"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Accordion: () => import_react92.Accordion,
  AccordionItem: () => AccordionItem,
  Alert: () => Alert,
  AlertDialog: () => import_react92.AlertDialog,
  AlertIcon: () => AlertIcon,
  AlertOctagonIcon: () => AlertOctagonIcon,
  Avatar: () => import_react92.Avatar,
  BUTTON_VARIANTS: () => BUTTON_VARIANTS,
  Badge: () => Badge,
  BankIcon: () => BankIcon,
  Box: () => import_react92.Box,
  Breadcrumb: () => Breadcrumb_default,
  BuildingIcon: () => BuildingIcon,
  Button: () => import_react92.Button,
  ButtonGroup: () => ButtonGroup,
  Card: () => Card,
  CellProps: () => import_react_table.CellProps,
  Center: () => import_react92.Center,
  ChakraModal: () => import_react92.Modal,
  Checkbox: () => Checkbox,
  CheckboxGroup: () => import_react92.CheckboxGroup,
  ChevronDownIcon: () => import_icons.ChevronDownIcon,
  CircularProgress: () => import_react92.CircularProgress,
  ClockUsedIcon: () => ClockUsedIcon,
  CloseButton: () => import_react92.CloseButton,
  Code: () => import_react92.Code,
  CoinsIcon: () => CoinsIcon,
  CoinsStackIcon: () => CoinsStackIcon,
  ContainedText: () => ContainedText_default,
  Container: () => import_react92.Container,
  ContextPhoneInput: () => ContextPhoneInput,
  Controller: () => import_react_hook_form9.Controller,
  ControllerRenderProps: () => import_react_hook_form9.ControllerRenderProps,
  CornIcon: () => CornIcon,
  CornToken: () => CornToken,
  CrossOutlineIcon: () => CrossOutlineIcon,
  DateCalendar: () => DateCalendar,
  DatePickerField: () => DatePickerField,
  Divider: () => Divider3,
  DollarSignIcon: () => DollarSignIcon,
  Drawer: () => import_react92.Drawer,
  Dropdown: () => Dropdown,
  DropdownField: () => DropdownField,
  DropzoneField: () => DropzoneField,
  DropzoneReadonly: () => DropzoneReadonly_default,
  Editable: () => import_react92.Editable,
  EmailIcon: () => EmailIcon,
  EmptyState: () => EmptyState,
  ErrorPage: () => ErrorPage_default,
  FeaturedIcons: () => FeaturedIcons,
  FiAlertCircle: () => import_fi17.FiAlertCircle,
  FiAlertTriangle: () => import_fi17.FiAlertTriangle,
  FiCalendar: () => import_fi17.FiCalendar,
  FiCheckCircle: () => import_fi17.FiCheckCircle,
  FiDownload: () => import_fi17.FiDownload,
  FiEdit: () => import_fi17.FiEdit,
  FiExternalLink: () => import_fi17.FiExternalLink,
  FiEye: () => import_fi17.FiEye,
  FiEyeOff: () => import_fi17.FiEyeOff,
  FiFigma: () => import_fi17.FiFigma,
  FiFile: () => import_fi17.FiFile,
  FiFileMinus: () => import_fi17.FiFileMinus,
  FiFileText: () => import_fi17.FiFileText,
  FiLogIn: () => import_fi17.FiLogIn,
  FiLogOut: () => import_fi17.FiLogOut,
  FiMail: () => import_fi17.FiMail,
  FiMinusCircle: () => import_fi17.FiMinusCircle,
  FiPlus: () => import_fi17.FiPlus,
  FiPlusCircle: () => import_fi17.FiPlusCircle,
  FiRefreshCcw: () => import_fi17.FiRefreshCcw,
  FiRefreshCw: () => import_fi17.FiRefreshCw,
  FiRepeat: () => import_fi17.FiRepeat,
  FiSave: () => import_fi17.FiSave,
  FiSearch: () => import_fi17.FiSearch,
  FiSend: () => import_fi17.FiSend,
  FiSlash: () => import_fi17.FiSlash,
  FiTool: () => import_fi17.FiTool,
  FiTrash2: () => import_fi17.FiTrash2,
  FiUserCheck: () => import_fi17.FiUserCheck,
  FiUserX: () => import_fi17.FiUserX,
  FiUsers: () => import_fi17.FiUsers,
  FiXOctagon: () => import_fi17.FiXOctagon,
  FieldArrayWithId: () => import_react_hook_form9.FieldArrayWithId,
  FieldError: () => import_react_hook_form9.FieldError,
  FieldValues: () => import_react_hook_form9.FieldValues,
  FileAttachmentErrorIcon: () => FileAttachmentErrorIcon,
  FileAttachmentIcon: () => FileAttachmentIcon,
  FileCheckIcon: () => FileCheckIcon,
  FileUpload: () => FileUpload,
  Flex: () => import_react92.Flex,
  FormControl: () => import_react92.FormControl,
  FormErrorMessage: () => FormErrorMessage,
  FormHelperText: () => FormHelperText,
  FormLabel: () => import_react92.FormLabel,
  FormProvider: () => import_react_hook_form9.FormProvider,
  FormState: () => import_react_hook_form9.FormState,
  Grid: () => import_react92.Grid,
  GridItem: () => import_react92.GridItem,
  Heading: () => import_react92.Heading,
  Highlight: () => import_react92.Highlight,
  HintIcon: () => HintIcon,
  Icon: () => import_react92.Icon,
  IconButton: () => import_react92.IconButton,
  Image: () => import_react92.Image,
  Kbd: () => import_react92.Kbd,
  Link: () => import_react92.Link,
  LinkOverlay: () => import_react92.LinkOverlay,
  List: () => import_react92.List,
  ListIcon: () => import_react92.ListIcon,
  ListItem: () => import_react92.ListItem,
  Menu: () => import_react92.Menu,
  MenuButton: () => import_react92.MenuButton,
  MenuDivider: () => import_react92.MenuDivider,
  MenuGroup: () => import_react92.MenuGroup,
  MenuItem: () => import_react92.MenuItem,
  MenuList: () => import_react92.MenuList,
  MenuOptionGroup: () => import_react92.MenuOptionGroup,
  Modal: () => Modal,
  ModalBody: () => import_react92.ModalBody,
  ModalCloseButton: () => import_react92.ModalCloseButton,
  ModalContent: () => import_react92.ModalContent,
  ModalFooter: () => import_react92.ModalFooter,
  ModalHeader: () => import_react92.ModalHeader,
  ModalOverlay: () => import_react92.ModalOverlay,
  Navigation: () => Navigation_default,
  NumberInput: () => import_react92.NumberInput,
  NumericFormatField: () => NumericFormatField,
  NumericReadOnlyField: () => NumericReadOnlyField,
  OrderedList: () => import_react92.OrderedList,
  PendingClockIcon: () => PendingClockIcon,
  PinInput: () => import_react92.PinInput,
  Popover: () => import_react92.Popover,
  Portal: () => import_react92.Portal,
  Progress: () => import_react92.Progress,
  Radio: () => import_react92.Radio,
  RadioButton: () => RadioButton,
  RadioGroup: () => import_react92.RadioGroup,
  RangeSlider: () => import_react92.RangeSlider,
  ReadOnlyField: () => ReadOnlyField,
  ReadOnlyTextarea: () => ReadOnlyTextarea,
  RightAlignCell: () => RightAlignCell,
  SIZES: () => SIZES,
  SeedIcon: () => SeedIcon,
  Select: () => import_react92.Select,
  SelectField: () => SelectField,
  SimpleGrid: () => import_react92.SimpleGrid,
  Skeleton: () => import_react92.Skeleton,
  Slider: () => import_react92.Slider,
  SoyIcon: () => SoyIcon,
  SoyToken: () => SoyToken,
  SpeedometerIcon: () => SpeedometerIcon,
  Spinner: () => import_react92.Spinner,
  Stack: () => import_react92.Stack,
  Stat: () => import_react92.Stat,
  Stepper: () => Stepper_default,
  Switch: () => import_react92.Switch,
  SwitchIcon: () => SwitchIcon,
  Tab: () => Tab,
  TabList: () => import_react92.TabList,
  TabPanel: () => import_react92.TabPanel,
  TabPanels: () => import_react92.TabPanels,
  Table: () => Table2,
  TableInstance: () => import_react_table.TableInstance,
  TableWrapper: () => TableWrapper,
  Tabs: () => import_react92.Tabs,
  Tag: () => import_react92.Tag,
  Text: () => import_react92.Text,
  TextField: () => TextField,
  TextareaField: () => TextareaField,
  ThemeProvider: () => ThemeProvider_default,
  Toast: () => Toast_default,
  Tooltip: () => import_react92.Tooltip,
  TwoLinesCell: () => TwoLinesCell,
  UnorderedList: () => import_react92.UnorderedList,
  UseFormHandleSubmit: () => import_react_hook_form9.UseFormHandleSubmit,
  UseFormRegister: () => import_react_hook_form9.UseFormRegister,
  UseFormReturn: () => import_react_hook_form9.UseFormReturn,
  UseFormSetValue: () => import_react_hook_form9.UseFormSetValue,
  VerificationCode: () => VerificationCode,
  VisuallyHidden: () => import_react92.VisuallyHidden,
  WheatIcon: () => WheatIcon,
  WheatToken: () => WheatToken,
  Wrap: () => import_react92.Wrap,
  getBase64FromFile: () => getBase64FromFile,
  theme: () => theme2,
  useBreakpointValue: () => import_react91.useBreakpointValue,
  useDebounce: () => useDebounce,
  useDisclosure: () => import_react92.useDisclosure,
  useFieldArray: () => import_react_hook_form9.useFieldArray,
  useForm: () => import_react_hook_form9.useForm,
  useFormContext: () => import_react_hook_form9.useFormContext,
  usePagination: () => import_react_table.usePagination,
  useTable: () => import_react_table.useTable,
  useTheme: () => import_react92.useTheme,
  useToast: () => useToast
});
module.exports = __toCommonJS(src_exports);

// src/components/AccordionItem.tsx
var import_react = require("@chakra-ui/react");
var import_jsx_runtime = require("react/jsx-runtime");
var AccordionItem = ({
  Badge: Badge3,
  HeadButton,
  title,
  children,
  showActions,
  RightActionButton,
  LeftActionButton
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react.AccordionItem,
    {
      borderRadius: "md",
      borderColor: "gray.200",
      borderWidth: "1px",
      _notLast: { mb: 2 },
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("h2", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
          import_react.AccordionButton,
          {
            p: "4",
            _focus: { boxShadow: "none" },
            _hover: { backgroundColor: "transparent" },
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
                import_react.Flex,
                {
                  as: "span",
                  flex: "1",
                  textAlign: "left",
                  alignItems: "center",
                  justifyContent: "space-between",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react.Flex, { gap: "2", alignItems: "center", children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Text, { variant: "medium", children: title }),
                      Badge3 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Badge3, { size: "sm" }) : null
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                      import_react.Box,
                      {
                        onClick: (e) => {
                          e.stopPropagation();
                        },
                        children: HeadButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(HeadButton, { variant: "link", mr: "4" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.AccordionIcon, { color: "gray.700" })
            ]
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react.AccordionPanel, { pt: 0, pb: 4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Divider, { color: "gray.200", mb: 4 }),
          children,
          showActions && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Divider, { color: "gray.200", my: 4 }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react.Flex, { gap: "4", justifyContent: "end", children: [
              LeftActionButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LeftActionButton, {}),
              RightActionButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RightActionButton, {})
            ] })
          ] })
        ] })
      ] })
    }
  );
};

// src/components/Badge.tsx
var import_react3 = require("@chakra-ui/react");
var import_react4 = require("react");
var import_fi = require("react-icons/fi");

// src/components/ContainedText.tsx
var import_react2 = require("@chakra-ui/react");
var import_jsx_runtime2 = require("react/jsx-runtime");
var ContainedText = (props) => {
  const _a2 = props, { variant, size = "sm", children } = _a2, rest = __objRest(_a2, ["variant", "size", "children"]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_react2.Text, __spreadProps(__spreadValues({ fontSize: size, variant }, rest), { lineHeight: 0, children }));
};
var ContainedText_default = ContainedText;

// src/components/Badge.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var mapColorSchemeToTextColor = {
  ["gray"]: "gray.700",
  ["error"]: "error.700",
  ["warning"]: "warning.800",
  ["success"]: "success.800",
  ["blue-light"]: "blue-light.700",
  ["blue"]: "blue.700",
  ["indigo"]: "indigo.700",
  ["purple"]: "purple.700",
  ["pink"]: "pink.700",
  ["rose"]: "rose.700",
  ["orange"]: "orange.700",
  ["blue-gray"]: "blue-gray.700"
};
var mapColorSchemeToBackgroundColor = {
  ["gray"]: "gray.100",
  ["error"]: "error.50",
  ["warning"]: "warning.50",
  ["success"]: "success.50",
  ["blue-light"]: "blue-light.50",
  ["blue"]: "blue.50",
  ["indigo"]: "indigo.50",
  ["purple"]: "purple.50",
  ["pink"]: "pink.50",
  ["rose"]: "rose.50",
  ["orange"]: "orange.50",
  ["blue-gray"]: "blue-gray.50"
};
var Badge = (_a2) => {
  var _b2 = _a2, {
    icon,
    size = "sm",
    colorScheme = "gray",
    children = "Label",
    type = "default",
    iconPosition
  } = _b2, otherProps = __objRest(_b2, [
    "icon",
    "size",
    "colorScheme",
    "children",
    "type",
    "iconPosition"
  ]);
  const [shouldShow, setShouldShow] = (0, import_react4.useState)(true);
  const isTypeClose = type === "close";
  const currentIcon = isTypeClose ? import_fi.FiX : icon;
  if (!shouldShow)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    import_react3.Badge,
    __spreadProps(__spreadValues({
      backgroundColor: mapColorSchemeToBackgroundColor[colorScheme],
      textTransform: "initial",
      paddingX: 2,
      height: { base: "20px", md: "24px" },
      boxShadow: "none",
      alignItems: "center",
      display: "flex",
      gap: "1",
      flexDirection: iconPosition === "leading" ? "row-reverse" : "row",
      justifyContent: "space-between",
      width: "min-content",
      borderRadius: "sm"
    }, otherProps), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          ContainedText_default,
          {
            size: size === "sm" ? "xs" : "sm",
            variant: "medium",
            color: mapColorSchemeToTextColor[colorScheme],
            children
          }
        ),
        currentIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          import_react3.Icon,
          {
            as: currentIcon,
            boxSize: "3",
            color: mapColorSchemeToTextColor[colorScheme],
            onClick: () => {
              if (isTypeClose)
                setShouldShow(false);
            },
            cursor: isTypeClose ? "pointer" : "default"
          }
        )
      ]
    })
  );
};

// src/components/ButtonGroup.tsx
var import_react5 = require("@chakra-ui/react");
var import_react6 = __toESM(require("react"));

// src/types/sizes.types.ts
var SIZES = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
  "2xl": "2xl",
  "3xl": "3xl",
  "4xl": "4xl"
};

// src/types/buttonVariants.ts
var BUTTON_VARIANTS = {
  primary: "primary",
  secondary: "secondary",
  destructive: "destructive",
  link: "link"
};

// src/components/ButtonGroup.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var ButtonGroup = ({
  size = "md",
  width,
  buttons,
  selectedId = -1
}) => {
  const [clickedId, setClickedId] = (0, import_react6.useState)(selectedId);
  const commonStyles = {
    height: size === "md" ? "31px" : "39px",
    borderRadius: "var(--chakra-radii-sm)"
  };
  const buttonClass = __spreadValues({}, commonStyles);
  const active = __spreadProps(__spreadValues({}, commonStyles), {
    backgroundColor: "white",
    boxShadow: "var(--chakra-shadows-xs)"
  });
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_react5.Box,
    {
      display: "inline-flex",
      border: "1px solid",
      borderColor: "var(--chakra-colors-gray-200)",
      padding: "4px",
      backgroundColor: "var(--chakra-colors-gray-100)",
      borderRadius: "md",
      gap: "4px",
      width: width ? width : "fit-content",
      height: size === "md" ? "40px" : "48px",
      children: buttons.map((button, index) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
        "div",
        {
          onClick: () => setClickedId(index),
          style: { flex: "1" },
          children: import_react6.default.cloneElement(button, {
            style: __spreadProps(__spreadValues({}, index === clickedId ? active : buttonClass), {
              border: "none",
              width: "100%"
            }),
            _focus: { boxShadow: "none" },
            _hover: {
              bg: "var(--chakra-colors-gray-50)"
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
              ContainedText_default,
              {
                variant: index === clickedId ? "medium" : "regular",
                size: SIZES.md,
                children: button.props.children
              }
            )
          })
        },
        index
      ))
    }
  );
};

// src/components/Card.tsx
var import_react7 = require("@chakra-ui/react");
var import_react8 = require("react");
var import_jsx_runtime5 = require("react/jsx-runtime");
var PADDINGS = {
  sm: "16px",
  md: "24px"
};
var BORDER_PROPS = {
  idle: "border-color-primary",
  active: "border-color-primary-selected"
};
var BACKGROUND_COLORS = {
  default: "background-primary-default",
  gray: "background-secondary-default",
  pressed: "background-primary-pressed"
};
var VARIANT_BACKGROUND_COLORS = {
  white: BACKGROUND_COLORS.default,
  gray: BACKGROUND_COLORS.gray
};
var BACKGROUND_COLOR_HOVERS = {
  white: "background-primary-hover",
  gray: "background-secondary-hover"
};
var Card = (props) => {
  const _a2 = props, {
    padding: paddingProp = SIZES.sm,
    variant = "white",
    selected = false,
    children,
    onClick,
    size = SIZES.md
  } = _a2, otherProps = __objRest(_a2, [
    "padding",
    "variant",
    "selected",
    "children",
    "onClick",
    "size"
  ]);
  const clickable = typeof onClick === "function";
  const [isSelected, setIsSelected] = (0, import_react8.useState)(false);
  const bgHover = clickable && !isSelected ? BACKGROUND_COLOR_HOVERS[variant] : void 0;
  const borderProps = isSelected ? BORDER_PROPS.active : BORDER_PROPS.idle;
  const backgroundProps = isSelected ? BACKGROUND_COLORS.pressed : VARIANT_BACKGROUND_COLORS[variant];
  (0, import_react8.useEffect)(() => {
    if (clickable)
      setIsSelected(selected);
  }, [selected]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    import_react7.Flex,
    __spreadProps(__spreadValues({
      p: PADDINGS[paddingProp],
      backgroundColor: backgroundProps,
      flexDirection: "column",
      cursor: clickable ? "pointer" : "default",
      onClick: () => {
        if (clickable) {
          setIsSelected((prev) => !prev);
          return onClick();
        }
      },
      _hover: { bg: bgHover },
      borderWidth: "1px",
      borderRadius: size === "md" ? "md" : "lg",
      borderColor: borderProps
    }, otherProps), {
      children
    })
  );
};

// src/components/DropdownField.tsx
var import_react31 = require("@chakra-ui/react");
var import_react_hook_form = require("react-hook-form");

// src/components/Dropdown/index.tsx
var import_react10 = require("@chakra-ui/react");

// src/components/svg/consts.ts
var mapSizeToValue = {
  sm: "16",
  md: "20",
  lg: "20"
};
var mapTokenSizeToValue = {
  xs: "16",
  sm: "24",
  md: "32",
  lg: "40",
  xl: "48"
};

// src/components/svg/ChevronUp.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var ChevronUp = ({ size = "md", color = "#667085" }) => {
  const sizeInPx = mapSizeToValue[size || "md"];
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: `0 0 16 16`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
        "path",
        {
          d: "M12 10L8 6L4 10",
          stroke: color,
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};

// src/components/svg/ChevronDown.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var ChevronDown = ({ size, color = "#667085" }) => {
  const sizeInPx = mapSizeToValue[size || "md"];
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
        "path",
        {
          d: "M4 6L8 10L12 6",
          stroke: color,
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};

// src/components/Dropdown/useInputStyles.ts
var import_react9 = require("@chakra-ui/react");

// src/components/Dropdown/sizes.ts
var menuSizes = {
  sm: {
    item: {
      fontSize: "14px",
      px: "10px",
      py: "6px"
    },
    button: {
      fontSize: "14px",
      px: "10px",
      py: "6px",
      h: "32px"
    }
  },
  md: {
    item: {
      fontSize: "16px",
      px: "12px",
      py: "8px"
    },
    button: {
      fontSize: "16px",
      px: "12px",
      py: "8px",
      h: "40px"
    }
  },
  lg: {
    item: {
      fontSize: "16px",
      px: "16px",
      py: "12px"
    },
    button: {
      fontSize: "16px",
      px: "16px",
      py: "12px",
      h: "48px"
    }
  }
};

// src/components/Dropdown/useInputStyles.ts
var useInputStyles = ({
  isDisabled,
  isInvalidFromProps,
  size
}) => {
  var _a2, _b2, _c;
  const inputStyles = (0, import_react9.useStyleConfig)("Input", { size });
  const invalidStyles = __spreadValues({}, inputStyles.field._invalid);
  const { isInvalid } = (0, import_react9.useFormControlContext)() || {
    isInvalid: isInvalidFromProps
  };
  const styles = menuSizes[size];
  const menuButtonStyles = __spreadValues(__spreadValues(__spreadValues({
    menuItems: styles.item
  }, styles.button), isInvalid ? invalidStyles : {}), isDisabled ? __spreadProps(__spreadValues({}, inputStyles.field._disabled), {
    ring: 0,
    boxShadow: "none !important"
  }) : {
    _focusVisible: isInvalid ? { ring: 2 } : __spreadValues({}, (_a2 = inputStyles == null ? void 0 : inputStyles.field) == null ? void 0 : _a2._focusVisible),
    _focus: isInvalid ? { ring: 2 } : (_b2 = inputStyles == null ? void 0 : inputStyles.field) == null ? void 0 : _b2._focusVisible,
    _active: isInvalid ? { ring: 2 } : (_c = inputStyles == null ? void 0 : inputStyles.field) == null ? void 0 : _c._focusVisible,
    _hover: {}
  });
  return menuButtonStyles;
};

// src/components/svg/Check.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Check = ({ size }) => {
  const sizeInPx = mapSizeToValue[size || "md"];
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
        "path",
        {
          d: "M13.3334 4L6.00008 11.3333L2.66675 8",
          stroke: "#288703",
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};

// src/components/Dropdown/index.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var Dropdown = ({
  options,
  onChange,
  value = "",
  size = "md",
  placeholder = "",
  isInvalid: isInvalidFromProps = false,
  isDisabled = false,
  leftIcon
}) => {
  var _b2;
  const { isInvalid } = (0, import_react10.useFormControlContext)() || {
    isInvalid: isInvalidFromProps
  };
  const notValue = !value;
  const _a2 = useInputStyles({
    size,
    isInvalidFromProps,
    isDisabled
  }), { menuItems } = _a2, menuButtonStyles = __objRest(_a2, ["menuItems"]);
  const menuButtonProps = isDisabled ? { onClick: (ev) => ev.preventDefault() } : {};
  const selectedValueLabel = (_b2 = options.find(
    (option) => option.value === value
  )) == null ? void 0 : _b2.label;
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_react10.Flex, { w: "full", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_react10.Menu, { closeOnSelect: true, size, children: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      import_react10.MenuButton,
      __spreadProps(__spreadValues({
        role: "combobox",
        textAlign: "left",
        w: "full",
        sx: menuButtonStyles,
        isActive: isOpen,
        as: import_react10.Button,
        fontFamily: "Larsseit",
        fontWeight: "normal",
        color: notValue ? "gray.500" : "gray.900",
        rightIcon: isOpen ? /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(ChevronUp, { size }) : /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(ChevronDown, { size }),
        leftIcon
      }, menuButtonProps), {
        children: selectedValueLabel || placeholder
      })
    ),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_react10.MenuList, { mt: "0", rootProps: { w: "full" }, borderRadius: "md", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      import_react10.MenuOptionGroup,
      {
        type: "checkbox",
        value,
        onChange: (selected) => onChange(Array.isArray(selected) ? selected[0] : selected),
        children: options.map((option, index) => {
          const isSelected = option.value === value;
          return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            import_react10.MenuItem,
            {
              onClick: () => onChange(option.value),
              "aria-label": option.label,
              sx: menuItems,
              children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_react10.HStack, { justify: "space-between", children: [
                /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_react10.HStack, { spacing: 2, children: [
                  leftIcon,
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: option.label })
                ] }),
                isSelected && /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(Check, {})
              ] })
            },
            index
          );
        })
      }
    ) })
  ] }) }) });
};

// src/components/FormErrorMessage.tsx
var import_react11 = require("@chakra-ui/react");

// src/theme/colorTokens.ts
var colorTokens = {
  // BACKGROUND
  "background-brand-default": "var(--chakra-colors-primary-300)",
  "background-brand-hover": "var(--chakra-colors-primary-200)",
  "background-brand-pressed": "var(--chakra-colors-primary-400)",
  "background-destructive-default": "var(--chakra-colors-error-25)",
  "background-destructive-bold-default": "var(--chakra-colors-error-700)",
  "background-destructive-bold-hover": "var(--chakra-colors-error-600)",
  "background-destructive-bold-pressed": "var(--chakra-colors-error-800)",
  "background-primary-default": "var(--chakra-colors-white)",
  "background-primary-hover": "var(--chakra-colors-gray-50)",
  "background-primary-pressed": "var(--chakra-colors-gray-100)",
  "background-secondary-default": "var(--chakra-colors-gray-50)",
  "background-success-default": "var(--chakra-colors-success-25)",
  "background-tertiary-default": "var(--chakra-colors-gray-100)",
  "background-tertiary-hover": "var(--chakra-colors-gray-200)",
  "background-tertiary-pressed": "var(--chakra-colors-gray-300)",
  "background-warning-default": "var(--chakra-colors-warning-25)",
  "background-gray-default": "var(--chakra-colors-primary-900)",
  "background-gray-hover": "var(--chakra-colors-primary-800)",
  "background-gray-pressed": "var(--chakra-colors-primary-700)",
  "background-disabled": "var(--chakra-colors-primary-50)",
  // BORDER
  "border-color-destructive": "var(--chakra-colors-error-700)",
  "border-color-focus": "var(--chakra-colors-primary-900)",
  "border-color-secondary": "var(--chakra-colors-gray-300)",
  "border-color-secondary-hover": "var(--chakra-colors-primary-400)",
  "border-color-success": "var(--chakra-colors-success-800)",
  "border-color-warning": "var(--chakra-colors-warning-800)",
  "border-color-primary": "var(--chakra-colors-gray-200)",
  "border-color-primary-hover": "var(--chakra-color-primary-300)",
  "border-color-primary-selected": "var(--chakra-colors-gray-400)",
  "border-color-disabled": "var(--chakra-colors-primary-200)",
  "border-color-brand": "var(--chakra-colors-brand-400)",
  // CONTENT
  "content-destructive": "var(--chakra-colors-error-700)",
  "content-primary": "var(--chakra-colors-gray-900)",
  "content-secondary": "var(--chakra-colors-gray-700)",
  "content-success": "var(--chakra-colors-success-800)",
  "content-tertiary": "var(--chakra-colors-gray-500)",
  "content-accent": "var(--chakra-colors-success-600)",
  "content-invert": "var(--chakra-colors-white)",
  "content-warning": "var(--chakra-colors-warning-800)",
  "content-disabled": "var(--chakra-colors-primary-400)",
  // LINK
  "link-brand-default": "var(--chakra-colors-primary-700)",
  "link-brand-hover": "var(--chakra-colors-primary-800)",
  "link-brand-pressed": "var(--chakra-colors-primary-900)",
  "link-destructive-default": "var(--chakra-colors-error-700)",
  "link-destructive-hover": "var(--chakra-colors-error-600)",
  "link-destructive-pressed": "var(--chakra-colors-error-800)",
  "link-primary-default": "var(--chakra-colors-primary-900)",
  "link-primary-hover": "var(--chakra-colors-primary-800)",
  "link-primary-pressed": "var(--chakra-colors-primary-700)",
  "link-secondary-default": "var(--chakra-colors-primary-500)",
  "link-secondary-hover": "var(--chakra-colors-primary-600)",
  "link-secondary-pressed": "var(--chakra-colors-primary-700)"
};

// src/components/svg/Icons/AlertIcon.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var AlertIcon = ({
  color = colorTokens["content-destructive"]
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("g", { clipPath: "url(#clip0_11266_2644)", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
          "path",
          {
            d: "M7.99992 5.33325V7.99992M7.99992 10.6666H8.00659M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z",
            stroke: color,
            strokeWidth: "1.33333",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("clipPath", { id: "clip0_11266_2644", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
};

// src/components/FormErrorMessage.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var FormErrorMessage = (_a2) => {
  var _b2 = _a2, {
    children
  } = _b2, rest = __objRest(_b2, [
    "children"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_react11.FormErrorMessage, __spreadProps(__spreadValues({}, rest), { children: /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_react11.Flex, { columnGap: "1", children: [
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_react11.Flex, { alignItems: "top", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(AlertIcon, {}) }),
    children
  ] }) }));
};

// src/components/DropdownField.tsx
var import_lodash = __toESM(require("lodash.get"));

// src/components/ReadOnlyField.tsx
var import_react30 = require("@chakra-ui/react");

// src/components/FormHelperText.tsx
var import_react29 = require("@chakra-ui/react");

// src/components/svg/Icons/CornIcon.tsx
var import_react12 = require("@chakra-ui/react");
var import_jsx_runtime12 = require("react/jsx-runtime");
var CornIcon = (0, import_react12.createIcon)({
  displayName: "CornIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
        "path",
        {
          d: "M6.96073 10.8883C6.92511 11.301 7.23078 11.6644 7.64345 11.7C8.05613 11.7356 8.41955 11.4299 8.45517 11.0173L6.96073 10.8883ZM8.91231 3.96394L8.1842 3.78403L8.91231 3.96394ZM14.0506 3.96574L14.7784 3.78467V3.78467L14.0506 3.96574ZM14.5859 11.5206C14.6189 11.9335 14.9804 12.2415 15.3933 12.2085C15.8062 12.1755 16.1141 11.814 16.0811 11.4011L14.5859 11.5206ZM6.00001 9.64802L6.53034 9.11769C6.31585 8.9032 5.99327 8.83903 5.71301 8.9551C5.43276 9.07118 5.25002 9.34464 5.25001 9.64798L6.00001 9.64802ZM17.2945 9.64802L18.0445 9.64797C18.0445 9.34461 17.8617 9.07114 17.5814 8.95508C17.3011 8.83902 16.9785 8.90322 16.7641 9.11776L17.2945 9.64802ZM11.9883 22L11.9882 22.75H11.9883L11.9883 22ZM12.2531 5.49425C11.8389 5.49425 11.5031 5.83003 11.5031 6.24425C11.5031 6.65846 11.8389 6.99425 12.2531 6.99425V5.49425ZM14.1596 6.99425C14.5738 6.99425 14.9096 6.65846 14.9096 6.24425C14.9096 5.83003 14.5738 5.49425 14.1596 5.49425V6.99425ZM12.2531 10.8086C11.8389 10.8086 11.5031 11.1444 11.5031 11.5586C11.5031 11.9728 11.8389 12.3086 12.2531 12.3086V10.8086ZM14.1596 12.3086C14.5738 12.3086 14.9096 11.9728 14.9096 11.5586C14.9096 11.1444 14.5738 10.8086 14.1596 10.8086V12.3086ZM8.0116 8.18762C7.59739 8.18762 7.2616 8.5234 7.2616 8.93762C7.2616 9.35183 7.59739 9.68762 8.0116 9.68762V8.18762ZM10.4151 9.68762C10.8293 9.68762 11.1651 9.35183 11.1651 8.93762C11.1651 8.5234 10.8293 8.18762 10.4151 8.18762V9.68762ZM8.45517 11.0173C8.6827 8.38121 9.22553 5.82287 9.64041 4.14385L8.1842 3.78403C7.75968 5.5021 7.19759 8.14407 6.96073 10.8883L8.45517 11.0173ZM13.3228 4.14681C13.767 5.93247 14.3613 8.7098 14.5859 11.5206L16.0811 11.4011C15.8473 8.4746 15.2321 5.60832 14.7784 3.78467L13.3228 4.14681ZM11.4797 2.75C12.3659 2.75 13.1182 3.32422 13.3228 4.14681L14.7784 3.78467C14.3983 2.25652 13.016 1.25 11.4797 1.25V2.75ZM11.4797 1.25C9.94487 1.25 8.56213 2.25457 8.1842 3.78403L9.64041 4.14385C9.84321 3.32311 10.5937 2.75 11.4797 2.75V1.25ZM11.3062 21.25C10.0838 21.25 9.26091 20.9897 8.6816 20.5653C8.10345 20.1417 7.67915 19.4897 7.37848 18.5333C7.07503 17.568 6.91333 16.3424 6.83159 14.8383C6.75006 13.3381 6.7499 11.6102 6.75001 9.64806L5.25001 9.64798C5.2499 11.5981 5.2496 13.3704 5.3338 14.9197C5.41779 16.4652 5.5877 17.8385 5.94753 18.9831C6.31014 20.1366 6.88081 21.1054 7.79512 21.7753C8.70827 22.4443 9.87535 22.75 11.3062 22.75L11.3062 21.25ZM5.46968 10.1784C7.88387 12.5926 9.42426 15.2224 10.9946 17.6057L12.2472 16.7804C10.7274 14.4738 9.08206 11.6694 6.53034 9.11769L5.46968 10.1784ZM16.7641 9.11776C14.0531 11.8295 11.9325 14.9957 10.859 17.5204C10.3302 18.7639 10.0144 19.9455 10.0828 20.8712C10.1176 21.3439 10.2589 21.8287 10.6076 22.2001C10.9712 22.5873 11.4639 22.7499 11.9882 22.75L11.9884 21.25C11.7775 21.25 11.7189 21.1923 11.7012 21.1734C11.6686 21.1388 11.5987 21.0316 11.5787 20.7608C11.5373 20.1997 11.7371 19.2884 12.2393 18.1073C13.2278 15.7828 15.2306 12.7732 17.8249 10.1783L16.7641 9.11776ZM11.9883 22.75C13.4191 22.75 14.5862 22.4443 15.4994 21.7753C16.4137 21.1054 16.9844 20.1366 17.347 18.9831C17.7068 17.8385 17.8767 16.4652 17.9607 14.9197C18.0449 13.3704 18.0446 11.5981 18.0445 9.64797L16.5445 9.64806C16.5446 11.6102 16.5444 13.3381 16.4629 14.8383C16.3812 16.3424 16.2195 17.568 15.916 18.5333C15.6154 19.4897 15.1911 20.1417 14.6129 20.5653C14.0336 20.9897 13.2107 21.25 11.9883 21.25L11.9883 22.75ZM12.2531 6.99425H14.1596V5.49425H12.2531V6.99425ZM12.2531 12.3086H14.1596V10.8086H12.2531V12.3086ZM8.0116 9.68762H10.4151V8.18762H8.0116V9.68762Z",
          fill: "currentColor"
        }
      )
    }
  )
});

// src/components/svg/Icons/FileAttachmentIcon.tsx
var import_react13 = require("@chakra-ui/react");
var import_jsx_runtime13 = require("react/jsx-runtime");
var FileAttachmentIcon = (0, import_react13.createIcon)({
  displayName: "FileAttachmentIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "path",
        {
          d: "M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M12.5 11H8M11.5 15H8M16 7H8M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/SeedIcon.tsx
var import_react14 = require("@chakra-ui/react");
var import_jsx_runtime14 = require("react/jsx-runtime");
var SeedIcon = (0, import_react14.createIcon)({
  displayName: "SeedIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("g", { clipPath: "url(#clip0_11905_215882)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M17.0783 5.08948C15.8464 5.5083 15.0978 6.31637 14.8105 7.36365C14.5383 8.3563 14.7062 9.46804 15.0613 10.5117C15.4162 11.555 15.9607 12.5385 16.7814 13.1593C17.6473 13.8143 18.7331 13.9986 19.9648 13.5798C21.1965 13.1611 21.945 12.3532 22.2322 11.3062C22.5045 10.3138 22.3367 9.20226 21.9822 8.15874C21.6276 7.11499 21.0831 6.13124 20.2623 5.51022C19.3962 4.85501 18.3102 4.67067 17.0783 5.08948Z",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M6.64218 1.73927C5.40154 1.34706 4.31974 1.55473 3.468 2.22842C2.6607 2.86696 2.13756 3.8622 1.80547 4.91334C1.47345 5.96425 1.32964 7.07912 1.6232 8.06542C1.93294 9.10607 2.69865 9.8976 3.93907 10.2897C5.17949 10.6819 6.26104 10.4743 7.11268 9.80084C7.91985 9.16251 8.44302 8.16757 8.77542 7.11679C9.1079 6.06577 9.25191 4.95067 8.95836 3.96412C8.64865 2.92325 7.88281 2.13148 6.64218 1.73927Z",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M6.29291 15.7731C5.55557 16.8452 5.43834 17.9405 5.83399 18.9518C6.20899 19.9103 7.00812 20.7013 7.91651 21.3258C8.82468 21.9502 9.84898 22.4132 10.878 22.4204C11.9638 22.428 12.9444 21.9268 13.6816 20.8549C14.4188 19.783 14.5361 18.688 14.1406 17.6768C13.7657 16.7185 12.9669 15.9276 12.059 15.3029C11.1508 14.678 10.1263 14.2147 9.09707 14.2074C8.01114 14.1997 7.03026 14.701 6.29291 15.7731Z",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M19.8018 13.3436L18.4251 8.86555",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M3.92764 10.0621L5.49142 5.57927",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            "path",
            {
              d: "M13.444 20.7885L9.62898 17.9956",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("clipPath", { id: "clip0_11905_215882", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  )
});

// src/components/svg/Icons/SoyIcon.tsx
var import_react15 = require("@chakra-ui/react");
var import_jsx_runtime15 = require("react/jsx-runtime");
var SoyIcon = (0, import_react15.createIcon)({
  displayName: "SoyIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
        "path",
        {
          d: "M11.521 1.59613C7.42241 1.67645 3.43236 4.12265 5.90479 8.17522C3.42524 8.57095 2.66877 12.1793 4.88552 13.6282C2.33139 15.8361 2.42773 18.9017 5.45543 21.4934C6.26941 20.7804 10.9266 18.1951 8.14404 14.3238M11.7564 1.61709C9.04671 3.30241 7.71404 7.62447 11.745 9.48855C9.83364 12.5869 11.8523 15.2583 14.6339 15.5418C13.8545 18.978 15.1822 21.3156 20.3081 21.5961C20.5506 20.4931 22.7049 15.4285 17.3035 14.198C18.8765 12.3714 18.2316 8.72485 14.7358 8.41721C16.141 5.81137 15.4542 3.42598 11.7564 1.61709Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/SpeedometerIcon.tsx
var import_react16 = require("@chakra-ui/react");
var import_jsx_runtime16 = require("react/jsx-runtime");
var SpeedometerIcon = (0, import_react16.createIcon)({
  displayName: "SpeedometerIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        "path",
        {
          d: "M16.4999 7.5L11.9999 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/SwitchIcon.tsx
var import_react17 = require("@chakra-ui/react");
var import_jsx_runtime17 = require("react/jsx-runtime");
var SwitchIcon = (0, import_react17.createIcon)({
  displayName: "SwitchIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
        "path",
        {
          d: "M4 17H20M20 17L16 13M20 17L16 21M20 7H4M4 7L8 3M4 7L8 11",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/WheatIcon.tsx
var import_react18 = require("@chakra-ui/react");
var import_jsx_runtime18 = require("react/jsx-runtime");
var WheatIcon = (0, import_react18.createIcon)({
  displayName: "WheatIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        "path",
        {
          d: "M11.6158 14.6723C11.6158 14.6723 12.8905 11.5988 14.3633 10.7481C15.8363 9.89742 18.0432 10.9614 18.0432 10.9614C18.0432 10.9614 17.8612 13.4047 16.388 14.2549C14.9149 15.1051 11.6158 14.6723 11.6158 14.6723ZM11.6158 14.6723C11.6158 14.6723 10.3412 11.5988 8.86843 10.7481C7.39547 9.89742 5.18852 10.9614 5.18852 10.9614C5.18852 10.9614 5.37056 13.4047 6.84378 14.2549C8.31683 15.1051 11.6158 14.6723 11.6158 14.6723ZM11.617 2C11.617 2 9.59211 3.37929 9.59238 5.08027C9.59264 6.78104 11.617 9.42179 11.617 9.42179C11.617 9.42179 13.6414 6.78104 13.6417 5.08027C13.6419 3.37929 11.617 2 11.617 2ZM18.2334 18.179C18.2334 18.179 16.0265 17.115 14.5535 17.9657C13.0807 18.8163 11.806 21.8898 11.806 21.8898C11.806 21.8898 15.1051 22.3226 16.5782 21.4725C18.0514 20.6222 18.2334 18.179 18.2334 18.179ZM5 18.179C5 18.179 7.20696 17.115 8.67992 17.9657C10.1527 18.8163 11.4275 21.8898 11.4275 21.8898C11.4275 21.8898 8.12831 22.3226 6.65526 21.4725C5.18204 20.6222 5 18.179 5 18.179Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/CoinsIcon.tsx
var import_react19 = require("@chakra-ui/react");
var import_jsx_runtime19 = require("react/jsx-runtime");
var CoinsIcon = (0, import_react19.createIcon)({
  displayName: "CoinsIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
        "path",
        {
          d: "M8.42202 3.15802C11.2986 0.280104 15.964 0.281215 18.8417 3.15802C21.7194 6.03483 21.7194 10.7006 18.8417 13.5785M15.7374 13.6308C15.7374 17.7007 12.4383 21 8.36868 21C4.29907 21 1 17.7007 1 13.6308C1 9.56083 4.29907 6.26151 8.36868 6.26151C12.4383 6.26151 15.7374 9.56083 15.7374 13.6308Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/CoinsStackIcon.tsx
var import_react20 = require("@chakra-ui/react");
var import_jsx_runtime20 = require("react/jsx-runtime");
var CoinsStackIcon = (0, import_react20.createIcon)({
  displayName: "CoinsStackIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
        "path",
        {
          d: "M14.1755 4.22225C14.1766 2.99445 11.6731 2 8.58832 2C5.50357 2 3.00224 2.99557 3 4.22225M3 4.22225C3 5.45004 5.50133 6.44449 8.58832 6.44449C11.6753 6.44449 14.1766 5.45004 14.1766 4.22225L14.1766 12.8445M3 4.22225V17.5556C3.00112 18.7834 5.50245 19.7779 8.58832 19.7779C10.0849 19.7779 11.4361 19.5412 12.4387 19.1601M3.00112 8.66672C3.00112 9.89451 5.50245 10.889 8.58944 10.889C11.6764 10.889 14.1778 9.89451 14.1778 8.66672M12.5057 14.6946C11.4976 15.0891 10.115 15.3335 8.58832 15.3335C5.50245 15.3335 3.00112 14.3391 3.00112 13.1113M20.5272 13.4646C22.4909 15.4169 22.4909 18.5836 20.5272 20.5358C18.5635 22.4881 15.3781 22.4881 13.4144 20.5358C11.4507 18.5836 11.4507 15.4169 13.4144 13.4646C15.3781 11.5124 18.5635 11.5124 20.5272 13.4646Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/FileAttachmentErrorIcon.tsx
var import_react21 = require("@chakra-ui/react");
var import_jsx_runtime21 = require("react/jsx-runtime");
var FileAttachmentErrorIcon = (0, import_react21.createIcon)({
  displayName: "FileAttachmentErrorIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
        "path",
        {
          d: "M14 11H8M10 15H8M16 7H8M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21",
          stroke: "#C72100",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/PendingClockIcon.tsx
var import_react22 = require("@chakra-ui/react");
var import_jsx_runtime22 = require("react/jsx-runtime");
var PendingClockIcon = (0, import_react22.createIcon)({
  displayName: "PendingClockIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.3059 2.93863C11.3747 3.34709 11.0994 3.73401 10.691 3.80286C6.54833 4.50111 3.59225 8.20126 3.82596 12.3958C4.05968 16.5904 7.40852 19.9392 11.6031 20.173C15.7977 20.4067 19.4978 17.4506 20.1961 13.308C20.2649 12.8995 20.6518 12.6242 21.0603 12.693C21.4687 12.7619 21.744 13.1488 21.6752 13.5573C20.85 18.4532 16.477 21.9469 11.5196 21.6706C6.56231 21.3944 2.6045 17.4366 2.32829 12.4793C2.05207 7.52195 5.5457 3.14895 10.4417 2.32372C10.8501 2.25488 11.237 2.53018 11.3059 2.93863Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.2378 8.09479C20.626 7.9503 21.0579 8.14786 21.2023 8.53606C21.4161 9.11041 21.5748 9.70379 21.6763 10.3082C21.7449 10.7167 21.4693 11.1034 21.0608 11.172C20.6523 11.2406 20.2656 10.965 20.197 10.5565C20.1113 10.0459 19.9772 9.54456 19.7966 9.0593C19.6521 8.67111 19.8496 8.23928 20.2378 8.09479Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.2271 4.51747C17.4909 4.19811 17.9636 4.15306 18.283 4.41685C18.7566 4.80804 19.1919 5.24337 19.5831 5.71697C19.8469 6.03632 19.8018 6.50906 19.4825 6.77284C19.1631 7.03663 18.6904 6.99158 18.4266 6.67222C18.0959 6.27193 17.728 5.90398 17.3277 5.57334C17.0083 5.30956 16.9633 4.83682 17.2271 4.51747Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.828 2.93886C12.8967 2.53039 13.2835 2.25496 13.692 2.32368C14.2966 2.42539 14.8901 2.58448 15.4644 2.79879C15.8525 2.94359 16.0497 3.37557 15.9049 3.76365C15.7601 4.15173 15.3281 4.34895 14.9401 4.20415C14.455 4.02316 13.9537 3.8888 13.4431 3.8029C13.0347 3.73418 12.7592 3.34733 12.828 2.93886Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.6088 6.24793C12.023 6.24793 12.3588 6.58372 12.3588 6.99793V11.6412H16.0016C16.4158 11.6412 16.7516 11.977 16.7516 12.3912C16.7516 12.8054 16.4158 13.1412 16.0016 13.1412H11.6088C11.1945 13.1412 10.8588 12.8054 10.8588 12.3912V6.99793C10.8588 6.58372 11.1945 6.24793 11.6088 6.24793Z",
            fill: "currentColor"
          }
        )
      ]
    }
  )
});

// src/components/svg/Icons/CrossOutlineIcon.tsx
var import_react23 = require("@chakra-ui/react");
var import_jsx_runtime23 = require("react/jsx-runtime");
var CrossOutlineIcon = (0, import_react23.createIcon)({
  displayName: "CrossOutlineIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
        "path",
        {
          d: "M8.66735 15.3333L15.334 8.66667M15.334 15.3333L8.66735 8.66667M6.90444 21.3489L2.65111 17.0956C2.23444 16.6789 2 16.1133 2 15.5244V8.47556C2 7.88667 2.23444 7.32111 2.65111 6.90444L6.90444 2.65111C7.32111 2.23444 7.88667 2 8.47556 2H15.5233C16.1122 2 16.6778 2.23444 17.0944 2.65111L21.3478 6.90444C21.7656 7.32111 22 7.88667 22 8.47556V15.5233C22 16.1122 21.7656 16.6778 21.3489 17.0944L16.4444 22H8.47556C7.88667 22 7.32111 21.7656 6.90444 21.3489Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/BuildingIcon.tsx
var import_react24 = require("@chakra-ui/react");
var import_jsx_runtime24 = require("react/jsx-runtime");
var BuildingIcon = (0, import_react24.createIcon)({
  displayName: "BuildingIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        "path",
        {
          d: "M8.66683 7.33333H11.8668C12.6136 7.33333 12.9869 7.33333 13.2722 7.47866C13.523 7.60649 13.727 7.81046 13.8548 8.06135C14.0002 8.34656 14.0002 8.71993 14.0002 9.46667V14M8.66683 14V4.13333C8.66683 3.3866 8.66683 3.01323 8.52151 2.72801C8.39367 2.47713 8.1897 2.27316 7.93882 2.14532C7.6536 2 7.28023 2 6.5335 2H4.1335C3.38676 2 3.01339 2 2.72818 2.14532C2.47729 2.27316 2.27332 2.47713 2.14549 2.72801C2.00016 3.01323 2.00016 3.3866 2.00016 4.13333V14M14.6668 14H1.3335M4.3335 4.66667H6.3335M4.3335 7.33333H6.3335M4.3335 10H6.3335",
          stroke: "currentColor",
          strokeWidth: "1.33333",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/BankIcon.tsx
var import_react25 = require("@chakra-ui/react");
var import_jsx_runtime25 = require("react/jsx-runtime");
var BankIcon = (0, import_react25.createIcon)({
  displayName: "BankIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
        "path",
        {
          d: "M1.5 6.49969H3V10.4997H2C1.86739 10.4997 1.74021 10.5524 1.64645 10.6461C1.55268 10.7399 1.5 10.8671 1.5 10.9997C1.5 11.1323 1.55268 11.2595 1.64645 11.3532C1.74021 11.447 1.86739 11.4997 2 11.4997H14C14.1326 11.4997 14.2598 11.447 14.3536 11.3532C14.4473 11.2595 14.5 11.1323 14.5 10.9997C14.5 10.8671 14.4473 10.7399 14.3536 10.6461C14.2598 10.5524 14.1326 10.4997 14 10.4997H13V6.49969H14.5C14.6088 6.49958 14.7146 6.46399 14.8013 6.39832C14.888 6.33265 14.951 6.24049 14.9806 6.13581C15.0102 6.03112 15.0049 5.91964 14.9654 5.81826C14.9259 5.71689 14.8545 5.63115 14.7619 5.57406L8.26188 1.57406C8.18311 1.52564 8.09246 1.5 8 1.5C7.90754 1.5 7.81689 1.52564 7.73812 1.57406L1.23812 5.57406C1.14552 5.63115 1.07406 5.71689 1.03458 5.81826C0.995107 5.91964 0.989773 6.03112 1.01939 6.13581C1.04901 6.24049 1.11195 6.33265 1.19869 6.39832C1.28542 6.46399 1.39121 6.49958 1.5 6.49969ZM4 6.49969H6V10.4997H4V6.49969ZM9 6.49969V10.4997H7V6.49969H9ZM12 10.4997H10V6.49969H12V10.4997ZM8 2.58656L12.7338 5.49969H3.26625L8 2.58656ZM15.5 12.9997C15.5 13.1323 15.4473 13.2595 15.3536 13.3532C15.2598 13.447 15.1326 13.4997 15 13.4997H1C0.867392 13.4997 0.740215 13.447 0.646447 13.3532C0.552678 13.2595 0.5 13.1323 0.5 12.9997C0.5 12.8671 0.552678 12.7399 0.646447 12.6461C0.740215 12.5524 0.867392 12.4997 1 12.4997H15C15.1326 12.4997 15.2598 12.5524 15.3536 12.6461C15.4473 12.7399 15.5 12.8671 15.5 12.9997Z",
          fill: "currentColor"
        }
      )
    }
  )
});

// src/components/svg/Icons/ClockUsedIcon.tsx
var import_react26 = require("@chakra-ui/react");
var import_jsx_runtime26 = require("react/jsx-runtime");
var ClockUsedIcon = (0, import_react26.createIcon)({
  displayName: "BuildingIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
        "path",
        {
          d: "M13 20.938C12.6683 20.9791 12.3343 20.9998 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C20.9998 12.3343 20.9791 12.6683 20.938 13M20 17L17.5 19.5L16 18M12.5 7V12.5H8",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/svg/Icons/EmailIcon.tsx
var import_jsx_runtime27 = require("react/jsx-runtime");
var EmailIcon = ({ color = "#667085" }) => /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      "path",
      {
        d: "M18.3332 4.99998C18.3332 4.08331 17.5832 3.33331 16.6665 3.33331H3.33317C2.4165 3.33331 1.6665 4.08331 1.6665 4.99998M18.3332 4.99998V15C18.3332 15.9166 17.5832 16.6666 16.6665 16.6666H3.33317C2.4165 16.6666 1.6665 15.9166 1.6665 15V4.99998M18.3332 4.99998L9.99984 10.8333L1.6665 4.99998",
        stroke: color,
        strokeWidth: "1.66667",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);

// src/components/svg/Icons/HintIcon.tsx
var import_jsx_runtime28 = require("react/jsx-runtime");
var HintIcon = ({ color = "#98A2B3" }) => /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("g", { clipPath: "url(#clip0_11266_7818)", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
        "path",
        {
          d: "M6.05967 5.99998C6.21641 5.55442 6.52578 5.17872 6.93298 4.9394C7.34018 4.70009 7.81894 4.61261 8.28446 4.69245C8.74998 4.7723 9.17222 5.01433 9.47639 5.37567C9.78057 5.737 9.94705 6.19433 9.94634 6.66665C9.94634 7.99998 7.94634 8.66665 7.94634 8.66665M7.99967 11.3333H8.00634M14.6663 7.99998C14.6663 11.6819 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6819 1.33301 7.99998C1.33301 4.31808 4.31778 1.33331 7.99967 1.33331C11.6816 1.33331 14.6663 4.31808 14.6663 7.99998Z",
          stroke: color,
          strokeWidth: "1.33333",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("clipPath", { id: "clip0_11266_7818", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
);

// src/components/svg/Icons/FileCheckIcon.tsx
var import_react27 = require("@chakra-ui/react");
var import_jsx_runtime29 = require("react/jsx-runtime");
var FileCheckIcon = (0, import_react27.createIcon)({
  displayName: "FileCheckIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
    "path",
    {
      d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11986 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) })
});

// src/components/svg/Icons/AlertOctagonIcon.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
var AlertOctagonIcon = ({
  color = colorTokens["content-destructive"]
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        "path",
        {
          d: "M12 8V12M12 16H12.01M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z",
          stroke: color,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};

// src/components/svg/Icons/DollarSign.tsx
var import_react28 = require("@chakra-ui/react");
var import_jsx_runtime31 = require("react/jsx-runtime");
var DollarSignIcon = (0, import_react28.createIcon)({
  displayName: "DollarSignIcon",
  path: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        "path",
        {
          d: "M10 0.833008V19.1663M14.1667 4.16634H7.91667C7.14312 4.16634 6.40125 4.47363 5.85427 5.02061C5.30729 5.56759 5 6.30946 5 7.08301C5 7.85656 5.30729 8.59842 5.85427 9.1454C6.40125 9.69238 7.14312 9.99967 7.91667 9.99967H12.0833C12.8569 9.99967 13.5987 10.307 14.1457 10.8539C14.6927 11.4009 15 12.1428 15 12.9163C15 13.6899 14.6927 14.4318 14.1457 14.9787C13.5987 15.5257 12.8569 15.833 12.0833 15.833H5",
          stroke: "currentColor",
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  )
});

// src/components/FormHelperText.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
var FormHelperText = (_a2) => {
  var _b2 = _a2, {
    children
  } = _b2, rest = __objRest(_b2, [
    "children"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_react29.FormHelperText, __spreadProps(__spreadValues({}, rest), { color: "content-tertiary", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(import_react29.Flex, { columnGap: "1", alignItems: "start", children: [
    /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_react29.Flex, { alignItems: "top", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(AlertIcon, { color: "currentColor" }) }),
    children
  ] }) }));
};

// src/components/ReadOnlyField.tsx
var import_jsx_runtime33 = require("react/jsx-runtime");
var ReadOnlyField = ({ label, value, helperText }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)(import_react30.FormControl, { children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_react30.FormLabel, { children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
      import_react30.Input,
      {
        readOnly: true,
        value,
        isDisabled: true,
        color: "content-tertiary",
        borderX: "none",
        borderRadius: 0,
        _disabled: {
          cursor: "text !important",
          backgroundColor: "white",
          borderTopColor: "white",
          borderBottomColor: "border-color-secondary"
        }
      }
    ),
    helperText && /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(FormHelperText, { children: helperText })
  ] });
};

// src/components/DropdownField.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");
var DropdownField = (props) => {
  const {
    name,
    rhfOptions,
    label,
    isReadOnly = false,
    readOnlyValue = ""
  } = props;
  const { control } = (0, import_react_hook_form.useFormContext)();
  const formState = (0, import_react_hook_form.useFormState)();
  if (isReadOnly)
    return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(ReadOnlyField, { label, value: readOnlyValue });
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
    import_react_hook_form.Controller,
    {
      control,
      name,
      rules: rhfOptions,
      render: (controlProps) => /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
        ControlledDropdown,
        __spreadProps(__spreadValues(__spreadValues({}, controlProps), props), {
          formState
        })
      )
    }
  );
};
var ControlledDropdown = ({
  field,
  options = [],
  name,
  label,
  placeholder,
  helperText,
  leftIcon,
  rhfOptions,
  isDisabled,
  formState,
  errorMessageFormatter = (message) => message
}) => {
  const { errors } = formState;
  const fieldError = (0, import_lodash.default)(errors, name, null);
  const { onChange, value } = field;
  const showHelperText = Boolean(!fieldError && helperText);
  const isRequired = Boolean(rhfOptions == null ? void 0 : rhfOptions.required);
  const isInvalid = Boolean(fieldError);
  const errorMessage = errorMessageFormatter(
    (0, import_lodash.default)(fieldError, "message", "")
  );
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)(import_react31.FormControl, { isInvalid, isRequired, children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(import_react31.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
      Dropdown,
      {
        onChange,
        value,
        options,
        placeholder,
        leftIcon,
        isDisabled
      }
    ),
    showHelperText && /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(FormHelperText, { children: helperText }),
    /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(FormErrorMessage, { children: errorMessage })
  ] });
};

// src/components/TextField.tsx
var import_react32 = require("@chakra-ui/react");
var import_lodash2 = __toESM(require("lodash.get"));
var import_react_hook_form2 = require("react-hook-form");
var import_jsx_runtime35 = require("react/jsx-runtime");
var TextField = ({
  name,
  label,
  placeholder,
  helperText,
  rhfOptions = {},
  type = "text",
  leftElement,
  rightElement,
  size = "md",
  errorMessageFormatter = (message) => message,
  isReadOnly = false,
  readOnlyValue = ""
}) => {
  const formMethods = (0, import_react_hook_form2.useFormContext)();
  if (!formMethods) {
    throw new Error(
      `SelectField component Must be used within react-hook-form "FormProvider"`
    );
  }
  const { register } = formMethods;
  const { errors } = (0, import_react_hook_form2.useFormState)();
  const fieldError = (0, import_lodash2.default)(errors, name, null);
  const errorMessage = errorMessageFormatter(
    (0, import_lodash2.default)(fieldError, "message", "")
  );
  const isInvalid = Boolean(fieldError);
  const isValid = !isInvalid;
  const showHelperText = isValid && helperText;
  const isRequired = Boolean(rhfOptions.required);
  if (isReadOnly)
    return /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(ReadOnlyField, { label, value: readOnlyValue });
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)(import_react32.FormControl, { isInvalid, isRequired, children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(import_react32.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)(import_react32.InputGroup, { size, children: [
      leftElement ? /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(import_react32.InputLeftElement, { pointerEvents: "none", children: leftElement }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
        import_react32.Input,
        __spreadValues({
          size,
          type,
          id: name,
          placeholder,
          isReadOnly
        }, register(name, rhfOptions))
      ),
      rightElement ? /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(import_react32.InputRightElement, { pointerEvents: "none", children: rightElement }) : null
    ] }),
    showHelperText && /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(FormHelperText, { children: helperText }),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(FormErrorMessage, { children: errorMessage })
  ] });
};

// src/components/ContextPhoneInput.tsx
var import_react33 = require("@chakra-ui/react");
var import_react_hook_form3 = require("react-hook-form");
var import_react_phone_input_2 = __toESM(require("react-phone-input-2"));
var import_style = require("react-phone-input-2/lib/style.css");
var import_jsx_runtime36 = require("react/jsx-runtime");
var ChakraPhoneInput = (0, import_react33.chakra)(import_react_phone_input_2.default);
var ContextPhoneInput = ({
  name,
  defaultCounty,
  context,
  label,
  helperText,
  options = {},
  size,
  masks = { ar: "..........." },
  value,
  disabled
}) => {
  const inputStyles = (0, import_react33.useStyleConfig)("Input", { size });
  const { control, watch } = context;
  const isRequired = Boolean(options.required);
  const requiredErrorMessage = options.required || "";
  let isValidPhoneNumber = false;
  const validatePhoneNumber = (inputNumber, country) => {
    if (!isRequired) {
      isValidPhoneNumber = true;
      return;
    }
    const numberWithoutPrefix = inputNumber == null ? void 0 : inputNumber.slice(country.countryCode.length);
    if (!inputNumber || !(numberWithoutPrefix == null ? void 0 : numberWithoutPrefix.length)) {
      isValidPhoneNumber = false;
      return;
    }
    isValidPhoneNumber = true;
  };
  const defaultValue = watch(name);
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
    import_react_hook_form3.Controller,
    {
      control,
      name,
      rules: __spreadProps(__spreadValues({}, options), {
        validate: () => isValidPhoneNumber || requiredErrorMessage
      }),
      defaultValue: value || defaultValue,
      render: (_a2) => {
        var _b2 = _a2, { field: _c } = _b2, _d = _c, { ref } = _d, field = __objRest(_d, ["ref"]), { fieldState: { error } } = _b2;
        const invalidStyles = error ? inputStyles.field._invalid : {};
        const showHelperText = !error && helperText;
        return /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(import_react33.FormControl, { isInvalid: Boolean(error), isRequired, children: [
          label ? /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(import_react33.FormLabel, { htmlFor: name, children: label }) : null,
          /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
            ChakraPhoneInput,
            __spreadProps(__spreadValues({
              masks,
              w: "full"
            }, field), {
              sx: {
                [`& input#${name}`]: __spreadValues(__spreadProps(__spreadValues({}, inputStyles.field), {
                  pl: "3.5rem"
                }), invalidStyles),
                "& .country-list": {
                  mt: "2px"
                }
              },
              inputProps: {
                ref,
                id: name,
                defaultValue
              },
              country: defaultCounty ? defaultCounty.toLowerCase() : "",
              value: value || defaultValue,
              disabled,
              countryCodeEditable: false,
              isValid: (value2, country) => {
                validatePhoneNumber(value2, country);
                return true;
              }
            })
          ),
          showHelperText && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(FormHelperText, { children: helperText }),
          /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(import_react33.FormErrorMessage, { children: error == null ? void 0 : error.message })
        ] });
      }
    }
  );
};

// src/components/FeaturedIcons.tsx
var import_react34 = require("@chakra-ui/react");

// src/utils/index.ts
var BREAKPOINTS = {
  sm: 768,
  md: 1280,
  lg: 1440
};
function getBase64FromFile(file, options = { removeMetadata: false }) {
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = function() {
      const result = reader.result;
      if (typeof result === "string" && options.removeMetadata) {
        resolve(removeMetadataFromB64(result));
      } else {
        resolve(reader.result);
      }
    };
    reader.onerror = function(error) {
      reject(error);
    };
  });
}
var removeMetadataFromB64 = (b64) => {
  const [_metadata, fileData] = b64.split(",");
  return fileData;
};

// src/components/FeaturedIcons.tsx
var import_jsx_runtime37 = require("react/jsx-runtime");
var mapSizeToValue2 = {
  xs: "24px",
  sm: "32px",
  md: "40px",
  lg: "48px",
  xl: "56px"
};
var mapVariantToBackgroundColor = {
  success: "background-success-default",
  destructive: "background-destructive-default",
  warning: "background-warning-default",
  primary: "background-secondary-default",
  disabled: "background-disabled"
};
var mapVariantToIconColor = {
  success: "content-success",
  destructive: "content-destructive",
  warning: "content-warning",
  primary: "content-primary",
  disabled: "content-disabled"
};
var mapSizeToIconBoxSize = {
  xs: "12px",
  sm: "16px",
  md: "20px",
  lg: "24px",
  xl: "28px"
};
var FeaturedIcons = ({
  size = "lg",
  icon,
  shape = "circle",
  variant = "success"
}) => {
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
    import_react34.Flex,
    {
      width: mapSizeToValue2[size],
      height: mapSizeToValue2[size],
      borderRadius: shape === "circle" ? "full" : isMobile ? "sm" : "md",
      backgroundColor: mapVariantToBackgroundColor[variant],
      borderWidth: "0px",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "content-box",
      children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
        import_react34.Icon,
        {
          as: icon,
          color: mapVariantToIconColor[variant],
          boxSize: mapSizeToIconBoxSize[size]
        }
      )
    }
  );
};

// src/components/svg/CornToken.tsx
var import_jsx_runtime38 = require("react/jsx-runtime");
var CornToken = ({ size }) => {
  const sizeInPx = mapTokenSizeToValue[size || "sm"];
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("g", { clipPath: "url(#clip0_9191_207820)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "mask",
            {
              id: "mask0_9191_207820",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: sizeInPx,
              height: sizeInPx,
              children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("path", { d: "M0 0H16V16H0V0Z", fill: "white" })
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("g", { mask: "url(#mask0_9191_207820)", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16 8.00408C16 12.4244 12.4184 16.008 8.00007 16.008C3.58177 16.008 0 12.4244 0 8.00408C0 3.58357 3.58177 0 8.00007 0C12.4184 0 16 3.58357 16 8.00408Z",
              fill: "#F6BF4C"
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.9834 1.83542C9.08855 1.9052 9.17967 1.99396 9.25262 2.09675H9.49886C9.8282 2.09675 10.0962 1.8286 10.0962 1.49909V1.41782C10.0962 1.08858 9.8282 0.820557 9.49886 0.820557H9.37674C9.38168 0.860793 9.38489 0.901698 9.38489 0.943538V1.02762C9.38489 1.357 9.22683 1.64948 8.9834 1.83542Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.49791 2.48792H9.41828C9.43084 2.55154 9.43926 2.61651 9.43926 2.68375V2.76783C9.43926 3.08357 9.29469 3.36616 9.06836 3.55291C9.16028 3.60972 9.24112 3.68204 9.31059 3.76411H9.86667C10.196 3.76411 10.4639 3.49609 10.4639 3.16658V3.08544C10.4639 2.75593 10.196 2.48792 9.86667 2.48792H9.49791Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.86699 4.15527H9.51801C9.54045 4.23882 9.55248 4.32665 9.55248 4.41728V4.51446C9.55248 4.85199 9.38667 5.15075 9.13281 5.33589C9.17236 5.36477 9.20897 5.39725 9.24397 5.43147H10.3026C10.6319 5.43147 10.8998 5.16332 10.8998 4.83381V4.75267C10.8998 4.42329 10.6319 4.15527 10.3026 4.15527H9.86699Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.0374 6.42009C11.0374 6.09071 10.7695 5.82269 10.4402 5.82269H9.49436C9.53137 5.92763 9.55248 6.04005 9.55248 6.15768V6.25473C9.55248 6.59226 9.38667 6.89116 9.13281 7.07617C9.18225 7.0894 9.23329 7.09889 9.28673 7.09889H10.4402C10.7695 7.09889 11.0374 6.83087 11.0374 6.50123V6.42009Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.20898 8.7537C9.23116 8.7573 9.25254 8.76225 9.27539 8.76345C9.28821 8.76292 9.30091 8.76145 9.31387 8.76145H9.82478C9.89426 8.70437 9.96414 8.64702 10.0351 8.5878C10.5102 8.19199 10.7805 7.90472 10.9153 7.62548C10.8127 7.54206 10.6836 7.48993 10.5413 7.48993H9.46538C9.52069 7.61492 9.55289 7.7522 9.55289 7.89764V7.99469C9.55289 8.29706 9.41915 8.56749 9.20898 8.7537Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.63838 1.65357H8.36748C8.71246 1.65357 8.99317 1.37285 8.99317 1.0277V0.943617C8.99317 0.598467 8.71246 0.317749 8.36748 0.317749H7.63838C7.29341 0.317749 7.0127 0.598467 7.0127 0.943617V1.0277C7.0127 1.37285 7.29341 1.65357 7.63838 1.65357Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.58272 3.39381H8.42245C8.76742 3.39381 9.04813 3.11309 9.04813 2.76781V2.68373C9.04813 2.33858 8.76742 2.05786 8.42245 2.05786H7.58272C7.23774 2.05786 6.95703 2.33858 6.95703 2.68373V2.76781C6.95703 3.11309 7.23774 3.39381 7.58272 3.39381Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.84473 4.51455C6.84473 4.8597 7.1253 5.14042 7.47028 5.14042H8.53581C8.88078 5.14042 9.16149 4.8597 9.16149 4.51455V4.41737C9.16149 4.07236 8.88078 3.7915 8.53581 3.7915H7.47028C7.1253 3.7915 6.84473 4.07236 6.84473 4.41737V4.51455Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.84473 6.25474C6.84473 6.59975 7.1253 6.88061 7.47028 6.88061H8.53581C8.88078 6.88061 9.16149 6.59975 9.16149 6.25474V6.15769C9.16149 5.81241 8.88078 5.53156 8.53581 5.53156H7.47028C7.1253 5.53156 6.84473 5.81241 6.84473 6.15769V6.25474Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.84473 7.99478C6.84473 8.3291 7.10847 8.60059 7.43835 8.61757C7.44917 8.61717 7.45959 8.61597 7.47028 8.61597H8.53581C8.5465 8.61597 8.55705 8.61717 8.56774 8.61757C8.89762 8.60059 9.16149 8.3291 9.16149 7.99478V7.89773C9.16149 7.55258 8.88078 7.27173 8.53581 7.27173H7.47028C7.1253 7.27173 6.84473 7.55258 6.84473 7.89773V7.99478Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.75644 9.98239C7.84743 10.0512 7.93187 10.1155 8.0127 10.1772C8.0906 10.1174 8.1733 10.0542 8.26068 9.98747L8.28901 9.96595C8.52923 9.78281 8.79872 9.57722 9.09026 9.34917C8.99072 9.15708 8.79645 9.02193 8.56811 9.01017C8.55729 9.00963 8.54714 9.00696 8.53618 9.00696H7.47066C7.4597 9.00696 7.44955 9.00963 7.43872 9.01017C7.21292 9.0218 7.0204 9.15413 6.91992 9.34302C7.21613 9.57307 7.48963 9.78027 7.73333 9.96474L7.75644 9.98239Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.01712 1.83542C6.91197 1.9052 6.82085 1.99396 6.7479 2.09675H6.50153C6.17218 2.09675 5.9043 1.8286 5.9043 1.49909V1.41782C5.9043 1.08858 6.17218 0.820557 6.50153 0.820557H6.62378C6.61897 0.860793 6.61563 0.901698 6.61563 0.943538V1.02762C6.61563 1.357 6.77369 1.64948 7.01712 1.83542Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.50296 2.48792H6.58273C6.5703 2.55154 6.56175 2.61651 6.56175 2.68375V2.76783C6.56175 3.08357 6.70632 3.36616 6.93265 3.55291C6.84073 3.60972 6.76003 3.68204 6.69055 3.76411H6.13434C5.80499 3.76411 5.53711 3.49609 5.53711 3.16658V3.08544C5.53711 2.75593 5.80499 2.48792 6.13434 2.48792H6.50296Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.13338 4.15527H6.48236C6.45992 4.23882 6.44776 4.32665 6.44776 4.41728V4.51446C6.44776 4.85199 6.6137 5.15075 6.86756 5.33589C6.82801 5.36477 6.7914 5.39725 6.75639 5.43147H5.69782C5.36847 5.43147 5.10059 5.16332 5.10059 4.83381V4.75267C5.10059 4.42329 5.36847 4.15527 5.69782 4.15527H6.13338Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.96289 6.42009C4.96289 6.09071 5.23078 5.82269 5.56012 5.82269H6.50593C6.46906 5.92763 6.44768 6.04005 6.44768 6.15768V6.25473C6.44768 6.59226 6.61362 6.89116 6.86748 7.07617C6.81804 7.0894 6.76714 7.09889 6.71356 7.09889H5.56012C5.23078 7.09889 4.96289 6.83087 4.96289 6.50123V6.42009Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.79114 8.7537C6.76923 8.7573 6.74772 8.76225 6.725 8.76345C6.71204 8.76292 6.69935 8.76145 6.68639 8.76145H6.17547C6.106 8.70437 6.03612 8.64702 5.96517 8.5878C5.49006 8.19199 5.21977 7.90472 5.08496 7.62548C5.18771 7.54206 5.31677 7.48993 5.45906 7.48993H6.53488C6.47956 7.61492 6.44723 7.7522 6.44723 7.89764V7.99469C6.44723 8.29706 6.58111 8.56749 6.79114 8.7537Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.81291 13.3552C5.81959 12.4051 6.42898 11.4381 7.62424 10.4814L7.63586 10.4722C7.18507 10.1305 6.37661 9.51011 5.68545 8.93852C4.9307 8.31425 4.52186 7.8778 4.52186 7.16558C4.52186 7.12869 4.48765 7.09888 4.44543 7.09888C4.40334 7.09888 4.36914 7.12869 4.36914 7.16558V10.1778L5.44121 11.2769L4.36914 10.6532V11.8917C4.36914 12.7675 4.95261 13.3265 5.58311 13.8004C5.69547 13.8849 5.81011 13.9726 5.92488 14.0612C5.84899 13.8332 5.81118 13.5976 5.81291 13.3552Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.5999 10.699C11.3792 10.8864 11.1512 11.0578 10.921 11.2238C10.4637 11.5564 9.97921 11.8566 9.53403 12.1727C9.07067 12.4959 8.63043 12.8241 8.24123 13.2213C8.04884 13.4196 7.86887 13.632 7.72644 13.8691C7.58482 14.1051 7.47633 14.3697 7.46804 14.6518C7.45254 14.3699 7.53979 14.089 7.66485 13.8356C7.79057 13.5801 7.95691 13.3471 8.13702 13.1278C8.49789 12.6906 8.93119 12.3081 9.3586 11.9538C9.80258 11.5882 10.2507 11.2653 10.6757 10.9068C10.8877 10.7294 11.0955 10.5481 11.2891 10.3581C11.4119 10.2368 11.5293 10.1106 11.6333 9.98185V7.16558C11.6333 7.12869 11.5995 7.09888 11.5577 7.09888C11.5157 7.09888 11.4818 7.12869 11.4818 7.16558C11.4818 7.8778 11.0759 8.31425 10.3265 8.93852C9.65761 9.49554 9.05183 9.95766 8.56523 10.3289C8.31699 10.5184 8.10255 10.6819 7.94142 10.8114L7.90868 10.8378C6.82605 11.7045 6.27425 12.5526 6.2686 13.3584C6.26436 13.9651 6.57714 14.531 7.19802 15.0404C7.27565 15.1042 7.9334 15.6659 7.93981 15.6715C7.95451 15.684 7.97362 15.6905 7.99272 15.6905C8.01009 15.6905 8.02759 15.6851 8.04189 15.6746C8.05552 15.6643 9.41899 14.641 10.4307 13.7984C11.0644 13.2704 11.6333 12.7273 11.6333 11.8917V10.6693C11.6222 10.6792 11.6111 10.6893 11.5999 10.699Z",
              fill: "#FFFFFE"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("clipPath", { id: "clip0_9191_207820", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("rect", { width: sizeInPx, height: sizeInPx, fill: "white" }) }) })
      ]
    }
  );
};

// src/components/svg/SoyToken.tsx
var import_jsx_runtime39 = require("react/jsx-runtime");
var SoyToken = ({ size }) => {
  const sizeInPx = mapTokenSizeToValue[size || "sm"];
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)("g", { clipPath: "url(#clip0_9191_207663)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "mask",
            {
              id: "mask0_9191_207663",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "16",
              height: "16",
              children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("path", { d: "M0 0.032959H15.9671V15.992H0V0.032959Z", fill: "white" })
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("g", { mask: "url(#mask0_9191_207663)", children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M15.9671 8.01656C15.9671 12.4256 12.3928 16 7.9836 16C3.5744 16 0 12.4256 0 8.01656C0 3.60736 3.5744 0.032959 7.9836 0.032959C12.3928 0.032959 15.9671 3.60736 15.9671 8.01656Z",
              fill: "#43A747"
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.0351 8.01853C10.8443 7.0368 11.6087 6.27053 11.6087 5.03013C11.6087 4.2712 11.3751 3.5672 10.9764 2.98493H10.9769C10.9691 2.9736 10.9604 2.9624 10.9524 2.95107C10.8983 2.87413 10.8421 2.79867 10.7823 2.72613C10.7821 2.72587 10.782 2.7256 10.7817 2.72533C10.7811 2.72467 10.7805 2.724 10.7799 2.7232C9.7504 1.43907 7.97773 0.351868 7.97773 0.351868C7.97773 0.351868 6.19907 1.4492 5.17307 2.74107C5.11787 2.80853 5.0656 2.87853 5.01547 2.95013C5.00707 2.96173 4.99827 2.97333 4.99 2.98493H4.99067C4.592 3.5672 4.3584 4.2712 4.3584 5.03013C4.3584 6.27053 5.23213 7.16987 5.93186 8.01853C5.20786 8.89947 4.3584 9.7664 4.3584 11.0068C4.3584 11.7657 4.592 12.4697 4.99067 13.0521H4.99C4.99827 13.0637 5.00707 13.0752 5.01547 13.0868C5.0656 13.1583 5.11787 13.2284 5.17307 13.296C6.19907 14.5877 7.97773 15.6852 7.97773 15.6852C7.97773 15.6852 9.7504 14.5979 10.7799 13.3137C10.7805 13.3131 10.7811 13.3123 10.7817 13.3116C10.782 13.3113 10.7821 13.3111 10.7823 13.3108C10.8421 13.2383 10.8983 13.1629 10.9524 13.086C10.9604 13.0747 10.9691 13.0635 10.9769 13.0521H10.9764C11.3751 12.4697 11.6087 11.7657 11.6087 11.0068C11.6087 9.7664 10.7475 8.8632 10.0351 8.01853Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.78601 11.462C9.75694 11.5968 9.71561 11.7304 9.65867 11.8588C9.60187 11.9907 9.53214 12.1004 9.43961 12.2383L8.86627 13.0596C8.67734 13.3408 8.49067 13.6256 8.32574 13.9263C8.24374 14.077 8.16441 14.2295 8.09734 14.3894C8.06387 14.4688 8.03614 14.552 8.01227 14.6354C8.00014 14.6768 7.99441 14.7215 7.98587 14.7634C7.98334 14.7784 7.98361 14.794 7.98361 14.8095C7.98347 14.794 7.98374 14.7784 7.98121 14.7634C7.97267 14.7215 7.96707 14.6768 7.95481 14.6354C7.93094 14.552 7.90321 14.4688 7.86974 14.3894C7.80281 14.2295 7.72321 14.077 7.64134 13.9263C7.47641 13.6256 7.28974 13.3408 7.10094 13.0596L6.52747 12.2383C6.43494 12.1004 6.36507 11.9907 6.30841 11.8588C6.25147 11.7304 6.21014 11.5968 6.18107 11.462C6.15241 11.327 6.13881 11.1896 6.14081 11.0528L6.14347 10.9506L6.15307 10.8692L6.17081 10.7864L6.19654 10.7023C6.27641 10.4755 6.43601 10.2307 6.62814 9.99096C6.81921 9.74949 7.03641 9.50536 7.25961 9.25069C7.28907 9.21683 7.31147 9.19163 7.34547 9.14963C7.38054 9.10323 7.41867 9.05896 7.44974 9.00936C7.51414 8.91216 7.57174 8.80936 7.61547 8.70069C7.70521 8.48456 7.75414 8.25069 7.75374 8.01629C7.75174 7.78203 7.70414 7.54829 7.61347 7.33216C7.56907 7.22376 7.51147 7.12136 7.44734 7.02389C7.41454 6.97616 7.37787 6.92949 7.34334 6.88456L7.26121 6.78789C7.03947 6.52963 6.82294 6.28109 6.62321 6.03749C6.42281 5.79363 6.26001 5.55923 6.19094 5.34536C6.15494 5.23323 6.13907 5.12949 6.13934 4.98416C6.13734 4.84723 6.15107 4.70976 6.17961 4.57483C6.20894 4.43989 6.24974 4.30603 6.30721 4.17749C6.32121 4.14536 6.33641 4.11349 6.35267 4.08203C6.37001 4.04856 6.38054 4.02723 6.40307 3.98976L6.46001 3.89856L6.48801 3.85269L7.09921 2.97603C7.28814 2.69523 7.47494 2.41056 7.64027 2.11003C7.72254 1.95976 7.80201 1.80723 7.86947 1.64776L7.91641 1.52669L7.95494 1.40203C7.96761 1.36069 7.97294 1.31576 7.98161 1.27403C7.98374 1.26216 7.98307 1.24963 7.98361 1.23736C7.98401 1.24963 7.98334 1.26216 7.98561 1.27403C7.99414 1.31576 7.99947 1.36069 8.01214 1.40203L8.05067 1.52669L8.09761 1.64776C8.16507 1.80723 8.24454 1.95976 8.32681 2.11003C8.49214 2.41056 8.67894 2.69523 8.86774 2.97603L9.47894 3.85269L9.50707 3.89856L9.56401 3.98976C9.58654 4.02723 9.59707 4.04856 9.61441 4.08203C9.63067 4.11349 9.64587 4.14536 9.66001 4.17749C9.71734 4.30603 9.75814 4.43989 9.78747 4.57483C9.81601 4.70976 9.82974 4.84723 9.82774 4.98416C9.82801 5.12949 9.81214 5.23323 9.77614 5.34536C9.70694 5.55923 9.54427 5.79363 9.34374 6.03749C9.14414 6.28109 8.92774 6.52963 8.70587 6.78789L8.62374 6.88456C8.58921 6.92949 8.55254 6.97616 8.51974 7.02389C8.45561 7.12136 8.39801 7.22376 8.35361 7.33216C8.26294 7.54829 8.21521 7.78203 8.21334 8.01629C8.21294 8.25069 8.26187 8.48456 8.35161 8.70069C8.39534 8.80936 8.45294 8.91216 8.51747 9.00936C8.54841 9.05896 8.58654 9.10323 8.62161 9.14963C8.65561 9.19163 8.67801 9.21683 8.70747 9.25069C8.93067 9.50536 9.14787 9.74949 9.33894 9.99096C9.53107 10.2307 9.69067 10.4755 9.77054 10.7023L9.79627 10.7864L9.81401 10.8692L9.82361 10.9506L9.82627 11.0528C9.82827 11.1896 9.81467 11.327 9.78601 11.462ZM10.6833 10.7808C10.6775 10.7258 10.6721 10.6698 10.664 10.6151C10.6535 10.562 10.6436 10.5076 10.6309 10.4552C10.5248 10.0347 10.3137 9.70736 10.1099 9.41136C9.90187 9.11603 9.67894 8.85603 9.47214 8.59909L9.39734 8.50776C9.38347 8.48643 9.36521 8.46829 9.35307 8.44603C9.32627 8.40336 9.30107 8.35949 9.28387 8.31229C9.24667 8.21909 9.22681 8.11843 9.22774 8.01763C9.22761 7.91683 9.24681 7.81616 9.28428 7.72296C9.30214 7.67576 9.32707 7.63203 9.35347 7.58896L9.39854 7.52669L9.47627 7.43029C9.67921 7.17229 9.89814 6.91309 10.1053 6.62576C10.2092 6.48149 10.3131 6.32989 10.4092 6.15803C10.5056 5.98723 10.5897 5.78869 10.6389 5.57349C10.6887 5.36163 10.6968 5.12669 10.6752 4.93789C10.656 4.74029 10.6145 4.54496 10.5527 4.35776C10.492 4.16989 10.4061 3.99163 10.3047 3.82563C10.2793 3.78403 10.2528 3.74336 10.2251 3.70349C10.1989 3.66563 10.1636 3.61709 10.1385 3.58589L10.0456 3.47576L9.99854 3.42136L9.95787 3.37883C9.72174 3.12589 9.48481 2.89469 9.24961 2.65749C9.01334 2.42229 8.78054 2.18603 8.55321 1.94483C8.43974 1.82416 8.33027 1.70016 8.22934 1.57043C8.12587 1.44163 8.02747 1.30883 7.98361 1.14496C7.93961 1.30883 7.84134 1.44163 7.73774 1.57043C7.63681 1.70016 7.52734 1.82416 7.41387 1.94483C7.18654 2.18603 6.95374 2.42229 6.71747 2.65749C6.48227 2.89469 6.24534 3.12589 6.00921 3.37883L5.96854 3.42136L5.92147 3.47576L5.82854 3.58589C5.80347 3.61709 5.76814 3.66563 5.74201 3.70349C5.71427 3.74336 5.68774 3.78403 5.66241 3.82563C5.56094 3.99163 5.47507 4.16989 5.41441 4.35776C5.35254 4.54496 5.31107 4.74029 5.29187 4.93789C5.27027 5.12669 5.27841 5.36163 5.32827 5.57349C5.37734 5.78869 5.46147 5.98723 5.55787 6.15803C5.65401 6.32989 5.75787 6.48149 5.86174 6.62576C6.06894 6.91309 6.28787 7.17229 6.49081 7.43029L6.56854 7.52669L6.61361 7.58896C6.63987 7.63203 6.66494 7.67576 6.68294 7.72296C6.72027 7.81616 6.73947 7.91683 6.73934 8.01763C6.74027 8.11843 6.72041 8.21909 6.68321 8.31229C6.66587 8.35949 6.64081 8.40336 6.61401 8.44603C6.60187 8.46829 6.58361 8.48643 6.56974 8.50776L6.49494 8.59909C6.28814 8.85603 6.06507 9.11603 5.85721 9.41136C5.65347 9.70736 5.44227 10.0347 5.33614 10.4552C5.32347 10.5076 5.31361 10.562 5.30307 10.6151C5.29494 10.6698 5.28961 10.7258 5.28374 10.7808C5.28121 10.8372 5.28081 10.8942 5.28027 10.9504C5.28307 11.0002 5.28441 11.0498 5.29041 11.0992C5.30961 11.2971 5.35107 11.4924 5.41307 11.6799C5.47387 11.8676 5.55947 12.0463 5.66121 12.2122C5.75987 12.3778 5.89161 12.5366 6.00827 12.6592C6.24507 12.9124 6.48187 13.1428 6.71721 13.3802C6.95361 13.6148 7.18627 13.8512 7.41347 14.0923C7.52681 14.2132 7.63667 14.3368 7.73707 14.467C7.84054 14.5959 7.93934 14.7284 7.98281 14.8924C7.98267 14.884 7.98321 14.8748 7.98361 14.866C7.98387 14.8748 7.98441 14.884 7.98427 14.8924C8.02787 14.7284 8.12667 14.5959 8.23001 14.467C8.33041 14.3368 8.44041 14.2132 8.55361 14.0923C8.78081 13.8512 9.01361 13.6148 9.24987 13.3802C9.48521 13.1428 9.72201 12.9124 9.95894 12.6592C10.0755 12.5366 10.2073 12.3778 10.3059 12.2122C10.4076 12.0463 10.4932 11.8676 10.554 11.6799C10.6159 11.4924 10.6575 11.2971 10.6767 11.0992C10.6825 11.0498 10.684 11.0002 10.6868 10.9504C10.6864 10.8942 10.6859 10.8372 10.6833 10.7808Z",
              fill: "#43A747"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.98337 14.9357C7.98644 14.4296 6.84591 13.1211 6.40164 12.4872C6.39857 12.4828 6.39537 12.4784 6.39231 12.474C6.36351 12.4341 6.33444 12.3903 6.30337 12.3401C6.30097 12.3363 6.28764 12.3155 6.28764 12.3155C6.05484 11.9291 5.93164 11.4767 5.93164 11.0069C5.93164 10.4131 6.27764 9.90267 6.84737 9.1324C6.91857 9.03613 6.98951 8.94027 7.05924 8.84413C7.40564 8.36693 7.41177 7.67773 7.06497 7.2008C6.99804 7.1084 6.92911 7.0156 6.85937 6.92173C6.38231 6.2784 5.93164 5.6708 5.93164 5.03013C5.93164 4.55973 6.05497 4.10693 6.28831 3.72027C6.28831 3.72027 6.29991 3.70253 6.30337 3.69693C6.33457 3.6468 6.36377 3.60253 6.39284 3.562C6.39577 3.55787 6.39871 3.55373 6.40164 3.54973C6.84577 2.916 7.98697 1.63627 7.98337 1.1344C7.98697 1.63627 9.11071 2.90747 9.55577 3.5364C9.55777 3.53933 9.56657 3.55173 9.56911 3.5552C9.59857 3.5956 9.62937 3.64213 9.66364 3.69747C9.66631 3.70187 9.67884 3.72147 9.67884 3.72147C9.91177 4.10787 10.0348 4.56027 10.0348 5.03013C10.0348 5.64067 9.74337 6.0616 9.13671 6.88093C9.06164 6.98253 8.98537 7.08573 8.90857 7.1912C8.55697 7.67493 8.55764 8.37413 8.91404 8.8532C8.96604 8.9232 9.01897 8.99347 9.07231 9.0644C9.56737 9.7224 10.0348 10.3439 10.0348 11.0069C10.0348 11.4772 9.91137 11.9304 9.67791 12.3172C9.67791 12.3172 9.66631 12.3352 9.66364 12.3395C9.62937 12.3948 9.59857 12.4413 9.56911 12.4817C9.56657 12.4855 9.55777 12.4976 9.55577 12.5005C9.12964 13.1028 7.98644 14.4296 7.98337 14.9357Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.94795 6.26921L7.02768 5.08588C7.01421 5.06868 7.01421 5.04401 7.02768 5.02668L7.94795 3.84334C7.96608 3.81988 8.00061 3.81988 8.01875 3.84334L8.93901 5.02668C8.95248 5.04401 8.95248 5.06868 8.93901 5.08588L8.01875 6.26921C8.00061 6.29254 7.96608 6.29254 7.94795 6.26921Z",
              fill: "#43A747"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.94795 12.1642L7.02768 10.9809C7.01421 10.9637 7.01421 10.9392 7.02768 10.9218L7.94795 9.73849C7.96608 9.71502 8.00061 9.71502 8.01875 9.73849L8.93901 10.9218C8.95248 10.9392 8.95248 10.9637 8.93901 10.9809L8.01875 12.1642C8.00061 12.1877 7.96608 12.1877 7.94795 12.1642Z",
              fill: "#43A747"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("clipPath", { id: "clip0_9191_207663", children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("rect", { width: sizeInPx, height: sizeInPx, fill: "white" }) }) })
      ]
    }
  );
};

// src/components/svg/WheatToken.tsx
var import_jsx_runtime40 = require("react/jsx-runtime");
var WheatToken = ({ size }) => {
  const sizeInPx = mapTokenSizeToValue[size || "sm"];
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(
    "svg",
    {
      width: sizeInPx,
      height: sizeInPx,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)("g", { clipPath: "url(#clip0_9191_207725)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "mask",
            {
              id: "mask0_9191_207725",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: sizeInPx,
              height: sizeInPx,
              children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("path", { d: "M0 0H15.9671V15.9591H0V0Z", fill: "white" })
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("g", { mask: "url(#mask0_9191_207725)", children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M15.9671 7.9836C15.9671 12.3927 12.3928 15.9671 7.9836 15.9671C3.5744 15.9671 0 12.3927 0 7.9836C0 3.5744 3.5744 0 7.9836 0C12.3928 0 15.9671 3.5744 15.9671 7.9836Z",
              fill: "#E88136"
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.3235 3.5083C11.2627 3.50724 11.2025 3.50588 11.1401 3.50588C10.3874 3.50588 9.82032 3.49697 9.29312 3.83417C8.44832 4.37457 8.60885 5.19204 8.60885 6.87817C9.50885 6.72044 10.9038 6.4335 11.3597 5.90057C11.5958 5.62457 11.6903 4.6827 11.6826 3.88724L9.15232 6.28444L11.3235 3.5083Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.3235 7.08807C11.2627 7.087 11.2025 7.08578 11.1401 7.08578C10.3874 7.08578 9.82032 7.07673 9.29312 7.41407C8.44832 7.95433 8.60885 8.77193 8.60885 10.4581C9.50885 10.3005 10.9038 10.0134 11.3597 9.48047C11.5958 9.20433 11.6903 8.2626 11.6826 7.46713L9.15232 9.86433L11.3235 7.08807Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.3235 10.6671C11.2627 10.6661 11.2025 10.6647 11.1401 10.6647C10.3874 10.6647 9.82032 10.6558 9.29312 10.9929C8.44832 11.5333 8.60885 12.3509 8.60885 14.0369C9.50885 13.8794 10.9038 13.5922 11.3597 13.0593C11.5958 12.7833 11.6903 11.8415 11.6826 11.0461L9.15232 13.4433L11.3235 10.6671Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.64356 3.5083C4.70436 3.50724 4.76463 3.50588 4.82703 3.50588C5.5797 3.50588 6.14676 3.49697 6.6741 3.83417C7.51876 4.37457 7.35823 5.19204 7.35823 6.87817C6.45823 6.72044 5.0633 6.4335 4.60743 5.90057C4.3713 5.62457 4.27676 4.6827 4.28463 3.88724L6.81476 6.28444L4.64356 3.5083Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.64356 7.08807C4.70436 7.087 4.76463 7.08578 4.82703 7.08578C5.5797 7.08578 6.14676 7.07673 6.6741 7.41407C7.51876 7.95433 7.35823 8.77193 7.35823 10.4581C6.45823 10.3005 5.0633 10.0134 4.60743 9.48047C4.3713 9.20433 4.27676 8.2626 4.28463 7.46713L6.81476 9.86433L4.64356 7.08807Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.64356 10.6671C4.70436 10.6661 4.76463 10.6647 4.82703 10.6647C5.5797 10.6647 6.14676 10.6558 6.6741 10.9929C7.51876 11.5333 7.35823 12.3509 7.35823 14.0369C6.45823 13.8794 5.0633 13.5922 4.60743 13.0593C4.3713 12.7833 4.27676 11.8415 4.28463 11.0461L6.81476 13.4433L4.64356 10.6671Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.97707 3.85303C7.83173 3.85303 7.71387 3.96916 7.71387 4.11249V15.3908C7.71387 15.534 7.83173 15.6502 7.97707 15.6502C8.1224 15.6502 8.2404 15.534 8.2404 15.3908V4.11249C8.2404 3.96916 8.1224 3.85303 7.97707 3.85303Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.97738 3.52869L7.73738 0.316956C7.69738 0.355622 7.65724 0.394022 7.61684 0.434556C7.12831 0.922955 6.75444 1.28522 6.63111 1.84616C6.43351 2.74522 6.88444 3.27762 7.97884 4.37202L7.97738 3.52869Z",
              fill: "#FFFFFE"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.97949 3.52869L8.18456 0.316956C8.22456 0.355622 8.26469 0.394022 8.30509 0.434556C8.79362 0.922955 9.16749 1.28522 9.29083 1.84616C9.48843 2.74522 9.07376 3.27762 7.97949 4.37202V3.52869Z",
              fill: "#FFFFFE"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("clipPath", { id: "clip0_9191_207725", children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("rect", { width: sizeInPx, height: sizeInPx, fill: "white" }) }) })
      ]
    }
  );
};

// src/components/TextareaField.tsx
var import_react35 = require("@chakra-ui/react");
var import_react_hook_form4 = require("react-hook-form");
var import_lodash3 = __toESM(require("lodash.get"));
var import_jsx_runtime41 = require("react/jsx-runtime");
var BORDER_COLORS = {
  default: "border-color-secondary",
  success: "border-color-success",
  error: "border-color-destructive",
  disabled: "border-color-disabled",
  focused: "border-color-focus"
};
var TextareaField = ({
  id,
  label,
  name,
  placeholder,
  isReadOnly = false,
  helperText,
  rhfOptions = {},
  helperTextIcon = /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(AlertIcon, { color: "currentColor" }),
  errorMessageFormatter = (message) => message,
  resize = "none"
}) => {
  const formMethods = (0, import_react_hook_form4.useFormContext)();
  if (!formMethods) {
    throw new Error(
      `TextareaField component Must be used within react-hook-form "FormProvider"`
    );
  }
  const { register } = formMethods;
  const { errors } = (0, import_react_hook_form4.useFormState)();
  const fieldError = (0, import_lodash3.default)(errors, name, null);
  const errorMessage = errorMessageFormatter(
    (0, import_lodash3.default)(fieldError, "message", "")
  );
  const isInvalid = Boolean(fieldError);
  const isValid = !isInvalid;
  const showHelperText = isValid && helperText;
  const isRequired = Boolean(rhfOptions.required);
  const isDisabled = Boolean(rhfOptions.disabled);
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
    import_react35.FormControl,
    {
      isInvalid,
      isDisabled,
      isReadOnly,
      isRequired,
      children: [
        label ? /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(import_react35.FormLabel, { htmlFor: id, _disabled: { color: "content-disabled" }, children: label }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
          import_react35.Textarea,
          __spreadProps(__spreadValues({
            id,
            placeholder,
            resize,
            role: "textarea",
            isDisabled,
            isInvalid
          }, register(name, rhfOptions)), {
            borderColor: BORDER_COLORS.default,
            _focusVisible: {
              borderWidth: "1.5px",
              borderColor: isReadOnly ? BORDER_COLORS.default : BORDER_COLORS.focused
            },
            disabled: isDisabled,
            isReadOnly,
            isRequired,
            borderRadius: "md"
          })
        ),
        /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(import_react35.Flex, { columnGap: "1", children: [
          showHelperText && /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FormHelperText, { children: helperText }),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FormErrorMessage, { mt: "1.5", children: errorMessage })
        ] })
      ]
    }
  );
};

// src/components/DatePicker/DateCalendar.tsx
var import_react36 = require("@chakra-ui/react");
var import_react37 = require("react");
var import_react38 = require("react");
var import_react_datepicker = __toESM(require("react-datepicker"));
var import_react_datepicker2 = require("react-datepicker/dist/react-datepicker.css");
var import_fi2 = require("react-icons/fi");

// src/components/DatePicker/datepicker-styles.ts
var chevronRightSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
var chevronRightSvgUrl = `data:image/svg+xml;base64,${btoa(chevronRightSvg)}`;
var chevronLeftSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>`;
var chevronLeftSvgUrl = `data:image/svg+xml;base64,${btoa(chevronLeftSvg)}`;
var datePickerStyles = {
  ".react-datepicker__header": {
    "background-color": "transparent !important",
    "border-bottom": "none !important",
    "margin-top": "10px",
    "padding-bottom": "0px"
  },
  ".react-datepicker-wrapper": {
    display: "block"
  },
  ".react-datepicker__triangle": {
    display: "none"
  },
  ".react-datepicker__input-container": {
    "padding-left": "0px",
    "padding-right": "0px",
    border: "none",
    "box-shadow": "none"
  },
  ".react-datepicker__navigationut": {
    "margin-top": "11px"
  },
  ".react-datepicker__day": {
    "border-radius": "var(--chakra-radii-md)",
    "font-size": "16px",
    "font-family": "Larsseit",
    "font-style": "normal",
    "font-weight": "500",
    border: "1px solid white",
    width: "40px",
    height: "40px",
    "padding-top": "5px",
    margin: "0px"
  },
  ".react-datepicker__day-names": {
    "margin-top": "12px"
  },
  ".react-datepicker__navigation-icon--next": {
    display: "none"
  },
  ".react-datepicker__navigation-icon--previous": {
    display: "none"
  },
  ".react-datepicker__current-month": {
    color: "var(--chakra-colors-gray-700)",
    "text-align": "center",
    "font-size": "16px",
    "font-family": "Larsseit",
    "font-style": "normal",
    "font-weight": "700",
    "line-height": "24px"
  },
  ".react-datepicker__day-name": {
    color: "var(--chakra-colors-gray-500)",
    "text-align": "center",
    "font-size": "16px",
    "font-family": "Larsseit",
    "font-style": "normal",
    "font-weight": "500",
    height: "40px",
    width: "40px",
    margin: "0px"
  },
  ".react-datepicker__day--selected": {
    "background-color": "black",
    "font-weight": "700"
  },
  ".react-datepicker__day:not(.react-datepicker__day--disabled):not(.react-datepicker__day--selected):hover": {
    "background-color": "var(--chakra-colors-gray-100)"
  },
  ".react-datepicker__day--disabled": {
    color: "var(--chakra-colors-gray-400)"
  },
  ".react-datepicker__day--keyboard-selected": {
    "background-color": "white",
    color: "black"
  },
  ".react-datepicker-popper[data-placement^=`bottom`]": {
    "padding-top": "8px"
  },
  ".react-datepicker": {
    "padding-bottom": "12px",
    border: "1px solid var(--chakra-colors-gray-200)",
    shadow: "md"
  },
  ".react-datepicker__day--today": {
    border: " 1px solid #e4e7ec",
    "font-weight": "700"
  },
  ".react-datepicker__navigation--next": {
    "margin-top": "16px",
    height: "24px",
    width: "24px",
    "margin-right": "8px",
    "background-image": `url(${chevronRightSvgUrl})`,
    "background-repeat": "no-repeat",
    "background-position": ""
  },
  ".react-datepicker__navigation--previous": {
    "margin-top": "16px",
    height: "24px",
    width: "24px",
    "margin-left": "8px",
    "background-image": `url(${chevronLeftSvgUrl})`,
    "background-repeat": "no-repeat",
    "background-position": ""
  }
};
var datepicker_styles_default = datePickerStyles;

// src/components/DatePicker/DateCalendar.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
var DateCalendar = ({
  label,
  defaultDate,
  placeholder,
  minDate,
  maxDate,
  errorMessage,
  onChange,
  name,
  helperText,
  width = "100%",
  isSuccess,
  isInvalid,
  isDisabled
}) => {
  const [selectedDate, setSelectedDate] = (0, import_react37.useState)(defaultDate != null ? defaultDate : void 0);
  const showHelperText = Boolean(helperText && !(isInvalid && errorMessage));
  const showErrorMessage = Boolean(!isSuccess && isInvalid && errorMessage);
  (0, import_react37.useEffect)(() => {
    setSelectedDate(defaultDate);
  }, [defaultDate]);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    onChange(date);
  };
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  const CustomInput = (0, import_react38.forwardRef)((props, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(import_react36.InputGroup, { position: "relative", zIndex: "0", children: [
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.InputLeftElement, { children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_fi2.FiCalendar, { size: 20, color: "var(--chakra-colors-gray-500)" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
        import_react36.Input,
        __spreadProps(__spreadValues({
          isDisabled,
          size: isMobile ? SIZES.lg : SIZES.md,
          borderRadius: "md",
          name
        }, props), {
          ref
        })
      )
    ] });
  });
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.FormControl, { isInvalid, children: /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(import_react36.Flex, { width, sx: datepicker_styles_default, direction: "column", children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
      import_react_datepicker.default,
      {
        disabled: isDisabled,
        name: `${name}-picker`,
        selected: selectedDate,
        onChange: handleDateChange,
        customInput: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(CustomInput, {}),
        placeholderText: placeholder,
        minDate,
        maxDate,
        dateFormat: "dd/MM/yyyy",
        fixedHeight: true
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(import_react36.Flex, { columnGap: 1, mt: "1.5", alignItems: "top", children: [
      showHelperText && !showErrorMessage && /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(import_react36.Flex, { columnGap: "1", color: "gray.600", children: [
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.Flex, { alignItems: "top", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(AlertIcon, { color: "#475467" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.FormHelperText, { color: "gray.600", mt: 0, children: helperText })
      ] }),
      showErrorMessage ? /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(import_react36.Flex, { gap: 1, children: [
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(AlertIcon, { color: "#F25037" }),
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_react36.FormErrorMessage, { mt: "0", children: errorMessage })
      ] }) : null
    ] })
  ] }) });
};

// src/components/Checkbox.tsx
var import_react39 = require("@chakra-ui/react");
var import_react40 = require("react");
var import_react41 = require("@chakra-ui/react");
var import_fi3 = require("react-icons/fi");
var import_jsx_runtime43 = require("react/jsx-runtime");
var Checkbox = (_a2) => {
  var _b2 = _a2, {
    size = SIZES.md,
    children,
    description,
    disabled = false,
    name,
    required = false,
    onChange
  } = _b2, rest = __objRest(_b2, [
    "size",
    "children",
    "description",
    "disabled",
    "name",
    "required",
    "onChange"
  ]);
  const [isClicked, setIsClicked] = (0, import_react40.useState)(false);
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
    import_react39.Flex,
    {
      sx: {
        ".chakra-checkbox__label": {
          ml: size === "sm" ? "8px" : "12px"
        },
        ".chakra-checkbox": {
          "align-items": "flex-start"
        },
        ".chakra-checkbox__control": {
          mt: "3px",
          _focus: {
            ring: isClicked ? 0 : 4,
            ringColor: "var(--chakra-colors-gray-900)",
            outline: "2px solid white"
          },
          _hover: {
            border: disabled || isClicked ? "" : "1px solid var(--chakra-colors-gray-500)",
            backgroundColor: disabled || isClicked ? "" : "var(--chakra-colors-gray-50)"
          }
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
        import_react39.Checkbox,
        __spreadProps(__spreadValues({
          colorScheme: "gray",
          size: size === SIZES.sm ? SIZES.md : SIZES.lg,
          disabled,
          icon: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_fi3.FiCheck, { color: "white", size: size === "sm" ? "12px" : "14px" }),
          required,
          onChange: (e) => {
            setIsClicked(true);
            onChange && onChange(e);
          },
          onFocus: () => setIsClicked(false)
        }, rest), {
          children: /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(import_react39.Flex, { flexDir: "column", marginTop: "1px", children: [
            /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
              import_react41.Text,
              {
                size,
                variant: "regular",
                color: disabled ? "var(--chakra-colors-gray-400)" : "var(--chakra-colors-gray-700)",
                children
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
              import_react41.Text,
              {
                size,
                variant: "regular",
                color: disabled ? "var(--chakra-colors-gray-300)" : "var(--chakra-colors-gray-500)",
                children: description
              }
            )
          ] })
        })
      )
    }
  );
};

// src/components/Modal.tsx
var import_react42 = require("@chakra-ui/react");
var import_react43 = require("@chakra-ui/react");
var import_jsx_runtime44 = require("react/jsx-runtime");
var Modal = (props) => {
  const {
    isOpen,
    onClose,
    title,
    text,
    icon = void 0,
    labelBtnClose,
    labelBtnConfirm,
    variantBtnConfirm = "primary",
    iconVariant = "primary",
    children,
    hideModalCloseButton = false,
    onClickConfirm,
    isLoadingConfirmBtn,
    size,
    hasActionButtons = true,
    buttonsPosition = "end",
    textColor,
    confirmButtonDisabled,
    confirmButtonProps = {}
  } = props;
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  if (!isOpen)
    return null;
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(
    import_react43.Modal,
    {
      size,
      isOpen,
      onClose,
      closeOnOverlayClick: !hideModalCloseButton,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(import_react43.ModalOverlay, {}),
        /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(
          import_react43.ModalContent,
          {
            padding: { base: "16px", sm: "24px" },
            marginRight: "16px",
            marginLeft: "16px",
            boxShadow: "var(--chakra-shadows-xl)",
            borderRadius: "lg",
            backgroundColor: "background-primary-default",
            children: [
              icon && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
                FeaturedIcons,
                {
                  shape: "circle",
                  variant: iconVariant,
                  size: "md",
                  icon
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(import_react42.Flex, { display: "inline-block", alignItems: "center", children: [
                /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(import_react43.ModalHeader, { marginTop: icon ? "6" : "0", padding: 0, children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(import_react42.Text, { size: "lg", variant: "medium", children: title }) }),
                !hideModalCloseButton && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
                  import_react43.ModalCloseButton,
                  {
                    top: 5,
                    right: 5,
                    _focus: { boxShadow: "none" },
                    color: "var(--chakra-colors-gray-500)",
                    _hover: { background: "var(--chakra-colors-gray-50)" }
                  }
                )
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(import_react43.ModalBody, { padding: 0, marginTop: "12px", children: [
                /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
                  import_react42.Text,
                  {
                    whiteSpace: "break-spaces",
                    variant: "regular",
                    color: textColor ? textColor : "gray.600",
                    children: text
                  }
                ),
                children
              ] }),
              hasActionButtons && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(import_react43.ModalFooter, { padding: 0, marginTop: { base: "24px", sm: "32px" }, children: /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(
                import_react42.Flex,
                {
                  flexDir: { base: "column", sm: "row-reverse" },
                  width: "full",
                  gap: "3",
                  justifyContent: buttonsPosition,
                  children: [
                    labelBtnConfirm && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
                      import_react42.Button,
                      __spreadProps(__spreadValues({
                        disabled: confirmButtonDisabled,
                        variant: variantBtnConfirm,
                        onClick: onClickConfirm,
                        size: isMobile ? "lg" : "md",
                        isLoading: isLoadingConfirmBtn
                      }, confirmButtonProps), {
                        children: labelBtnConfirm
                      })
                    ),
                    labelBtnClose && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
                      import_react42.Button,
                      {
                        variant: "secondary",
                        onClick: onClose,
                        size: isMobile ? "lg" : "md",
                        children: labelBtnClose
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      ]
    }
  );
};

// src/components/Tab.tsx
var import_react44 = require("@chakra-ui/react");
var import_jsx_runtime45 = require("react/jsx-runtime");
var Tab = (_a2) => {
  var _b2 = _a2, { children } = _b2, otherProps = __objRest(_b2, ["children"]);
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(import_react44.Tab, __spreadProps(__spreadValues({ width: isMobile ? "100%" : "" }, otherProps), { children }));
};

// src/components/EmptyState.tsx
var import_react45 = require("@chakra-ui/react");

// src/components/svg/EmptyState.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
var EmptyStatePicture = ({ size }) => {
  const sizeInPx = mapSizeToValue[size || "md"];
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
    "svg",
    {
      width: "198",
      height: "137",
      viewBox: "0 0 198 137",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "98.5", cy: "68.5", r: "68.5", fill: "#BBEF9C" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "26.575", cy: "17.125", r: "6.85", fill: "#CAF2B8" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "173.85", cy: "107.887", r: "5.1375", fill: "#CAF2B8" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "25.7188", cy: "118.162", r: "8.5625", fill: "#CAF2B8" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "184.125", cy: "39.3875", r: "8.5625", fill: "#CAF2B8" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("circle", { cx: "167.856", cy: "9.41874", r: "5.99375", fill: "#CAF2B8" }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("g", { filter: "url(#filter0_dd_14701_2434)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M101.485 13.7C87.1543 13.7 74.4778 20.7813 66.7635 31.6356C64.2444 31.0415 61.6173 30.7272 58.9168 30.7272C40.1092 30.7272 24.8625 45.9738 24.8625 64.7815C24.8625 83.5891 40.1092 98.8357 58.9168 98.8357L58.9567 98.8357H144.004C144.02 98.8357 144.036 98.8358 144.053 98.8358C160.509 98.8358 173.85 85.495 173.85 69.0383C173.85 52.5816 160.509 39.2408 144.053 39.2408C142.884 39.2408 141.73 39.3081 140.597 39.439C134.074 24.299 119.017 13.7 101.485 13.7Z",
              fill: "#DBF5D4"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "circle",
            {
              cx: "58.9168",
              cy: "64.7815",
              r: "34.0543",
              fill: "url(#paint0_linear_14701_2434)"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "circle",
            {
              cx: "101.485",
              cy: "56.2679",
              r: "42.5679",
              fill: "url(#paint1_linear_14701_2434)"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "circle",
            {
              cx: "144.053",
              cy: "69.0383",
              r: "29.7975",
              fill: "url(#paint2_linear_14701_2434)"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("g", { filter: "url(#filter1_b_14701_2434)", children: [
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "rect",
            {
              x: "74.525",
              y: "71.925",
              width: "47.95",
              height: "47.95",
              rx: "23.975",
              fill: "#1C781F",
              "fill-opacity": "0.4"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
            "path",
            {
              d: "M107.491 104.891L103.145 100.545M105.493 94.901C105.493 99.3146 101.915 102.893 97.5011 102.893C93.0874 102.893 89.5094 99.3146 89.5094 94.901C89.5094 90.4873 93.0874 86.9093 97.5011 86.9093C101.915 86.9093 105.493 90.4873 105.493 94.901Z",
              stroke: "white",
              strokeWidth: "1.99792",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("defs", { children: [
          /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
            "filter",
            {
              id: "filter0_dd_14701_2434",
              x: "0.862549",
              y: "1.70001",
              width: "196.988",
              height: "133.136",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feOffset", { dy: "12" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feGaussianBlur", { stdDeviation: "12" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_14701_2434"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feOffset", {}),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feGaussianBlur", { stdDeviation: "2" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "effect1_dropShadow_14701_2434",
                    result: "effect2_dropShadow_14701_2434"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect2_dropShadow_14701_2434",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
            "filter",
            {
              id: "filter1_b_14701_2434",
              x: "66.525",
              y: "63.925",
              width: "63.95",
              height: "63.95",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "4" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feComposite",
                  {
                    in2: "SourceAlpha",
                    operator: "in",
                    result: "effect1_backgroundBlur_14701_2434"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_backgroundBlur_14701_2434",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
            "linearGradient",
            {
              id: "paint0_linear_14701_2434",
              x1: "32.768",
              y1: "42.2814",
              x2: "92.9711",
              y2: "98.8357",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { "stop-color": "#9CD87A" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { offset: "0.350715", "stop-color": "white", "stop-opacity": "0" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
            "linearGradient",
            {
              id: "paint1_linear_14701_2434",
              x1: "68.7987",
              y1: "28.1427",
              x2: "144.053",
              y2: "98.8357",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { "stop-color": "#ABDB8F" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { offset: "0.350715", "stop-color": "white", "stop-opacity": "0" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
            "linearGradient",
            {
              id: "paint2_linear_14701_2434",
              x1: "121.172",
              y1: "49.3506",
              x2: "173.85",
              y2: "98.8357",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { "stop-color": "#9CD87A" }),
                /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("stop", { offset: "0.350715", "stop-color": "white", "stop-opacity": "0" })
              ]
            }
          )
        ] })
      ]
    }
  );
};

// src/components/EmptyState.tsx
var import_jsx_runtime47 = require("react/jsx-runtime");
var mapSizetoTitleText = {
  ["sm"]: "md",
  ["md"]: "lg",
  ["lg"]: "xl"
};
var mapSizetoDescriptionText = {
  ["sm"]: "sm",
  ["md"]: "md",
  ["lg"]: "md"
};
var mapSizetoImage = {
  ["sm"]: false,
  ["md"]: false,
  ["lg"]: true
};
var mapSizetoIcon = {
  ["sm"]: true,
  ["md"]: true,
  ["lg"]: false
};
var EmptyState = (_a2) => {
  var _b2 = _a2, {
    size,
    icon,
    title,
    description,
    labelBtnSecondary = "Clear",
    labelBtnSuccess = "Create Project",
    variantBtnSuccess = "primary",
    onClickSuccess,
    onClickClear,
    showActions,
    isLoadingSuccessBtn,
    children
  } = _b2, otherProps = __objRest(_b2, [
    "size",
    "icon",
    "title",
    "description",
    "labelBtnSecondary",
    "labelBtnSuccess",
    "variantBtnSuccess",
    "onClickSuccess",
    "onClickClear",
    "showActions",
    "isLoadingSuccessBtn",
    "children"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)(import_react45.Flex, __spreadProps(__spreadValues({}, otherProps), { direction: "column", alignItems: "center", children: [
    mapSizetoImage[size] ? /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(EmptyStatePicture, {}) : mapSizetoIcon[size] && icon ? /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
      FeaturedIcons,
      {
        variant: "primary",
        icon,
        size: size === "sm" ? "lg" : "xl"
      }
    ) : null,
    /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)(import_react45.Flex, { direction: "column", alignItems: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        import_react45.Text,
        {
          variant: "medium",
          size: mapSizetoTitleText[size],
          color: "gray.900",
          mb: 2,
          mt: size === "lg" ? 8 : 5,
          children: title
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        import_react45.Text,
        {
          variant: "regular",
          size: mapSizetoDescriptionText[size],
          color: "gray.500",
          children: description
        }
      ),
      children
    ] }),
    showActions && /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)(import_react45.Flex, { mt: 6, gap: 3, children: [
      labelBtnSecondary && /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(import_react45.Button, { variant: "secondary", onClick: onClickClear, children: labelBtnSecondary }),
      /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        import_react45.Button,
        {
          variant: variantBtnSuccess,
          onClick: onClickSuccess,
          isLoading: isLoadingSuccessBtn,
          children: labelBtnSuccess
        }
      )
    ] })
  ] }));
};

// src/components/VerificationCode.tsx
var import_react46 = require("@chakra-ui/react");
var import_jsx_runtime48 = require("react/jsx-runtime");
var VerificationCode = (_a2) => {
  var _b2 = _a2, {
    verificationCodeLenght = 6,
    showHelperTextIcon = true,
    helperText,
    isSuccess,
    isInvalid,
    errorMessage,
    onComplete,
    spacing,
    isRequired,
    code,
    setCode
  } = _b2, rest = __objRest(_b2, [
    "verificationCodeLenght",
    "showHelperTextIcon",
    "helperText",
    "isSuccess",
    "isInvalid",
    "errorMessage",
    "onComplete",
    "spacing",
    "isRequired",
    "code",
    "setCode"
  ]);
  const showHelperText = !isSuccess && !isInvalid && helperText;
  const onChangeCode = (value) => {
    setCode(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)(import_react46.FormControl, { isInvalid, children: [
    /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_react46.HStack, { children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
      import_react46.PinInput,
      {
        onChange: onChangeCode,
        value: code,
        isInvalid,
        otp: true,
        placeholder: "",
        size: "lg",
        errorBorderColor: "error.300",
        focusBorderColor: "primary.300",
        type: "number",
        onComplete,
        children: [...Array(verificationCodeLenght)].map((_, index) => /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
          import_react46.PinInputField,
          {
            fontSize: "30px",
            padding: 2,
            color: "gray.900",
            borderRadius: "md",
            borderColor: "gray.300",
            _focusVisible: {
              ringColor: isSuccess ? "primary.700" : "black",
              ring: "1.5px",
              borderColor: "transparent"
            }
          },
          index
        ))
      }
    ) }),
    showHelperText && /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)(import_react46.Flex, { columnGap: "1", color: "gray.500", mt: 1.5, children: [
      showHelperTextIcon && /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_react46.Flex, { alignItems: "center", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(AlertIcon, { color: "currentColor" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_react46.FormHelperText, { color: "gray.500", mt: 0, children: helperText })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(FormErrorMessage, { mt: "1.5", children: errorMessage })
  ] });
};

// src/theme/theme.ts
var import_react49 = require("@chakra-ui/react");

// src/theme/borders/borders.ts
var borders = {
  "border-focus": "1.5px solid var(--chakra-colors-gray-900)"
};

// src/theme/components/badge.ts
var import_react47 = require("@chakra-ui/react");
var Badge2 = {
  baseStyle: {
    borderRadius: "lg",
    boxShadow: import_react47.theme.shadows.xs,
    fontFamily: "Larsseit",
    fontWeight: "400"
  },
  variants: {
    primary: {
      bg: "primary.600",
      color: "white",
      boxShadow: "xs",
      border: "primary.600",
      _focus: {
        shadowFocus: "primary"
      },
      _hover: {
        bg: "primary.700",
        border: "primary.700",
        boxShadowColor: "primary.700"
      },
      _active: {
        bg: "primary.800"
      },
      fontSize: "md",
      _disabled: {
        pointerEvents: "none",
        bg: "primary.200",
        border: "primary.200"
      }
    },
    secondary: {
      bg: "primary.50",
      color: "primary.700",
      fontSize: "sm",
      _hover: { color: "primary.800", bg: "primary.100" },
      _disabled: { color: "primary.300", bg: "primary.25" }
    },
    success: {
      color: "success.700",
      fontWeight: "normal",
      _hover: {
        color: "primary.800",
        textDecoration: "none"
      },
      _disabled: { color: "gray.300" }
    },
    error: {
      color: "success.700",
      _hover: { color: "success.800" },
      _disabled: { color: "success.300" }
    },
    info: {
      color: "warning.700",
      _hover: { color: "warning.800" },
      _disabled: { color: "warning-300" }
    },
    warning: {
      color: "error.700",
      _hover: { color: "error.800" },
      _disabled: { color: "error.300" }
    },
    gray: {
      color: "gray.500",
      _hover: {
        color: "gray.600"
      },
      _disabled: { color: "gray.300" }
    },
    purple: {
      color: "white",
      _hover: { color: "success.50" },
      _disabled: { color: "gray.300" }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
};
var badge_default = Badge2;

// src/theme/components/button.ts
var Button4 = {
  baseStyle: {
    borderRadius: "base",
    fontFamily: "Larsseit-medium",
    fontSize: "md",
    fontWeight: "500",
    _focusVisible: {
      ring: "2px"
    }
  },
  variants: {
    primary: {
      minWidth: "min-content",
      color: "content-invert",
      backgroundColor: "background-gray-default",
      _hover: {
        backgroundColor: "background-gray-hover"
      },
      _active: {
        backgroundColor: "background-gray-pressed",
        border: "3.5px solid border-color-focus"
      },
      _focus: {
        ring: 0,
        color: "none"
      },
      _focusVisible: {
        border: "2px",
        borderColor: "white",
        ringColor: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        backgroundColor: "background-disabled",
        color: "content-disabled",
        opacity: 1
      }
    },
    secondary: (config) => {
      const borderSize = "1px";
      const currentSize = config.size;
      const pxChakraName = config.theme.components.Button.sizes[currentSize].px;
      const chakraNameToPixels = (chakraName) => Number(chakraName) * 4;
      const pixelsValue = `${chakraNameToPixels(pxChakraName)}px`;
      const paddingXInPixels = `calc(${pixelsValue} - ${borderSize});`;
      return {
        minWidth: "min-content",
        color: "content-secondary",
        backgroundColor: "background-primary-default",
        border: `${borderSize} solid`,
        borderColor: "border-color-secondary",
        ringColor: "border-color-focus",
        px: paddingXInPixels,
        _hover: {
          backgroundColor: "background-primary-hover"
        },
        _focus: {
          ring: 0
        },
        _focusVisible: {
          border: "2px",
          borderColor: "white",
          ringColor: "border-color-focus"
        },
        _active: {
          color: "content-secondary",
          backgroundColor: "background-primary-pressed"
        },
        _disabled: {
          pointerEvents: "none",
          color: "content-disabled",
          borderColor: "border-color-disabled",
          backgroundColor: "background-disabled",
          opacity: 1
        },
        _loading: {
          color: "content-secondary"
        }
      };
    },
    destructive: {
      minWidth: "min-content",
      color: "content-invert",
      backgroundColor: "background-destructive-bold-default",
      ringColor: "border-color-focus",
      _hover: {
        backgroundColor: "background-destructive-bold-hover"
      },
      _focus: {
        ring: 0
      },
      _focusVisible: {
        border: "2px",
        borderColor: "white",
        ringColor: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        color: "content-disabled",
        borderColor: "border-color-disabled",
        backgroundColor: "background-disabled",
        opacity: 1
      },
      _active: { backgroundColor: "background-destructive-bold-pressed" },
      _loading: {
        color: "content-invert"
      }
    },
    tertiary: {
      minWidth: "min-content",
      color: "content-secondary",
      borderRadius: "4px",
      ringColor: "border-color-focus",
      _hover: {
        backgroundColor: "background-primary-hover"
      },
      _focus: {
        ring: 0
      },
      _focusVisible: {
        border: "2px",
        borderColor: "white",
        ringColor: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        color: "content-disabled",
        borderColor: "border-color-disabled",
        backgroundColor: "background-disabled",
        opacity: 1
      },
      _active: { backgroundColor: "background-primary-pressed" },
      _loading: {
        color: "content-secondary"
      }
    },
    linkPrimary: {
      maxHeight: "24px",
      minWidth: "min-content",
      padding: 0,
      color: "link-primary-default",
      textDecoration: "underline",
      _hover: {
        color: "link-primary-hover"
      },
      _focus: {
        ring: 0,
        color: "border-color-focus"
      },
      _focusVisible: {
        padding: "1px",
        ring: "2px",
        ringColor: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        color: "content-disabled",
        opacity: 1
      },
      _active: { color: "link-primary-pressed" }
    },
    linkSecondary: {
      maxHeight: "24px",
      minWidth: "min-content",
      padding: 0,
      color: "link-secondary-default",
      textDecoration: "underline",
      _hover: {
        color: "link-secondary-hover"
      },
      _focus: {
        ring: 0,
        color: "border-color-focus"
      },
      _focusVisible: {
        padding: "1px",
        ring: "2px",
        ringColor: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        color: "content-disabled",
        opacity: 1
      },
      _active: { color: "link-secondary-pressed" }
    },
    linkDestructive: {
      maxHeight: "24px",
      minWidth: "min-content",
      padding: 0,
      color: "link-destructive-default",
      textDecoration: "underline",
      _hover: {
        color: "link-destructive-hover"
      },
      _focus: {
        ring: 0,
        ringColor: "none"
      },
      _focusVisible: {
        padding: "1px",
        ring: "2px",
        ringColor: "border-color-focus",
        color: "border-color-focus"
      },
      _disabled: {
        pointerEvents: "none",
        color: "content-disabled",
        opacity: 1
      },
      _active: { color: "link-destructive-pressed" }
    }
  },
  sizes: {
    sm: {
      px: 3,
      py: 1.5,
      fontSize: "sm",
      borderRadius: "sm"
    },
    md: {
      px: 4,
      py: 2.5,
      fontSize: "md"
    },
    lg: {
      px: 5,
      py: 3,
      fontSize: "md",
      lineHeight: "28px"
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
};
var button_default = Button4;

// src/theme/components/checkbox.ts
var Checkbox2 = {
  baseStyle: {
    control: {
      _focus: {
        ring: 1,
        ringColor: "primary.700"
      },
      border: "1px solid var(--chakra-colors-gray-400)",
      borderColor: "var(--chakra-colors-gray-400)",
      borderRadius: "xs",
      _checked: {
        bg: "var(--chakra-colors-gray-700)",
        border: "0px",
        _hover: {
          border: "0px",
          bg: "var(--chakra-colors-gray-800)"
        }
      },
      _disabled: {
        borderColor: "1px solid var(--chakra-colors-gray-300)",
        border: "1px solid var(--chakra-colors-gray-300)",
        background: "var(--chakra-colors-gray-50)"
      }
    }
  }
};
var checkbox_default = Checkbox2;

// src/theme/components/form/formError.ts
var FormError = {
  baseStyle: {
    text: {
      fontFamily: "Larsseit",
      color: "content-destructive",
      fontSize: "sm",
      lineHeight: "20px",
      fontWeight: "400"
    },
    mt: "1.5"
  }
};

// src/theme/components/form/form.ts
var Form = {
  baseStyle: {
    helperText: {
      color: "gray.600",
      fontFamily: "Larsseit",
      fontSize: "sm",
      lineHeight: "20px",
      fontWeight: "400",
      mt: "1.5"
    }
  }
};

// src/theme/components/form/formLabel.ts
var FormLabel7 = {
  baseStyle: {
    fontFamily: "Larsseit-medium",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "0.875rem",
    lineHeight: "0.875rem",
    color: "content-secondary",
    marginBottom: "0.375rem",
    mb: "1.5",
    "&:first-letter": {
      textTransform: "uppercase"
    }
  },
  sizes: {
    //lg and md sizes are the same on purpose (they refer to md size). This is because we don't use lg size on labels but we need it to be defined anyways.
    lg: {
      fontSize: "1rem",
      lineHeight: "1rem"
    },
    md: {
      fontSize: "1rem",
      lineHeight: "1rem"
    },
    sm: {
      fontSize: "0.875rem",
      lineHeight: "0.875rem"
    },
    xs: {
      fontSize: "0.75rem",
      lineHeight: "0.75rem"
    }
  },
  variants: {
    regular: {
      fontWeight: "normal"
    },
    medium: {
      fontWeight: "medium",
      fontFamily: "Larsseit-medium"
    },
    mediumUnderline: {
      fontWeight: "medium",
      fontFamily: "Larsseit-medium",
      textDecoration: "underline"
    },
    bold: {
      fontWeight: "bold",
      fontFamily: "Larsseit-bold"
    }
  },
  defaultProps: {
    size: "sm",
    variant: "medium",
    color: "content-secondary",
    marginBottom: "0.375rem"
  }
};

// src/theme/components/form/input.ts
var Input4 = {
  baseStyle: {
    py: "2",
    px: "3",
    borderRadius: "md",
    borderColor: "gray.300",
    field: {
      border: "1px",
      borderColor: "gray.300",
      textColor: "gray.900",
      borderTopRightRadius: "md",
      borderBottomRightRadius: "md",
      _placeholder: {
        textColor: "gray.500"
      },
      _focusVisible: {
        border: "border-focus"
      },
      _invalid: {
        ringColor: "error.600",
        borderColor: "border-color-destructive"
      },
      _disabled: {
        opacity: 1,
        textColor: "content-disabled",
        borderColor: "content-disabled",
        _placeholder: {
          textColor: "content-disabled"
        },
        backgroundColor: "background-disabled"
      }
    },
    element: {
      h: "full"
    }
  },
  sizes: {
    sm: {
      field: {
        borderRadius: "md",
        fontSize: "14px",
        px: "10px",
        py: "6px"
      },
      element: {
        w: "36px"
      }
    },
    md: {
      field: {
        borderRadius: "md",
        fontSize: "16px",
        px: "12px",
        py: "8px"
      },
      element: {
        w: "40px"
      }
    },
    lg: {
      field: {
        borderRadius: "md",
        fontSize: "16px",
        px: "16px",
        py: "12px"
      },
      element: {
        w: "44px"
      }
    }
  },
  // default values for `size` and `variant`
  defaultProps: {
    size: "md",
    variant: ""
  }
};
var input_default = Input4;

// src/theme/components/link.ts
var Link = {
  baseStyle: {
    fontFamily: "Larsseit",
    fontWeight: "400",
    fontsize: "4",
    color: "gray.500",
    _hover: {
      color: "gray.700",
      textDecoration: "none"
    },
    _disabled: { color: "gray.300" }
  },
  sizes: {},
  variants: {
    success: {
      color: "success.500",
      _hover: { color: "success.700" },
      _disabled: { color: "success.300" }
    },
    warning: {
      color: "warning.500",
      _hover: { color: "warning.700" },
      _disabled: { color: "warning-300" }
    },
    error: {
      color: "error.500",
      _hover: { color: "error.700" },
      _disabled: { color: "error.300" }
    },
    gray: {
      color: "gray.500",
      border: "none",
      _hover: {
        color: "gray.700"
      },
      _disabled: { color: "gray.300" }
    },
    white: {
      color: "white",
      _hover: { color: "success.50" },
      _disabled: { color: "gray.300" }
    }
  },
  defaultProps: {}
};
var link_default = Link;

// src/theme/components/select.ts
var Select = {
  baseStyle: {
    borderRadius: "md",
    field: {
      border: "1px",
      borderColor: "gray.300",
      textColor: "gray.900",
      _placeholder: {
        textColor: "gray.500"
      },
      _focusVisible: {
        border: "border-focus"
      },
      _invalid: {
        ringColor: "error.50",
        borderColor: "error.300"
      },
      _disabled: {
        textColor: "gray.500",
        borderColor: "gray.300",
        backgroundColor: "gray.50"
      }
    }
  },
  sizes: {
    sm: {
      field: {
        borderRadius: "md",
        fontSize: "14px",
        px: "10px",
        py: "6px"
      }
    },
    md: {
      field: {
        borderRadius: "md",
        fontSize: "16px",
        px: "12px",
        py: "8px"
      }
    },
    lg: {
      field: {
        borderRadius: "md",
        fontSize: "16px",
        px: "16px",
        py: "12px"
      }
    }
  },
  // default values for `size` and `variant`
  defaultProps: {
    size: "md",
    variant: ""
  }
};
var select_default = Select;

// src/theme/components/textarea.ts
var Textarea = {
  baseStyle: {
    borderRadius: "md",
    border: "1px",
    color: "content-primary",
    fontSize: "md",
    backgroundColor: "background-primary-default",
    borderColor: "border-color-secondary",
    _placeholder: {
      textColor: "content-tertiary"
    },
    _focusVisible: {
      border: "border-focus"
    },
    _disabled: {
      textColor: "content-disabled",
      color: "content-disabled",
      borderColor: "border-disabled",
      _placeholder: {
        textColor: "content-tertiary"
      },
      backgroundColor: "background-disabled"
    },
    _invalid: {
      ringColor: "border-color-destructive",
      borderColor: "border-color-destructive"
    }
  },
  sizes: {
    md: {
      py: "2",
      px: "3"
    }
  },
  variants: {},
  defaultProps: {
    variant: "",
    size: "md"
  }
};
var textarea_default = Textarea;

// src/theme/components/tooltip.ts
var import_react48 = require("@chakra-ui/react");
var arrowBg = (0, import_react48.cssVar)("popper-arrow-bg");
var bg = (0, import_react48.cssVar)("tooltip-bg");
var Tooltip = {
  // Styles for the base style
  baseStyle: (props) => ({
    textColor: "white",
    fontFamily: "Larsseit-Medium",
    bg: bg.reference,
    [bg.variable]: "colors.gray.900",
    [arrowBg.variable]: bg.reference,
    py: 2,
    px: 3,
    borderRadius: "sm"
  }),
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {}
};
var tooltip_default = Tooltip;

// src/theme/components/heading.ts
var Heading = {
  baseStyle: {
    fontFamily: "Larsseit",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "1rem",
    lineHeight: "base",
    color: "content-primary"
  },
  sizes: {
    "2xl": {
      fontSize: "4.5rem",
      lineHeight: "6.75rem"
    },
    xl: {
      fontSize: "3.75rem",
      lineHeight: "5.5rem"
    },
    lg: {
      fontSize: "3rem",
      lineHeight: "4.5rem"
    },
    md: {
      fontSize: "2.25rem",
      lineHeight: "3.5rem"
    },
    sm: {
      fontSize: "1.875rem",
      lineHeight: "2.875rem"
    },
    xs: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem"
    }
  },
  variants: {
    regular: {
      fontWeight: "normal"
    },
    medium: {
      fontWeight: "medium",
      fontFamily: "Larsseit-medium"
    },
    bold: {
      fontWeight: "bold",
      fontFamily: "Larsseit-bold"
    }
  },
  defaultProps: {
    size: "md",
    variant: "medium"
  }
};
var heading_default = Heading;

// src/theme/components/text.ts
var Text6 = {
  baseStyle: {
    fontFamily: "Larsseit",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "content-primary"
  },
  sizes: {
    xl: {
      fontSize: "1.25rem",
      lineHeight: "1.5rem"
    },
    lg: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem"
    },
    md: {
      fontSize: "1rem",
      lineHeight: "1.5rem"
    },
    sm: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem"
    },
    xs: {
      fontSize: "0.75rem",
      lineHeight: "1rem"
    }
  },
  variants: {
    regular: {
      fontWeight: "normal"
    },
    medium: {
      fontWeight: "medium",
      fontFamily: "Larsseit-medium"
    },
    bold: {
      fontWeight: "bold",
      fontFamily: "Larsseit-bold"
    }
  },
  defaultProps: {
    size: "md",
    variant: "regular"
  }
};
var text_default = Text6;

// src/theme/components/table.ts
var baseStyle = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "separate",
    borderSpacing: 0,
    borderTop: "1px solid var(--chakra-colors-gray-200)",
    "@media only screen and (max-width: 800px)": {
      display: "block"
    }
  },
  thead: {
    "@media only screen and (max-width: 800px)": {
      display: "block",
      tr: {
        position: "absolute",
        top: "-9999px",
        left: "-9999px"
      }
    }
  },
  tbody: {
    "@media only screen and (max-width: 800px)": {
      display: "block"
    }
  },
  th: {
    height: "14px",
    fontSize: "14px",
    fontFamily: "Larsseit-medium",
    fontWeight: "500",
    textAlign: "start",
    bgColor: "gray.50",
    borderBottom: "1px solid var(--chakra-colors-gray-200)",
    textTransform: "none",
    "& > div": {
      height: "14px"
    },
    "@media only screen and (max-width: 800px)": {
      display: "block"
    }
  },
  td: {
    textAlign: "start",
    "@media only screen and (max-width: 800px)": {
      display: "flex",
      padding: 0,
      paddingBottom: "12px",
      flexDirection: "column",
      border: "none",
      whiteSpace: "normal",
      textAlign: "left",
      color: "gray.900",
      "&:before": {
        content: "attr(data-title)",
        paddingRight: "10px",
        whiteSpace: "nowrap",
        textAlign: "left",
        fontWeight: "500",
        fontFamily: "Larsseit-Medium",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontSize: "14px",
        color: "content-secondary"
      }
    }
  },
  tr: {
    _hover: {
      td: {
        bgColor: "gray.50"
      }
    },
    "&:not(:hover)": {
      td: {
        bgColor: "white"
      }
    },
    "@media only screen and (max-width: 800px)": {
      display: "block",
      border: "1px solid var(--chakra-colors-gray-200)",
      margin: "16px",
      padding: "12px",
      paddingBottom: 0,
      borderRadius: { base: "md", md: "lg" },
      overflow: "hidden",
      "td:last-child": {
        borderBottom: 0
      },
      _hover: {
        bgColor: "gray.50"
      }
    }
  },
  caption: {
    mt: 4,
    textAlign: "center",
    fontWeight: "medium"
  }
};
var sizes = {
  sm: {
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    th: {
      px: "6",
      py: "14px",
      lineHeight: "4",
      fontSize: "14px"
    },
    td: {
      px: "6",
      py: "3",
      lineHeight: "5",
      fontSize: "14px"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }
};
var Table = {
  variants: {
    simple: {
      td: {
        borderColor: "gray.200"
      },
      th: {
        color: "gray.500"
      }
    }
  },
  baseStyle,
  sizes,
  defaultProps: {
    size: "md",
    variant: "simple"
  }
};

// src/theme/components/radio.ts
var Radio = {
  baseStyle: {
    control: {
      backgroundColor: "white",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "gray.300",
      _hover: {
        backgroundColor: "gray.50",
        borderColor: "gray.500"
      },
      _focus: {
        backgroundColor: "white",
        borderColor: "gray.900"
      },
      _focusVisible: {
        backgroundColor: "white",
        borderColor: "gray.200",
        outlineColor: "gray.900"
      },
      _disabled: {
        backgroundColor: "gray.50",
        borderColor: "gray.200"
      }
    }
  },
  sizes: {
    sm: {
      control: {
        width: "16px",
        height: "16px"
      }
    },
    md: {
      control: {
        width: "20px",
        height: "20px"
      }
    }
  },
  defaultProps: {
    size: "sm"
  }
};
var radio_default = Radio;

// src/theme/components/divider.ts
var Divider2 = {
  baseStyle: {
    color: "border-color-primary",
    colorScheme: "border-color-primary",
    borderColor: "border-color-primary"
  }
};
var divider_default = Divider2;

// src/theme/components/spinner.ts
var Spinner = {
  baseStyle: {
    color: "content-accent"
  },
  variants: {
    success: {
      color: "content-accent"
    },
    secondary: {
      color: "content-secondary"
    },
    invert: {
      color: "content-invert"
    }
  }
};

// src/theme/components/menu/menu.ts
var Menu2 = {
  baseStyle: {
    list: {
      py: "4",
      borderRadius: "md",
      border: "none",
      bg: "background-primary-default",
      color: "content-secondary",
      fontFamily: "Larsseit",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "1.25rem",
      px: "8px"
    },
    item: {
      color: "content-secondary",
      fontSize: "16px",
      borderRadius: "sm",
      _hover: {
        bg: "background-primary-hover",
        color: "content-secondary"
      },
      "&:active": {
        color: "content-secondary",
        bg: "background-primary-pressed"
      },
      _focusVisible: {
        ringBorderColor: "border-color-focus"
      },
      _focus: {
        ringBorderColor: "border-color-focus"
      },
      _disabled: {
        color: "content-disabled",
        bg: "background-primary-default"
      }
    },
    groupTitle: {
      textTransform: "uppercase",
      color: "white",
      textAlign: "center",
      letterSpacing: "wider",
      opacity: "0.7"
    },
    command: {
      opacity: "0.8",
      fontFamily: "mono",
      fontSize: "sm",
      letterSpacing: "tighter",
      pl: "4",
      size: "16px"
    },
    divider: {
      color: "border-color-primary",
      colorScheme: "border-color-primary",
      borderColor: "border-color-primary"
    }
  }
};

// src/theme/components/avatar.ts
var Avatar = {
  parts: ["container"],
  baseStyle: {
    container: {
      fontFamily: "Larsseit",
      color: "content-primary",
      bg: "background-tertiary-default",
      _hover: {
        bg: "background-tertiary-hover"
      },
      _active: {
        bg: "background-tertiary-pressed"
      }
    }
  }
};

// src/theme/components/drawer.ts
var Drawer = {
  baseStyle: {
    dialogContainer: { bg: "content-terciary" },
    closeButton: {
      color: "content-terciary",
      _focus: {
        boxShadow: "none"
      }
    },
    header: {
      color: "content-primary",
      fontFamily: "Larsseit",
      fontSize: "1.5rem",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "2.25rem",
      padding: "1rem 1.75rem 32px 1rem"
    },
    body: {
      padding: "0 1.75rem 0 1rem"
    },
    footer: {
      padding: "0 1.75rem 1rem 1rem"
    }
  }
};

// src/theme/components/tabs.ts
var Tabs = {
  variants: {
    line: {
      tab: {
        color: "content-tertiary",
        _hover: {
          color: "content-primary",
          borderColor: "border-color-secondary-hover"
        },
        _focus: {
          backgroundColor: "transparent"
        },
        _selected: {
          borderColor: "border-color-brand",
          color: "content-primary",
          _hover: {
            borderColor: "border-color-brand"
          }
        }
      }
    }
  },
  baseStyle: {
    indicator: {
      mt: "-4px",
      height: "3px",
      bg: "border-color-brand",
      borderRadius: 0,
      zIndex: 1
    }
  }
};

// src/theme/components/switch.ts
var Switch = {
  baseStyle: {
    container: {},
    thumb: {
      backgroundColor: "background-primary-default"
    },
    track: {
      bg: "background-tertiary-default",
      _hover: { bg: "background-brand-default" },
      _focus: {
        border: "1.5px solid",
        borderColor: "background-primary-default",
        boxShadow: "none",
        outline: "2px solid",
        outlineColor: "border-color-focus"
      },
      _focusVisible: {
        border: "1.5px solid",
        borderColor: "background-primary-default",
        boxShadow: "none",
        outline: "2px solid",
        outlineColor: "border-color-focus"
      },
      _disabled: {
        bg: "primary.100",
        _hover: { bg: "primary.100" }
      },
      _checked: {
        bg: "background-gray-default",
        _hover: { bg: "background-gray-hover" },
        _disabled: {
          bg: "primary.100",
          _hover: { bg: "primary.100" }
        }
      }
    }
  }
};

// src/theme/components/index.ts
var components = {
  Avatar,
  Button: button_default,
  Input: input_default,
  Badge: badge_default,
  Form,
  Link: link_default,
  Select: select_default,
  Checkbox: checkbox_default,
  Textarea: textarea_default,
  Tooltip: tooltip_default,
  FormLabel: FormLabel7,
  FormError,
  Heading: heading_default,
  Text: text_default,
  Table,
  Radio: radio_default,
  Divider: divider_default,
  Spinner,
  Menu: Menu2,
  Drawer,
  Switch,
  Tabs
};
var components_default = components;

// src/theme/theme.ts
var themeColors = __spreadProps(__spreadValues({
  primary: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#E4E7EC",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  brand: {
    25: "#EBFCE8",
    50: "#D7FDD0",
    100: "#BEF8BA",
    200: "#84EC86",
    300: "#61D970",
    400: "#33C152",
    500: "#19A229",
    600: "#208433",
    700: "#1A6F29",
    800: "#0D4614",
    900: "#001D00"
  },
  error: {
    25: "#FFF4F4",
    50: "#FEDEDC",
    100: "#FEC9C4",
    200: "#FDB4AC",
    300: "#FC9F95",
    400: "#F87766",
    500: "#F25037",
    600: "#E62B0A",
    700: "#C72100",
    800: "#7B1700",
    900: "#330A00"
  },
  warning: {
    25: "#FFF7F0",
    50: "#FFEEDB",
    100: "#FEE5C6",
    200: "#FDDEB2",
    300: "#FDD89D",
    400: "#FACB74",
    500: "#F6BF4C",
    600: "#EDA526",
    700: "#DA8702",
    800: "#AB6900",
    900: "#332200"
  },
  success: {
    25: "#ECF7EE",
    50: "#DAF6DF",
    100: "#C7F4CF",
    200: "#B5F2C0",
    300: "#A2EFB1",
    400: "#7DE792",
    500: "#57D972",
    600: "#33C152",
    700: "#139B32",
    800: "#006719",
    900: "#00290A"
  },
  blue: {
    50: "#EFF8FF",
    700: "#175CD3"
  },
  "blue-gray": {
    50: "#F8F9FC",
    700: "#363F72"
  },
  "blue-light": {
    50: "#F0F9FF",
    700: "#026AA2"
  },
  indigo: {
    50: "#EEF4FF",
    700: "#3538CD"
  },
  purple: {
    50: "#F4F3FF",
    700: "#5925DC"
  },
  pink: {
    50: "#FDF2FA",
    700: "#C11574"
  },
  rose: {
    50: "#FFF1F3",
    700: "#C01048"
  },
  orange: {
    50: "#FFF6ED",
    700: "#C4320A"
  }
}, colorTokens), {
  white: "#FFFFFF",
  black: "#000000"
});
var _a, _b;
var theme2 = (0, import_react49.extendTheme)(
  {
    breakpoints: {
      sm: "30em",
      // 480px
      md: "40em",
      // 640px
      lg: "64em",
      // 1024px
      xl: "80em",
      // 1280px
      "2xl": "96em"
      // 1536px
    },
    colors: __spreadValues({}, themeColors),
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
      "7xl": "4.5rem",
      "8xl": "6rem",
      "9xl": "8rem"
    },
    shadows: {
      "3xl": "0 32px 64px rgba(16, 24, 40, 0.2)",
      "2xl": "0 24px 48px rgba(16, 24, 40, 0.25)",
      xl: "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(16, 24, 40, 0.12)",
      lg: "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(16, 24, 40, 0.08)",
      md: "0px 0px 4px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(16, 24, 40, 0.06)",
      sm: "0px 0px 6px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px 1px rgba(16, 24, 40, 0.08)",
      xs: "0px 1px 2px 1px #E4E7EC",
      "focus-primary": "0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px colors.primary.50",
      "focus-error": "0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px colors.error.100",
      "focus-secondary": "0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px colors.primary.50",
      "focus-secondary-gray": "0 1px 2px rgba(16, 24, 40, 0.05), 0 0 0 4px colors.gray.100"
    },
    fonts: {
      heading: `Larsseit, ${(_a = import_react49.theme.fonts) == null ? void 0 : _a.heading}`,
      body: `Larsseit, ${(_b = import_react49.theme.fonts) == null ? void 0 : _b.body}`
    },
    fontFamily: {
      sans: ["Larsseit", "sans-serif"]
    },
    borderWidth: {
      DEFAULT: "1px",
      0: "0",
      2: "2px",
      4: "4px",
      6: "6px",
      8: "8px",
      10: "10px"
    },
    radii: {
      base: "8px",
      xs: "4px",
      sm: "6px",
      md: "8px",
      lg: "12px",
      full: "9999px"
    },
    extend: {
      borderRadius: {
        DEFAULT: "3px"
      },
      keyframes: {
        "notification-in-right": {
          "0%": { transform: "translateX(100%)" },
          "100%": { transform: "translateX(0)" }
        },
        "notification-in-bottom": {
          "0%": { transform: "translateY(100%)" },
          "100%": { transform: "translateY(0)" }
        },
        "notification-out-right": {
          "0%": { transform: "translateX(0)" },
          "100%": { transform: "translateX(100%)" }
        }
      },
      animation: {
        "notification-in-right": "notification-in-right 0.5s ease-in-out",
        "notification-in-bottom": "notification-in-bottom 0.5s ease-in-out",
        "notification-out-right": "notification-out-right 0.5s ease-in-out"
      }
    },
    components: components_default,
    borders
  },
  (0, import_react49.withDefaultColorScheme)({
    colorScheme: "primary",
    components: ["Checkbox", "Radio", "Switch", "Slider", "Textarea"]
  }),
  (0, import_react49.withDefaultSize)({
    size: "md",
    components: ["Button", "Badge", "Checkbox", "Radio", "Switch", "Slider"]
  }),
  {
    components: {
      Checkbox: {
        parts: ["control"],
        baseStyle: {
          control: {
            _disabled: {
              bg: "white"
            },
            _focus: {
              ring: 2
            }
          }
        }
      }
    }
  }
);

// src/theme/ThemeProvider.tsx
var import_react50 = require("@chakra-ui/react");
var import_jsx_runtime49 = require("react/jsx-runtime");
var ThemeProvider = ({
  children,
  colorOverrides = {},
  theme: theme3 = theme2
}) => {
  const customColorTheme = (0, import_react50.extendTheme)(theme3, {
    colors: __spreadValues({}, colorOverrides)
  });
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(import_react50.ChakraProvider, { theme: customColorTheme, children });
};
var ThemeProvider_default = ThemeProvider;

// src/components/Breadcrumb.tsx
var import_react51 = require("@chakra-ui/react");
var import_react52 = require("react");
var import_fi4 = require("react-icons/fi");
var import_jsx_runtime50 = require("react/jsx-runtime");
var Breadcrumb = ({
  options,
  onNavigate,
  showHomeOnFirstItem = true
}) => {
  const [showCompleteRoute, setShowCompleteRoute] = (0, import_react52.useState)(false);
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  const compactRoute = isMobile && !showCompleteRoute;
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.Wrap, { alignItems: "center", spacingY: 6, spacingX: 3, children: options.map(
    (item, index) => index === 0 && showHomeOnFirstItem ? /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(import_react51.Flex, { gap: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.WrapItem,
        {
          alignItems: "center",
          alignContent: "center",
          width: "20px",
          height: "20px",
          children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
            import_react51.Icon,
            {
              as: import_fi4.FiHome,
              onClick: () => onNavigate(item.to),
              sx: {
                color: "gray.500",
                _hover: {
                  color: "gray.600"
                },
                _active: {
                  color: "gray.700"
                },
                width: "20px",
                height: "20px",
                cursor: "pointer"
              }
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", height: 4, width: 4, children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.Icon,
        {
          as: import_fi4.FiChevronRight,
          color: "border-color-secondary",
          height: 4,
          width: 4,
          marginTop: 1
        }
      ) })
    ] }, index) : index !== options.length - 1 ? /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_jsx_runtime50.Fragment, { children: compactRoute ? index === 1 && /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(import_react51.Flex, { gap: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.Button,
        {
          variant: "linkPrimary",
          size: "sm",
          onClick: () => setShowCompleteRoute(true),
          height: 6,
          top: 0,
          children: "..."
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", height: 4, width: 4, children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.Icon,
        {
          as: import_fi4.FiChevronRight,
          color: "border-color-secondary",
          marginTop: 1
        }
      ) })
    ] }, index) : /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(import_react51.Flex, { gap: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.Button,
        {
          variant: "linkPrimary",
          size: "sm",
          onClick: () => onNavigate(item.to),
          height: 6,
          top: 0,
          children: item.label
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", height: 4, width: 4, children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
        import_react51.Icon,
        {
          as: import_fi4.FiChevronRight,
          color: "border-color-secondary",
          marginTop: 1
        }
      ) })
    ] }, index) }) : /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_react51.WrapItem, { alignItems: "center", marginRight: 3, children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(ContainedText_default, { size: "sm", variant: "medium", color: "gray.700", children: item.label }) }, index)
  ) });
};
var Breadcrumb_default = Breadcrumb;

// src/components/Stepper/index.tsx
var import_react55 = require("@chakra-ui/react");

// src/components/Stepper/Step.tsx
var import_react54 = require("@chakra-ui/react");

// src/components/svg/WhiteCheck.tsx
var import_jsx_runtime51 = require("react/jsx-runtime");
var WhiteCheck = ({ size }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
    "svg",
    {
      width: size != null ? size : "12px",
      height: size != null ? size : "12px",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 12 12",
      fill: "none",
      children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        "path",
        {
          d: "M10 3L4.5 8.5L2 6",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
};

// src/components/Stepper/StepSeparator.tsx
var import_react53 = require("@chakra-ui/react");
var import_jsx_runtime52 = require("react/jsx-runtime");
var STEP_SEPARATOR_SIZE = {
  row: {
    height: "1px",
    width: "34px"
  },
  column: {
    height: "34px",
    width: "1px"
  }
};
var STEP_SEPARATOR_COLORS = {
  complete: "content-primary",
  active: "border-color-disabled",
  incomplete: "border-color-disabled"
};
var StepSeparator = (props) => {
  const { direction, status = "active" } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
    import_react53.Flex,
    {
      direction: direction != null ? direction : {
        base: "column",
        md: "row"
      },
      flex: "1 1 0%",
      borderRadius: "xs",
      minW: direction ? STEP_SEPARATOR_SIZE[direction].width : {
        base: "1px",
        md: "34px"
      },
      minH: direction ? STEP_SEPARATOR_SIZE[direction].height : {
        base: "34px",
        md: "1px"
      },
      width: "100%",
      borderColor: STEP_SEPARATOR_COLORS[status],
      bg: STEP_SEPARATOR_COLORS[status],
      height: "1px"
    }
  );
};
var StepSeparator_default = StepSeparator;

// src/components/Stepper/Step.tsx
var import_jsx_runtime53 = require("react/jsx-runtime");
var STATUS_STEP_COLORS = {
  complete: { color: "content-invert", bg: "background-gray-default" },
  active: { color: "content-invert", bg: "content-primary" },
  incomplete: { color: "content-disabled", bg: "background-disabled" }
};
var LEFT_ICON_SIZES = {
  sm: "18px",
  md: "24px"
};
var STEP_SEPARATOR_MARGIN = {
  sm: "9px",
  md: "12px"
};
var Step = (props) => {
  const {
    index,
    status,
    children,
    options,
    size,
    to,
    onNavigate,
    setStep,
    clickable,
    direction
  } = props;
  const isCompleteStatus = status === "complete";
  const isIncompleteStatus = status === "incomplete";
  const isRowDirection = direction === "row";
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsxs)(
    import_react54.Flex,
    {
      alignItems: direction ? {
        base: isRowDirection ? "center" : "start"
      } : {
        base: "start",
        md: "center"
      },
      direction: direction != null ? direction : { base: "column", md: "row" },
      gap: 2,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime53.jsxs)(import_react54.Flex, { gap: 2, alignItems: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
            import_react54.Flex,
            {
              width: LEFT_ICON_SIZES[size],
              height: LEFT_ICON_SIZES[size],
              borderRadius: "lg",
              justifyContent: "center",
              alignItems: "center",
              fontSize: size,
              color: STATUS_STEP_COLORS[status].color,
              bg: STATUS_STEP_COLORS[status].bg,
              children: isCompleteStatus ? /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(WhiteCheck, {}) : index + 1
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(import_react54.Box, { fontSize: size, minWidth: "min-content", children: /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
            import_react54.Button,
            {
              size,
              variant: "linkPrimary",
              cursor: clickable ? "pointer" : "default",
              onClick: () => {
                if (!clickable)
                  return;
                setStep(index + 1);
                if (to !== void 0 && to !== "") {
                  onNavigate(to);
                }
              },
              isDisabled: isIncompleteStatus,
              color: isIncompleteStatus ? STATUS_STEP_COLORS[status].color : void 0,
              _hover: isIncompleteStatus ? {} : void 0,
              textDecoration: isCompleteStatus && to !== void 0 ? "underline" : "none",
              children
            },
            index
          ) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
          import_react54.Box,
          {
            marginLeft: {
              base: isRowDirection ? 0 : STEP_SEPARATOR_MARGIN[size],
              md: !direction || isRowDirection ? 0 : STEP_SEPARATOR_MARGIN[size]
            },
            children: index + 1 < options.length && /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(StepSeparator_default, { status, direction })
          }
        )
      ]
    }
  );
};
var Step_default = Step;

// src/components/Stepper/index.tsx
var import_jsx_runtime54 = require("react/jsx-runtime");
var getStatus = (index, currentStep) => {
  let status = "incomplete";
  if (index + 1 < currentStep)
    status = "complete";
  if (index + 1 === currentStep)
    status = "active";
  if (index + 1 > currentStep)
    status = "incomplete";
  return status;
};
var Stepper = ({
  options,
  onNavigate,
  currentStep,
  setStep,
  clickable = true,
  size = "sm",
  direction
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    import_react55.Flex,
    {
      gap: 2,
      direction: direction != null ? direction : {
        base: "column",
        md: "row"
      },
      children: options.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
        import_react55.Flex,
        {
          alignItems: "start",
          direction: direction != null ? direction : {
            base: "column",
            md: "row"
          },
          gap: 2,
          children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
            Step_default,
            {
              index,
              size,
              children: item.label,
              options,
              to: item.to,
              setStep,
              onNavigate,
              clickable,
              direction,
              status: getStatus(index, currentStep)
            }
          )
        },
        index
      ))
    }
  );
};
var Stepper_default = Stepper;

// src/components/Table/Cell/RightAlignCell.tsx
var import_react56 = require("@chakra-ui/react");
var import_jsx_runtime55 = require("react/jsx-runtime");
var RightAlignCell = ({ content }) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_react56.Flex, { justifyContent: "flex-end", children: content });

// src/components/Table/Cell/TwoLinesCell.tsx
var import_react57 = require("@chakra-ui/react");
var import_jsx_runtime56 = require("react/jsx-runtime");
var TwoLinesCell = (_a2) => {
  var _b2 = _a2, { firstLine, secondLine } = _b2, rest = __objRest(_b2, ["firstLine", "secondLine"]);
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsxs)(import_react57.Flex, __spreadProps(__spreadValues({ flexDir: "column" }, rest), { gap: "4px", children: [
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(import_react57.Text, { variant: "medium", color: "gray.900", size: "sm", lineHeight: "14px", children: firstLine }),
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(import_react57.Text, { variant: "regular", color: "gray.500", size: "sm", lineHeight: "14px", children: secondLine })
  ] }));
};

// src/components/Table/TableWrapper.tsx
var import_react58 = require("@chakra-ui/react");
var import_jsx_runtime57 = require("react/jsx-runtime");
var TableWrapper = ({
  searchComponent,
  quickFilters,
  rightElement,
  children
}) => /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)(
  import_react58.TableContainer,
  {
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: { base: "md", md: "lg" },
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)(import_react58.Flex, { px: "6", py: "3", justifyContent: "space-between", children: [
        /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)(import_react58.Flex, { gap: "16px", children: [
          /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(import_react58.Box, { w: "320px", children: searchComponent }),
          quickFilters
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(import_react58.Flex, { children: rightElement })
      ] }),
      children
    ]
  }
);

// src/components/Table/Table.tsx
var import_react59 = require("@chakra-ui/react");
var import_fi5 = require("react-icons/fi");
var import_jsx_runtime58 = require("react/jsx-runtime");
function Table2({
  tableInstance,
  emptyStateContent,
  isLoading = false,
  isRowClickableCallback = () => true,
  handleRowClick
}) {
  var _a2;
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = tableInstance;
  const isEmpty = page.length === 0;
  const columnCount = ((_a2 = headerGroups[0]) == null ? void 0 : _a2.headers.length) || 0;
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsxs)(import_react59.Table, __spreadProps(__spreadValues({}, getTableProps()), { w: "full", children: [
    /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Thead, { children: headerGroups.map((headerGroup, index) => /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tr, __spreadProps(__spreadValues({}, headerGroup.getHeaderGroupProps()), { children: headerGroup.headers.map((column, i) => /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Th, { children: /* @__PURE__ */ (0, import_jsx_runtime58.jsxs)(import_react59.Flex, { gap: "4px", alignItems: "center", children: [
      column.render("Header"),
      " "
    ] }) }, `B${i}`)) }), `A${index}`)) }),
    isEmpty && !isLoading && /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tfoot, { children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tr, { children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Td, { colSpan: columnCount, children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Flex, { w: "full", justifyContent: "center", py: "40px", children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
      EmptyState,
      {
        title: emptyStateContent.title,
        size: "md",
        description: emptyStateContent.description,
        icon: import_fi5.FiSearch
      }
    ) }) }) }) }),
    isLoading ? /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tfoot, { children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tr, { children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Td, { colSpan: columnCount, children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Center, { w: "full", py: "40px", children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
      import_react59.Spinner,
      {
        "data-testid": "table-is-loading-data",
        color: "content-secondary"
      }
    ) }) }) }) }) : /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_react59.Tbody, __spreadProps(__spreadValues({}, getTableBodyProps()), { children: page.map((row) => {
      prepareRow(row);
      return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
        import_react59.Tr,
        __spreadProps(__spreadValues(__spreadValues({}, row.getRowProps()), isRowClickableCallback(row.original) && handleRowClick ? {
          onClick: () => handleRowClick(row.original),
          cursor: "pointer"
        } : {
          _hover: { bgColor: "auto" }
        }), {
          children: row.cells.map((cell, i) => {
            var _a3, _b2;
            const dataTitleValue = typeof cell.column.Header === "string" ? cell.column.Header : ((_b2 = (_a3 = cell.column.Header) == null ? void 0 : _a3.props) == null ? void 0 : _b2["data-header-text"]) || "";
            return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
              import_react59.Td,
              __spreadProps(__spreadValues({}, cell.getCellProps()), {
                "data-title": dataTitleValue,
                children: cell.render("Cell")
              }),
              `D${i}`
            );
          })
        }),
        `C${row.original.uuid}`
      );
    }) }))
  ] }));
}

// src/components/Alert.tsx
var import_react60 = require("@chakra-ui/react");
var import_react61 = require("react");
var import_fi6 = require("react-icons/fi");
var import_jsx_runtime59 = require("react/jsx-runtime");
var Alert = (_a2) => {
  var _b2 = _a2, {
    variant = "default",
    title,
    description,
    learnMoreButtonLabel = "Learn more",
    viewChangesButtonLabel = "View changes",
    onClickLearnMoreButton,
    onClickViewChangesButton,
    showCloseButton = true,
    icon
  } = _b2, otherProps = __objRest(_b2, [
    "variant",
    "title",
    "description",
    "learnMoreButtonLabel",
    "viewChangesButtonLabel",
    "onClickLearnMoreButton",
    "onClickViewChangesButton",
    "showCloseButton",
    "icon"
  ]);
  const [display, setDisplay] = (0, import_react61.useState)("flex");
  const mapVariantToBackgroundColor2 = {
    ["gray"]: "background-secondary-default",
    ["error"]: "background-destructive-default",
    ["warning"]: "background-warning-default",
    ["success"]: "background-success-default",
    ["default"]: "transparent"
  };
  const mapVariantToContentColor = {
    ["gray"]: "content-secondary",
    ["error"]: "content-destructive",
    ["warning"]: "content-warning",
    ["success"]: "content-success",
    ["default"]: "content-secondary"
  };
  const mapVariantToBorderColor = {
    ["gray"]: "border-color-secondary",
    ["error"]: "border-color-destructive",
    ["warning"]: "border-color-warning",
    ["success"]: "border-color-success",
    ["default"]: "transparent"
  };
  const mapVariantToIcon = {
    ["gray"]: import_fi6.FiInfo,
    ["error"]: import_fi6.FiAlertCircle,
    ["warning"]: import_fi6.FiAlertTriangle,
    ["success"]: import_fi6.FiCheckCircle,
    ["default"]: import_fi6.FiInfo
  };
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(
    import_react60.Flex,
    __spreadProps(__spreadValues({
      display,
      backgroundColor: mapVariantToBackgroundColor2[variant],
      borderLeftColor: mapVariantToBorderColor[variant],
      borderLeftWidth: "2px",
      borderRadius: "0px 8px 8px 0px",
      justifyContent: "space-between",
      padding: "4"
    }, otherProps), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_react60.Flex, { gap: "3", direction: ["column", "row"], rowGap: "3", children: [
          /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
            import_react60.Icon,
            {
              boxSize: "20px",
              as: icon != null ? icon : mapVariantToIcon[variant],
              color: mapVariantToContentColor[variant]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_react60.Flex, { direction: "column", gap: "1", children: [
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              import_react60.Text,
              {
                color: mapVariantToContentColor[variant],
                variant: "medium",
                size: "sm",
                children: title
              }
            ),
            description && /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              import_react60.Text,
              {
                color: mapVariantToContentColor[variant],
                size: "sm",
                whiteSpace: "break-spaces",
                children: description
              }
            ),
            (onClickLearnMoreButton || onClickViewChangesButton) && /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_react60.Flex, { gap: "4", mt: "3", children: [
              onClickLearnMoreButton && /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
                import_react60.Button,
                {
                  variant: "link",
                  onClick: onClickLearnMoreButton,
                  size: "sm",
                  children: learnMoreButtonLabel
                }
              ),
              onClickViewChangesButton && /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
                import_react60.Button,
                {
                  size: "sm",
                  variant: "link",
                  rightIcon: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(import_fi6.FiArrowRight, {}),
                  onClick: onClickViewChangesButton,
                  children: viewChangesButtonLabel
                }
              )
            ] })
          ] })
        ] }),
        showCloseButton && /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
          import_react60.Icon,
          {
            as: import_fi6.FiX,
            color: "content-tertiary",
            boxSize: "20px",
            onClick: () => setDisplay("none"),
            cursor: "pointer"
          }
        )
      ]
    })
  );
};

// src/components/RadioButton.tsx
var import_react62 = require("@chakra-ui/react");
var import_jsx_runtime60 = require("react/jsx-runtime");
var mapSizeToBorderWidthSize = {
  [SIZES.sm]: "5px",
  [SIZES.md]: "6px"
};
var RADIO_TEXT_STYLES = {
  text: {
    active: "content-primary",
    disabled: "content-disabled"
  },
  supportingText: {
    active: "content-secondary",
    disabled: "content-disabled"
  }
};
var RadioButton = ({
  label,
  value,
  supportingText,
  size = SIZES.sm,
  disabled = false,
  key
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(
    import_react62.Radio,
    {
      role: "radio",
      size,
      alignItems: "flex-start",
      value,
      disabled,
      isDisabled: disabled,
      borderColor: "border-color-secondary",
      backgroundColor: "background-primary-default",
      _hover: {
        backgroundColor: "background-primary-hover",
        borderColor: "border-color-secondary-hover",
        _disabled: {
          backgroundColor: "background-disabled",
          borderColor: "border-color-disabled"
        }
      },
      _disabled: {
        backgroundColor: "background-disabled",
        borderColor: "border-color-disabled"
      },
      _focus: {
        backgroundColor: "background-primary-default",
        borderColor: "border-color-secondary",
        boxShadow: `0 0 0 1px ${colorTokens["border-color-focus"]}`
      },
      _checked: {
        border: `${mapSizeToBorderWidthSize[size]} solid`,
        color: "content-invert",
        borderColor: "background-gray-hover",
        _hover: {
          borderColor: "background-gray-hover",
          _disabled: {
            border: `${mapSizeToBorderWidthSize[size]} solid`,
            backgroundColor: "content-disabled",
            borderColor: "border-color-disabled"
          }
        },
        _focus: { borderColor: "background-gray-hover" },
        _focusVisible: { borderColor: "background-gray-hover" },
        _disabled: {
          border: `${mapSizeToBorderWidthSize[size]} solid`,
          backgroundColor: "content-disabled",
          borderColor: "border-color-disabled"
        }
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          import_react62.Text,
          {
            color: disabled ? RADIO_TEXT_STYLES.text.disabled : RADIO_TEXT_STYLES.text.active,
            size,
            children: label
          }
        ),
        supportingText && /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          import_react62.Text,
          {
            variant: "regular",
            color: disabled ? RADIO_TEXT_STYLES.supportingText.disabled : RADIO_TEXT_STYLES.supportingText.active,
            size,
            children: supportingText
          }
        )
      ]
    },
    key
  );
};

// src/components/Divider.tsx
var import_react63 = require("@chakra-ui/react");
var import_jsx_runtime61 = require("react/jsx-runtime");
var Divider3 = (props) => {
  const { dividerContent } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsxs)(import_react63.Box, { position: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(import_react63.Divider, {}),
    dividerContent && /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(import_react63.AbsoluteCenter, { bg: "white", px: "4", children: dividerContent })
  ] });
};
var Divider_default = Divider3;

// src/components/Toast/index.tsx
var import_react64 = require("react");
var import_react65 = require("@chakra-ui/react");
var import_fi7 = require("react-icons/fi");
var import_jsx_runtime62 = require("react/jsx-runtime");
var Toast = (props) => {
  const { variant, featuredIcon, title, text, buttonLabel } = props;
  const [isClose, setIsClose] = (0, import_react64.useState)(false);
  const closeToast = () => setIsClose((prev) => !prev);
  const leftIcon = /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
    FeaturedIcons,
    {
      shape: "circle",
      variant: variant != null ? variant : "primary",
      size: "md",
      icon: featuredIcon
    }
  );
  const mainContent = /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(import_react65.Flex, { direction: "column", alignItems: "start", children: [
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
      import_react65.Text,
      {
        size: "sm",
        variant: "medium",
        color: "content-primary",
        display: title ? "block" : "none",
        children: title
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
      import_react65.Text,
      {
        size: "sm",
        variant: "regular",
        color: "content-tertiary",
        display: text ? "block" : "none",
        children: text
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
      import_react65.Button,
      {
        size: "sm",
        padding: 0,
        variant: "linkSecondary",
        color: "link-secondary-default",
        display: buttonLabel ? "block" : "none",
        children: buttonLabel
      }
    )
  ] });
  const closeButton = /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
    import_react65.Icon,
    {
      onClick: () => closeToast(),
      as: import_fi7.FiX,
      color: "content-tertiary",
      boxSize: "24px",
      _hover: { cursor: "pointer" }
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(
    import_react65.Flex,
    {
      bg: "background-primary-default",
      borderRadius: "lg",
      padding: 4,
      boxShadow: "lg",
      maxWidth: "100%",
      width: "sm",
      display: isClose ? "none" : "block",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(import_react65.Box, { display: { base: "block", md: "none" }, children: [
          /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(
            import_react65.Flex,
            {
              justifyContent: "space-between",
              marginBottom: 4,
              alignItems: "start",
              children: [
                leftIcon,
                closeButton
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(import_react65.Box, { padding: 1, children: mainContent })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(import_react65.Box, { display: { base: "none", md: "flex" }, gap: 4, alignItems: "start", children: [
          /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(import_react65.Box, { display: "block", children: leftIcon }),
          mainContent,
          closeButton
        ] })
      ]
    }
  );
};
var Toast_default = Toast;

// src/components/hooks/useToast.tsx
var import_react66 = require("@chakra-ui/react");
var import_jsx_runtime63 = require("react/jsx-runtime");
var useToast = () => {
  const chakraToast = (0, import_react66.useToast)();
  return (_a2) => {
    var _b2 = _a2, {
      title,
      text,
      variant,
      featuredIcon,
      buttonLabel
    } = _b2, chakraToastArgs = __objRest(_b2, [
      "title",
      "text",
      "variant",
      "featuredIcon",
      "buttonLabel"
    ]);
    return chakraToast(__spreadProps(__spreadValues({}, chakraToastArgs), {
      position: "top-right",
      render: () => /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
        Toast_default,
        {
          title,
          variant,
          featuredIcon,
          text,
          buttonLabel
        }
      )
    }));
  };
};

// src/index.tsx
var import_react_hook_form9 = require("react-hook-form");

// src/components/FileUpload/index.tsx
var import_react70 = require("@chakra-ui/react");
var import_react71 = require("react");

// src/components/FileUpload/FileUploadError.tsx
var import_react67 = require("@chakra-ui/react");
var import_fi8 = require("react-icons/fi");
var import_jsx_runtime64 = require("react/jsx-runtime");
var FileError = (props) => {
  const {
    fileName,
    onClick = () => alert("Upload again"),
    tryAgainMessage,
    errors,
    onDeleteFileHandler
  } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(
    import_react67.Flex,
    {
      borderRadius: "base",
      p: 4,
      border: "1px solid",
      borderColor: "border-color-primary",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(import_react67.Flex, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
            FeaturedIcons,
            {
              size: "md",
              shape: "circle",
              variant: "destructive",
              icon: FileAttachmentErrorIcon
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(import_react67.Box, { ml: "3.5", children: [
            errors.map((error) => /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_react67.Text, { fontSize: "sm", variant: "medium", color: "content-destructive", children: error })),
            /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_react67.Text, { fontSize: "sm", variant: "regular", color: "content-destructive", children: fileName }),
            /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
              import_react67.Button,
              {
                size: "sm",
                variant: "linkSecondary",
                mt: 1,
                onClick: () => onClick(),
                color: "content-tertiary",
                leftIcon: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_fi8.FiRotateCcw, {}),
                children: tryAgainMessage
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_react67.Button, { variant: "linkSecondary", onClick: onDeleteFileHandler, size: "sm", children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_fi8.FiTrash2, { size: "1.25rem" }) })
      ]
    }
  );
};

// src/components/FileUpload/FileUploadSuccess.tsx
var import_react68 = require("@chakra-ui/react");
var import_fi9 = require("react-icons/fi");
var import_jsx_runtime65 = require("react/jsx-runtime");
var convertBytesToMb = (bytes) => bytes / 1e6;
var FileSuccess = (props) => {
  const { files, onDeleteFileHandler, isLoading } = props;
  const formatFileSize = convertBytesToMb(files[0].size).toLocaleString(
    "es-AR"
  );
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsxs)(
    import_react68.Flex,
    {
      borderRadius: "base",
      p: 4,
      border: "1px solid",
      borderColor: "border-color-primary",
      gap: 3,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_react68.Box, { children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          FeaturedIcons,
          {
            size: "md",
            shape: "circle",
            variant: "primary",
            icon: FileAttachmentIcon
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsxs)(import_react68.Flex, { direction: "column", gap: 2, isTruncated: true, children: [
          /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
            import_react68.Button,
            {
              variant: "link",
              fontSize: "sm",
              color: "link-secondary-default",
              isTruncated: true,
              minW: "min-content",
              children: files[0].name
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime65.jsxs)(
            import_react68.Text,
            {
              fontSize: "sm",
              color: "content-tertiary",
              size: "xs",
              variant: "regular",
              children: [
                formatFileSize,
                " MB"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_react68.Flex, { marginLeft: "auto", alignItems: "start", children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_react68.Center, { children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_react68.Spinner, { variant: "line-simple", size: "sm" }) }) : /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          import_react68.Button,
          {
            variant: "linkSecondary",
            onClick: onDeleteFileHandler,
            size: "sm",
            children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_fi9.FiTrash2, { size: "1.25rem" })
          }
        ) })
      ]
    }
  );
};

// src/components/FileUpload/index.tsx
var import_react_dropzone = require("react-dropzone");

// src/components/FileUpload/FileUploadEmpty.tsx
var import_react69 = require("@chakra-ui/react");
var import_jsx_runtime66 = require("react/jsx-runtime");
var FileUploadEmpty = (props) => {
  const {
    getInputProps,
    multiple = false,
    disabled,
    clickHereMessage,
    orDropTheFileMessage,
    maxSize,
    getRootProps,
    supportedFileTypes = "PDF, PNG, o JPG"
  } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
    import_react69.FormControl,
    __spreadProps(__spreadValues({}, getRootProps()), {
      bg: disabled ? "background-tertiary-default" : "background-primary-default",
      children: /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(
        import_react69.Flex,
        {
          border: "1px",
          borderStyle: "dashed",
          borderColor: disabled ? "border-color-disabled" : "border-color-primary",
          borderRadius: "base",
          alignItems: "center",
          padding: 4,
          _hover: { cursor: disabled ? "not-allowed" : "pointer" },
          gap: 3,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
              import_react69.Input,
              __spreadProps(__spreadValues({}, getInputProps()), {
                type: "file",
                multiple,
                hidden: true,
                disabled,
                isDisabled: disabled,
                size: "sm"
              })
            ),
            /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
              FeaturedIcons,
              {
                size: "md",
                variant: disabled ? "disabled" : "primary",
                shape: "circle",
                icon: FileAttachmentIcon
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(import_react69.Flex, { direction: "column", children: [
              /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(import_react69.Flex, { direction: "row", alignItems: "center", children: [
                /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
                  import_react69.Button,
                  {
                    isDisabled: disabled,
                    size: "sm",
                    variant: "linkSecondary",
                    marginRight: 1,
                    color: disabled ? "content-disabled" : "link-secondary-default",
                    children: clickHereMessage
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
                  import_react69.Text,
                  {
                    size: "sm",
                    variant: "regular",
                    minW: "max-content",
                    color: disabled ? "content-disabled" : "content-tertiary",
                    children: orDropTheFileMessage
                  }
                )
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(
                import_react69.Text,
                {
                  size: "sm",
                  variant: "regular",
                  minW: "max-content",
                  color: disabled ? "content-disabled" : "content-tertiary",
                  children: [
                    supportedFileTypes,
                    " ",
                    maxSize ? `(max. ${maxSize}MB)` : "(max. 20MB)"
                  ]
                }
              )
            ] })
          ]
        }
      )
    })
  );
};
var FileUploadEmpty_default = FileUploadEmpty;

// src/components/FileUpload/index.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var convertMbToBytes = (mb) => mb * 1e6;
var FileUpload = (params) => {
  const _a2 = params, {
    isLoadingUpload = false,
    isLoadingDelete = false,
    multiple = false,
    accept = {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"]
    },
    disabled,
    required,
    maxFiles = 1,
    maxSize = 20,
    noClick = false,
    noKeyboard = false,
    noDrag = false,
    clickHereMessage = "Click here",
    label = "Upload file",
    orDropTheFileMessage = "or drop the file",
    tryAgainMessage = "Upload again",
    files,
    setFiles,
    fileInvalidTypeMessage = "The file is invalid",
    fileTooLargeMessage = "The file is too large",
    fileTooSmallMessage = "The file is too small",
    tooManyFilesMessage = "Too many files",
    tryAgainAction,
    width = "100%"
  } = _a2, rest = __objRest(_a2, [
    "isLoadingUpload",
    "isLoadingDelete",
    "multiple",
    "accept",
    "disabled",
    "required",
    "maxFiles",
    "maxSize",
    "noClick",
    "noKeyboard",
    "noDrag",
    "clickHereMessage",
    "label",
    "orDropTheFileMessage",
    "tryAgainMessage",
    "files",
    "setFiles",
    "fileInvalidTypeMessage",
    "fileTooLargeMessage",
    "fileTooSmallMessage",
    "tooManyFilesMessage",
    "tryAgainAction",
    "width"
  ]);
  const [errors, setErrors] = (0, import_react71.useState)();
  const DROPZONE_ERRORS_BY_CODE = {
    "file-invalid-type": fileInvalidTypeMessage,
    "file-too-large": fileTooLargeMessage,
    "file-too-small": fileTooSmallMessage,
    "too-many-files": tooManyFilesMessage
  };
  const onDropFunction = (acceptedFiles, fileRejections) => {
    setFiles(acceptedFiles);
    if (fileRejections.length) {
      fileRejections.forEach(({ file, errors: errors2 }, index) => {
        const isFirstError = !index;
        const errorMessagesForFileName = errors2.map(
          ({ code }) => DROPZONE_ERRORS_BY_CODE[code]
        );
        if (isFirstError) {
          setFiles([file]);
        }
        setErrors(errorMessagesForFileName);
      });
    }
  };
  const onDrop = (0, import_react71.useCallback)(onDropFunction, []);
  const { getRootProps, getInputProps } = (0, import_react_dropzone.useDropzone)({
    noKeyboard,
    maxFiles,
    maxSize: convertMbToBytes(maxSize),
    noClick,
    noDrag,
    disabled,
    onDrop,
    accept
  });
  const onDeleteFileHandler = () => {
    setFiles([]);
    setErrors([]);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)(import_react70.FormControl, __spreadProps(__spreadValues({ minW: "min-content", w: width, isRequired: required }, rest), { children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(import_react70.FormLabel, { children: label }) : null,
    typeof files === null || !(files == null ? void 0 : files.length) ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
      FileUploadEmpty_default,
      {
        getInputProps,
        getRootProps,
        multiple,
        disabled,
        clickHereMessage,
        orDropTheFileMessage,
        maxSize
      }
    ) : null,
    files && files.length > 0 && !(errors == null ? void 0 : errors.length) ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
      FileSuccess,
      {
        files,
        onDeleteFileHandler,
        isLoading: isLoadingUpload || isLoadingDelete
      }
    ) : null,
    (errors == null ? void 0 : errors.length) && files ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
      FileError,
      {
        errors,
        tryAgainMessage,
        fileName: files[0].name,
        onDeleteFileHandler,
        onClick: tryAgainAction
      }
    ) : null
  ] }));
};

// src/components/DropzoneField/index.tsx
var import_react75 = require("@chakra-ui/react");
var import_react76 = require("react");

// src/components/DropzoneField/DropzoneError.tsx
var import_react72 = require("@chakra-ui/react");
var import_fi10 = require("react-icons/fi");
var import_jsx_runtime68 = require("react/jsx-runtime");
var DropzoneError = (props) => {
  const { fileName, tryAgainMessage, errors, onDeleteFileHandler } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(
    import_react72.Flex,
    {
      borderRadius: "base",
      p: 4,
      border: "1px solid",
      borderColor: "border-color-primary",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(import_react72.Flex, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
            FeaturedIcons,
            {
              size: "md",
              shape: "circle",
              variant: "destructive",
              icon: FileAttachmentErrorIcon
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(import_react72.Box, { ml: "3.5", children: [
            errors.map((error) => /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
              import_react72.Text,
              {
                fontSize: "sm",
                variant: "medium",
                color: "content-destructive",
                children: error
              },
              error
            )),
            /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(import_react72.Text, { fontSize: "sm", variant: "regular", color: "content-destructive", children: fileName }),
            /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
              import_react72.Button,
              {
                size: "sm",
                variant: "linkSecondary",
                mt: 1,
                color: "content-tertiary",
                leftIcon: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(import_fi10.FiRotateCcw, {}),
                children: tryAgainMessage
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(import_react72.Button, { variant: "linkSecondary", onClick: onDeleteFileHandler, size: "sm", children: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(import_fi10.FiTrash2, { size: "1.25rem" }) })
      ]
    }
  );
};

// src/components/DropzoneField/DropzoneSuccess.tsx
var import_react73 = require("@chakra-ui/react");
var import_fi11 = require("react-icons/fi");
var import_jsx_runtime69 = require("react/jsx-runtime");
var convertBytesToMb2 = (bytes) => bytes / 1e6;
var DropzoneSuccess = (props) => {
  const { files, onDeleteFileHandler, isLoading } = props;
  const formatFileSize = convertBytesToMb2(files[0].size).toLocaleString(
    "es-AR"
  );
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)(
    import_react73.Flex,
    {
      p: 4,
      border: "1px solid",
      borderColor: "border-color-primary",
      gap: 3,
      borderRadius: "base",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(import_react73.Box, { children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
          FeaturedIcons,
          {
            size: "md",
            shape: "circle",
            variant: "primary",
            icon: FileAttachmentIcon
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)(import_react73.Flex, { direction: "column", gap: 2, isTruncated: true, children: [
          /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
            import_react73.Button,
            {
              variant: "link",
              minW: "min-content",
              borderRadius: 0,
              whiteSpace: "normal",
              height: "auto",
              blockSize: "auto",
              children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
                import_react73.Text,
                {
                  isTruncated: true,
                  color: "link-secondary-default",
                  variant: "link",
                  fontSize: "sm",
                  children: files[0].name
                }
              )
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)(
            import_react73.Text,
            {
              fontSize: "sm",
              color: "content-tertiary",
              size: "xs",
              variant: "regular",
              children: [
                formatFileSize,
                " MB"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(import_react73.Flex, { marginLeft: "auto", alignItems: "start", children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(import_react73.Center, { children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(import_react73.Spinner, { variant: "line-simple", size: "sm" }) }) : /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
          import_react73.Button,
          {
            variant: "linkSecondary",
            onClick: onDeleteFileHandler,
            size: "sm",
            children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(import_fi11.FiTrash2, { size: "1.25rem" })
          }
        ) })
      ]
    }
  );
};

// src/components/DropzoneField/index.tsx
var import_react_dropzone2 = require("react-dropzone");

// src/components/DropzoneField/DropzoneEmpty.tsx
var import_react74 = require("@chakra-ui/react");
var import_jsx_runtime70 = require("react/jsx-runtime");
var DropzoneEmpty = (props) => {
  const {
    getInputProps,
    multiple = false,
    disabled,
    clickHereMessage,
    orDropTheFileMessage,
    maxSize,
    getRootProps,
    onChange,
    onBlur,
    name,
    supportedFileTypes = "PDF, PNG, o JPG"
  } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
    import_react74.FormControl,
    __spreadProps(__spreadValues({}, getRootProps()), {
      bg: disabled ? "background-tertiary-default" : "background-primary-default",
      children: /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(
        import_react74.Flex,
        {
          border: "1px",
          borderStyle: "dashed",
          borderColor: disabled ? "border-color-disabled" : "border-color-primary",
          borderRadius: "base",
          alignItems: "center",
          padding: 4,
          _hover: { cursor: disabled ? "not-allowed" : "pointer" },
          gap: 3,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
              import_react74.Input,
              __spreadValues({
                type: "file",
                multiple,
                hidden: true,
                disabled,
                isDisabled: disabled,
                size: "sm",
                name
              }, getInputProps({ onChange, onBlur }))
            ),
            /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
              FeaturedIcons,
              {
                size: "md",
                variant: disabled ? "disabled" : "primary",
                shape: "circle",
                icon: FileAttachmentIcon
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(import_react74.Flex, { direction: "column", children: [
              /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(import_react74.Flex, { direction: "row", alignItems: "center", children: [
                /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
                  import_react74.Button,
                  {
                    isDisabled: disabled,
                    size: "sm",
                    variant: "linkSecondary",
                    marginRight: 1,
                    color: disabled ? "content-disabled" : "link-secondary-default",
                    children: clickHereMessage
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
                  import_react74.Text,
                  {
                    size: "sm",
                    variant: "regular",
                    minW: "max-content",
                    color: disabled ? "content-disabled" : "content-tertiary",
                    children: orDropTheFileMessage
                  }
                )
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(
                import_react74.Text,
                {
                  size: "sm",
                  variant: "regular",
                  minW: "max-content",
                  color: disabled ? "content-disabled" : "content-tertiary",
                  children: [
                    supportedFileTypes,
                    " ",
                    maxSize ? `(max. ${maxSize}MB)` : "(max. 20MB)"
                  ]
                }
              )
            ] })
          ]
        }
      )
    })
  );
};
var DropzoneEmpty_default = DropzoneEmpty;

// src/components/DropzoneField/index.tsx
var import_react_hook_form5 = require("react-hook-form");
var import_lodash4 = __toESM(require("lodash.get"));
var import_jsx_runtime71 = require("react/jsx-runtime");
var convertMbToBytes2 = (mb) => mb * 1e6;
var DropzoneField = (props) => {
  const _a2 = props, {
    name,
    label = "Upload file",
    multiple = false,
    accept = {
      "image/*": [".jpeg", ".jpg", ".png"],
      "application/pdf": [".pdf"]
    },
    disabled = false,
    maxFiles = 1,
    maxSize = 20,
    noClick = false,
    noKeyboard = false,
    noDrag = false,
    clickHereMessage = "Click here",
    orDropTheFileMessage = "or drop the file",
    tryAgainMessage = "Upload again",
    fileInvalidTypeMessage = "The file is invalid",
    fileTooLargeMessage = "The file is too large",
    fileTooSmallMessage = "The file is too small",
    tooManyFilesMessage = "Too many files",
    helperText,
    rhfOptions,
    setValueAsBase64 = false,
    fileObjectCallback,
    errorMessageFormatter = (message) => message,
    files,
    setFiles,
    isLoading = false,
    onDeleteClick,
    supportedFileTypes
  } = _a2, rest = __objRest(_a2, [
    "name",
    "label",
    "multiple",
    "accept",
    "disabled",
    "maxFiles",
    "maxSize",
    "noClick",
    "noKeyboard",
    "noDrag",
    "clickHereMessage",
    "orDropTheFileMessage",
    "tryAgainMessage",
    "fileInvalidTypeMessage",
    "fileTooLargeMessage",
    "fileTooSmallMessage",
    "tooManyFilesMessage",
    "helperText",
    "rhfOptions",
    "setValueAsBase64",
    "fileObjectCallback",
    "errorMessageFormatter",
    "files",
    "setFiles",
    "isLoading",
    "onDeleteClick",
    "supportedFileTypes"
  ]);
  const formMethods = (0, import_react_hook_form5.useFormContext)();
  if (!formMethods) {
    throw new Error(
      `DropzoneField component Must be used within react-hook-form "FormProvider"`
    );
  }
  const { errors } = (0, import_react_hook_form5.useFormState)();
  const rhfLocalStateErrors = errors;
  const isRequired = Boolean(rhfOptions == null ? void 0 : rhfOptions.required);
  const fieldError = (0, import_lodash4.default)(rhfLocalStateErrors, name, null);
  const isInvalid = Boolean(fieldError);
  const isValid = !isInvalid;
  const errorMessage = errorMessageFormatter(
    (0, import_lodash4.default)(fieldError, "message", "")
  );
  const showHelperText = isValid && helperText;
  const [dropzoneStateErrors, setDropzoneStateErrors] = (0, import_react76.useState)();
  const hasDropzoneStateErrors = Boolean(dropzoneStateErrors == null ? void 0 : dropzoneStateErrors.length);
  const hasRhfLocalStateErrors = Boolean(rhfLocalStateErrors == null ? void 0 : rhfLocalStateErrors.length);
  const hasLoadedFiles = files == null ? void 0 : files.length;
  const shouldRenderIdleStateDropzone = !hasLoadedFiles && !hasRhfLocalStateErrors && !hasDropzoneStateErrors;
  const shouldRenderSuccessStateDropzone = hasLoadedFiles && !hasRhfLocalStateErrors && !hasDropzoneStateErrors;
  const DROPZONE_ERRORS_BY_CODE = {
    "file-invalid-type": fileInvalidTypeMessage,
    "file-too-large": fileTooLargeMessage,
    "file-too-small": fileTooSmallMessage,
    "too-many-files": tooManyFilesMessage
  };
  const { control, setValue } = (0, import_react_hook_form5.useFormContext)();
  const onDropFunction = (acceptedFiles, fileRejections) => {
    setFiles(acceptedFiles);
    if ((acceptedFiles == null ? void 0 : acceptedFiles.length) && !(fileRejections == null ? void 0 : fileRejections.length)) {
      setValue(name, acceptedFiles, {
        shouldValidate: true
      });
    }
    if (fileRejections == null ? void 0 : fileRejections.length) {
      fileRejections.forEach(({ file, errors: errors2 }, index) => {
        const isFirstError = !index;
        const errorMessagesForFileName = errors2.map(
          ({ code }) => DROPZONE_ERRORS_BY_CODE[code]
        );
        if (isFirstError) {
          setFiles([file]);
        }
        setDropzoneStateErrors(errorMessagesForFileName);
        formMethods.setError(name, {
          type: "FileError",
          message: errorMessagesForFileName.join(",")
        });
        formMethods.trigger(name);
      });
    }
  };
  const onDrop = (0, import_react76.useCallback)(onDropFunction, []);
  const { getRootProps, getInputProps } = (0, import_react_dropzone2.useDropzone)({
    noKeyboard,
    maxFiles,
    maxSize: convertMbToBytes2(maxSize),
    noClick,
    noDrag,
    disabled,
    onDrop,
    accept
  });
  const onDeleteFileHandler = () => {
    setValue(name, []);
    setFiles([]);
    setDropzoneStateErrors([]);
    onDeleteClick && onDeleteClick();
  };
  const setValueAsB64 = (fieldName, callback) => (files2) => {
    const isAlreadyB64 = typeof files2 === "string";
    if (isAlreadyB64) {
      return files2;
    }
    const theFile = files2 == null ? void 0 : files2[0];
    if (!(files2 == null ? void 0 : files2[0]))
      return Promise.resolve(null);
    getBase64FromFile(theFile, {
      removeMetadata: true
    }).then((b64File) => {
      setValue(fieldName, b64File);
      if (callback) {
        callback(theFile);
      }
      formMethods.trigger(fieldName);
    });
  };
  const { field } = (0, import_react_hook_form5.useController)({
    name,
    control,
    rules: __spreadValues(__spreadProps(__spreadValues({}, rhfOptions), {
      validate: () => !(dropzoneStateErrors == null ? void 0 : dropzoneStateErrors.length)
    }), setValueAsBase64 ? { setValueAs: setValueAsB64(name, fileObjectCallback) } : {})
  });
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsxs)(
    import_react75.FormControl,
    __spreadProps(__spreadValues({
      width: "100%",
      maxW: "Calc(100vw - 32px)",
      isRequired
    }, rest), {
      isInvalid,
      children: [
        label ? /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(import_react75.FormLabel, { htmlFor: name, children: label }) : null,
        shouldRenderIdleStateDropzone ? /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
          DropzoneEmpty_default,
          {
            getInputProps,
            getRootProps,
            multiple,
            disabled,
            clickHereMessage,
            orDropTheFileMessage,
            maxSize,
            onChange: field.onChange,
            onBlur: field.onBlur,
            name,
            supportedFileTypes
          }
        ) : null,
        shouldRenderSuccessStateDropzone ? /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
          DropzoneSuccess,
          {
            files,
            onDeleteFileHandler,
            isLoading
          }
        ) : null,
        (dropzoneStateErrors == null ? void 0 : dropzoneStateErrors.length) && hasLoadedFiles ? /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
          DropzoneError,
          {
            errors: dropzoneStateErrors,
            tryAgainMessage,
            fileName: files[0].name,
            onDeleteFileHandler
          }
        ) : null,
        showHelperText && /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(import_react75.FormHelperText, { children: helperText }),
        /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(FormErrorMessage, { children: errorMessage })
      ]
    })
  );
};

// src/components/Navigation/index.tsx
var import_react82 = require("@chakra-ui/react");

// src/components/Navigation/NavigationInDesktop.tsx
var import_react79 = require("@chakra-ui/react");

// src/components/Tabs.tsx
var import_react77 = require("@chakra-ui/react");
var import_react78 = require("react");
var import_jsx_runtime72 = require("react/jsx-runtime");
var showTabHandler = (isMobile, hiddenInMobile = false, hiddenInDesktop = false) => {
  return isMobile ? !hiddenInMobile : !hiddenInDesktop;
};
var Tabs2 = (props) => {
  const _a2 = props, {
    tabsProps,
    showTabIndicator = true,
    leftElement,
    rightElement,
    fullWidth = false,
    paddingYTab,
    defaultIndex,
    badgeColorScheme,
    overrideIndex
  } = _a2, otherProps = __objRest(_a2, [
    "tabsProps",
    "showTabIndicator",
    "leftElement",
    "rightElement",
    "fullWidth",
    "paddingYTab",
    "defaultIndex",
    "badgeColorScheme",
    "overrideIndex"
  ]);
  const [selected, setSelected] = (0, import_react78.useState)(defaultIndex != null ? defaultIndex : 0);
  const isMobile = (0, import_react77.useBreakpointValue)({
    base: true,
    sm: true,
    md: false,
    lg: false,
    xl: false
  });
  const handleTabsChange = (index, shouldExecuteCallback = true) => {
    setSelected(index);
    if (shouldExecuteCallback) {
      const tab = tabsProps.find((tab2) => tab2.id === index);
      (tab == null ? void 0 : tab.onClick) && (tab == null ? void 0 : tab.onClick());
    }
  };
  (0, import_react78.useEffect)(() => {
    if (overrideIndex !== void 0 && selected !== overrideIndex) {
      handleTabsChange(overrideIndex, false);
    }
  }, [overrideIndex]);
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)(
    import_react77.Tabs,
    {
      w: "min-content",
      variant: "unstyled",
      index: selected,
      onChange: (index) => handleTabsChange(index),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)(
          import_react77.TabList,
          __spreadProps(__spreadValues({
            minW: fullWidth ? "100vw" : "min-content",
            gap: 8
          }, otherProps), {
            borderBottom: "1px solid",
            borderBottomColor: "border-color-secondary",
            children: [
              leftElement != null ? leftElement : null,
              tabsProps.map((tab) => {
                const showTab = showTabHandler(
                  isMobile,
                  tab.hiddenInMobile,
                  tab.hiddenInDesktop
                );
                return showTab && /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
                  import_react77.Flex,
                  {
                    w: { base: "100%", sm: "min-content" },
                    direction: {
                      base: "column",
                      sm: "row"
                    },
                    _focusVisible: {
                      outline: "none",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "1.5px solid",
                      borderColor: "border-color-focus",
                      borderRadius: "4px"
                    },
                    tabIndex: showTab || !tab.isDisabled ? tab.id : -1,
                    "data-index": showTab || !tab.isDisabled ? tab.id : -1,
                    paddingBottom: paddingYTab ? 0 : { base: 1, sm: 3 },
                    paddingY: paddingYTab,
                    children: /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)(
                      import_react77.Tab,
                      {
                        "data-testid": `tab-${tab.id}`,
                        id: tab.id.toString(),
                        isDisabled: tab.isDisabled,
                        disabled: tab.isDisabled,
                        paddingX: 0,
                        _selected: {
                          backgroundColor: "transparent",
                          _disabled: {
                            textColor: "content-disabled",
                            borderColor: "border-color-disabled",
                            color: "content-disabled",
                            opacity: 0.4,
                            cursor: "not-allowed"
                          }
                        },
                        "aria-label": tab.label,
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
                            import_react77.Text,
                            {
                              size: "sm",
                              whiteSpace: "nowrap",
                              variant: selected === tab.id ? "medium" : "regular",
                              color: selected === tab.id ? "content-primary" : tab.isDisabled ? "content-disabled" : "content-secondary",
                              children: tab.label
                            }
                          ),
                          (tab == null ? void 0 : tab.showBadge) && /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
                            Badge,
                            {
                              ml: "2",
                              size: "sm",
                              colorScheme: badgeColorScheme,
                              type: "default",
                              children: tab == null ? void 0 : tab.badgeText
                            }
                          )
                        ]
                      },
                      tab.id
                    )
                  },
                  tab.id
                );
              }),
              rightElement != null ? rightElement : null
            ]
          })
        ),
        showTabIndicator && /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(import_react77.TabIndicator, {})
      ]
    }
  );
};

// src/components/Navigation/NavigationInDesktop.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
var NavigationInDesktop = (props) => {
  const {
    homePath,
    showLogo,
    mainButton,
    links,
    rightElement,
    defaultIndex,
    overrideIndex,
    badgeColorScheme
  } = props;
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  const leftElement = /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
    import_react79.Link,
    {
      tabIndex: 0,
      href: homePath,
      display: showLogo ? "block" : "none",
      _focus: {
        outline: "none"
      },
      children: mainButton
    },
    0
  );
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
    Tabs2,
    __spreadProps(__spreadValues({
      leftElement: leftElement != null ? leftElement : null,
      tabsProps: links != null ? links : [],
      rightElement: rightElement != null ? rightElement : null,
      fullWidth: true,
      paddingYTab: isMobile ? 1 : 4
    }, { paddingX: 8, height: "4rem", alignItems: "center" }), {
      defaultIndex,
      overrideIndex,
      badgeColorScheme
    })
  );
};
var NavigationInDesktop_default = NavigationInDesktop;

// src/components/Navigation/NavigationInMobile.tsx
var import_react80 = require("@chakra-ui/react");
var import_react81 = require("react");
var import_fi12 = require("react-icons/fi");
var import_jsx_runtime74 = require("react/jsx-runtime");
var NavigationMobile = (props) => {
  const {
    onClickLogout,
    logoutLabel,
    links,
    homePath,
    showLogo,
    mainButton,
    rightElement
  } = props;
  const [isOpen, setIsOpen] = (0, import_react81.useState)(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const styles = {
    alignItems: "center",
    gap: 1,
    py: 3,
    px: 4,
    w: "100%",
    fontFamily: "Larsseit",
    _focus: {
      outline: "none",
      backgroundColor: "transparent",
      boxShadow: "none",
      borderRadius: "xs",
      _hover: {
        bg: "background-primary-pressed",
        borderRadius: "xs"
      }
    },
    _hover: {
      bg: "background-primary-hover",
      borderRadius: "xs"
    },
    _disabled: {
      textColor: "content-disabled",
      borderColor: "transparent",
      color: "content-disabled",
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _active: {
      outline: "none",
      backgroundColor: "transparent",
      boxShadow: "none",
      borderRadius: "xs"
    },
    _focusVisible: {
      outline: "none",
      backgroundColor: "background-primary-pressed",
      boxShadow: "none",
      borderRadius: "xs",
      border: "1.5px solid",
      borderColor: "border-color-focus"
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
    import_react80.Flex,
    {
      as: "nav",
      align: "center",
      justify: "space-between",
      position: "sticky",
      top: "0",
      left: "0",
      right: "0",
      zIndex: "1",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(import_react80.Flex, { bg: "background-primary-default", w: "100%", direction: "column", children: [
          /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(import_react80.Flex, { align: "center", justify: "space-between", px: 4, py: 3, children: [
            /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
              import_react80.Link,
              {
                href: homePath,
                display: showLogo ? "block" : "none",
                tabIndex: 0,
                children: mainButton
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
              import_react80.IconButton,
              {
                "data-testid": "menu-mobile-button",
                tabIndex: 1,
                onClick: toggleMenu,
                _hover: { cursor: "pointer" },
                "aria-label": isOpen ? "Open menu" : "Close Menu",
                icon: isOpen ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_fi12.FiX, { size: "1.25rem" }) : /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_fi12.FiMenu, { size: "1.25rem" }),
                variant: "iconTertiary",
                size: "md"
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_react80.Box, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Divider3, {}) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
          import_react80.Flex,
          {
            position: "fixed",
            top: "4rem",
            left: isOpen ? "0" : "-100%",
            w: "100%",
            transition: "left 0.6s ease",
            px: 4,
            h: isOpen ? "calc(100vh - 4rem)" : "auto",
            overflowY: "auto",
            direction: "column",
            bg: "white",
            children: [
              links.map((link) => /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(import_react80.Flex, { direction: "column", children: [
                /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
                  import_react80.Link,
                  __spreadProps(__spreadValues({}, styles), {
                    w: "100%",
                    tabIndex: link.id,
                    onClick: () => {
                      toggleMenu();
                      link.onClick && link.onClick();
                    },
                    "data-testid": `link-${link.label}`,
                    children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
                      import_react80.Text,
                      {
                        size: "md",
                        variant: "regular",
                        color: "content-secondary",
                        "aria-label": link.label,
                        children: link.label
                      }
                    )
                  }),
                  link.id
                ),
                (link == null ? void 0 : link.hasDividerAfter) && /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
                  import_react80.Box,
                  {
                    width: "100%",
                    display: (link == null ? void 0 : link.hasDividerAfter) ? "block" : "none",
                    children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Divider3, {})
                  }
                )
              ] }, link.id)),
              /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_react80.Box, { children: rightElement != null ? rightElement : null }),
              /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
                import_react80.Link,
                __spreadProps(__spreadValues({}, styles), {
                  onClick: () => {
                    toggleMenu();
                    onClickLogout && onClickLogout();
                  },
                  display: "flex",
                  tabIndex: links.length + 1,
                  gap: 2,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_react80.Icon, { as: import_fi12.FiLogOut, color: "content-primary" }),
                    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_react80.Text, { color: "content-secondary", size: "md", variant: "regular", children: logoutLabel })
                  ]
                })
              )
            ]
          }
        )
      ]
    }
  );
};
var NavigationInMobile_default = NavigationMobile;

// src/components/Navigation/index.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");
var Navigation = (props) => {
  let { links, rightElement } = props;
  const {
    showLogo = true,
    homePath,
    logoutLabel,
    onClickLogout,
    mainButton,
    defaultIndex,
    overrideIndex,
    badgeColorScheme
  } = props;
  const isMobile = (0, import_react82.useBreakpointValue)({
    base: true,
    sm: true,
    md: false,
    lg: false,
    xl: false
  });
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("nav", { children: isMobile ? /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
    NavigationInMobile_default,
    {
      links,
      homePath,
      showLogo,
      mainButton,
      rightElement,
      logoutLabel,
      onClickLogout,
      overrideIndex
    }
  ) : /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
    NavigationInDesktop_default,
    {
      links,
      homePath,
      showLogo,
      mainButton,
      rightElement,
      defaultIndex,
      badgeColorScheme,
      overrideIndex
    }
  ) });
};
var Navigation_default = Navigation;

// src/components/SelectField/index.tsx
var import_react84 = require("@chakra-ui/react");
var import_react85 = require("react");
var import_react_hook_form6 = require("react-hook-form");
var import_fi13 = require("react-icons/fi");
var import_async = __toESM(require("react-select/async"));
var import_react_select = require("react-select");

// src/components/SelectField/styles/index.ts
var COLOR = {
  disabled: "content-disabled",
  default: "content-secondary"
};
var BACKGROUND_COLOR = {
  disabled: "background-disabled",
  default: "background-primary-default"
};
var BORDER_COLOR = {
  focus: "border-color-focus",
  default: "border-color-secondary",
  destructive: "border-color-destructive"
};
var singleSelectStyle = (isInvalid) => {
  return {
    control: (provided, { isFocused, isDisabled }) => __spreadProps(__spreadValues({}, provided), {
      border: "1px solid",
      borderRadius: "8px",
      fontFamily: "Larsseit",
      fontSize: "1rem",
      fontWeight: "400",
      fontStyle: "normal",
      lineHeight: "1.5rem",
      boxShadow: "none",
      color: colorTokens[isDisabled ? COLOR.disabled : "content-tertiary"],
      backgroundColor: colorTokens[isDisabled ? BACKGROUND_COLOR.disabled : BACKGROUND_COLOR.default],
      "border-color": colorTokens[isInvalid ? BORDER_COLOR.destructive : isFocused ? BORDER_COLOR.focus : BORDER_COLOR.default],
      "border-width": isFocused ? "1.5px" : "1px",
      "&:hover": {
        borderColor: "none"
      },
      "&:active": {
        borderColor: colorTokens[BORDER_COLOR.focus],
        border: "1.5px solid"
      }
    }),
    placeholder: (provided, { isDisabled }) => __spreadProps(__spreadValues({}, provided), {
      color: isDisabled ? colorTokens[COLOR.disabled] : colorTokens["content-tertiary"],
      fontFamily: "Larsseit",
      fontSize: "1rem",
      fontWeight: "400",
      fontStyle: "normal",
      lineHeight: "1.5rem",
      backgroundColor: isDisabled ? colorTokens[BACKGROUND_COLOR.disabled] : colorTokens[BACKGROUND_COLOR.default]
    }),
    input: (provided, { isDisabled }) => __spreadProps(__spreadValues({}, provided), {
      fontSize: "1rem",
      fontWeight: "400",
      fontStyle: "normal",
      border: "none",
      color: isDisabled ? colorTokens[COLOR.disabled] : colorTokens[COLOR.default],
      backgroundColor: isDisabled ? colorTokens[BACKGROUND_COLOR.disabled] : "transparent"
    }),
    singleValue: (provided) => __spreadProps(__spreadValues({}, provided), {
      color: colorTokens[COLOR.default]
    }),
    option: (provided, { isSelected, isFocused, isDisabled }) => __spreadProps(__spreadValues({}, provided), {
      fontSize: "1rem",
      fontWeight: "400",
      fontStyle: "normal",
      borderRadius: "8px",
      color: isFocused ? colorTokens[COLOR.default] : isDisabled ? colorTokens[COLOR.disabled] : colorTokens[COLOR.default],
      "border-color": isFocused ? colorTokens[BORDER_COLOR.focus] : colorTokens[BORDER_COLOR.default],
      backgroundColor: colorTokens[isSelected ? "background-primary-pressed" : isDisabled ? BACKGROUND_COLOR.disabled : isFocused ? "background-primary-hover" : BACKGROUND_COLOR.default],
      "&:hover": {
        color: colorTokens[COLOR.default],
        backgroundColor: colorTokens["background-primary-hover"]
      },
      "&:active": {
        color: colorTokens[COLOR.default]
      }
    })
  };
};

// src/components/SelectField/index.tsx
var import_lodash5 = __toESM(require("lodash.get"));

// src/hooks/useDebounce.tsx
var import_react83 = require("react");
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = (0, import_react83.useState)(value);
  (0, import_react83.useEffect)(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

// src/components/SelectField/utils.ts
var mergeUniqueByValue = (array1, array2) => {
  const map = /* @__PURE__ */ new Map();
  [...array1, ...array2].forEach((item) => {
    map.set(item.value, item);
  });
  return Array.from(map.values());
};

// src/components/SelectField/index.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
var SelectField = (_a2) => {
  var _b2 = _a2, {
    label,
    placeholder,
    options = [],
    isLoading,
    isMulti = false,
    noOptionMessage,
    noOptionButtonLabel,
    noOptionAction,
    showHelperTextIcon,
    helperText,
    name,
    leftIcon,
    rhfOptions,
    getOptions: getOptionsFromProps,
    debounce = 0,
    errorMessageFormatter = (s) => s,
    isReadOnly = false,
    readOnlyValue = "",
    cacheOptions
  } = _b2, otherProps = __objRest(_b2, [
    "label",
    "placeholder",
    "options",
    "isLoading",
    "isMulti",
    "noOptionMessage",
    "noOptionButtonLabel",
    "noOptionAction",
    "showHelperTextIcon",
    "helperText",
    "name",
    "leftIcon",
    "rhfOptions",
    "getOptions",
    "debounce",
    "errorMessageFormatter",
    "isReadOnly",
    "readOnlyValue",
    "cacheOptions"
  ]);
  const formMethods = (0, import_react_hook_form6.useFormContext)();
  if (!formMethods) {
    throw new Error(
      `SelectField component Must be used within react-hook-form "FormProvider"`
    );
  }
  const {
    setValue,
    formState: { errors, dirtyFields, isSubmitted },
    register,
    watch,
    trigger
  } = formMethods;
  const isDirtyField = Boolean(dirtyFields[name]);
  register(name, rhfOptions);
  const [selectedOptionsFromGetOptions, setSelectedOptionsFromGetOptions] = (0, import_react85.useState)([]);
  const selectedOptions = watch(name);
  const setSelectedOptions = (optionValue) => {
    const isArrayOfOptions = Array.isArray(optionValue);
    let formattedValue;
    if (isArrayOfOptions) {
      formattedValue = optionValue.map((option) => {
        options.push(option);
        return option.value;
      });
    } else
      [formattedValue = optionValue == null ? void 0 : optionValue.value];
    setValue(name, formattedValue, {
      shouldDirty: true,
      shouldValidate: isDirtyField && isSubmitted
    });
  };
  const fieldError = (0, import_lodash5.default)(errors, name, null);
  const errorMessage = errorMessageFormatter(
    (fieldError == null ? void 0 : fieldError.message) || ""
  );
  const isInvalid = Boolean(fieldError);
  const isDisabled = Boolean(rhfOptions == null ? void 0 : rhfOptions.disabled);
  const isRequired = Boolean(rhfOptions == null ? void 0 : rhfOptions.required);
  const isValid = !isInvalid;
  const showHelperText = isValid && helperText;
  const colorIcon = colorTokens[isDisabled ? "content-disabled" : "content-tertiary"];
  const styles = singleSelectStyle(isInvalid);
  const [searchValue, setSearchValue] = (0, import_react85.useState)("");
  const debouncedSearch = useDebounce(searchValue, debounce);
  const loadOptionCallbackRef = (0, import_react85.useRef)(null);
  const selectValue = watch(name);
  (0, import_react85.useEffect)(() => {
    if (selectValue) {
      trigger(name);
    }
  }, [selectValue]);
  (0, import_react85.useEffect)(() => {
    const defaultGetOptions = (inputValue) => __async(void 0, null, function* () {
      return options.filter(
        (i) => i.label.toLowerCase().includes(inputValue.toLowerCase())
      );
    });
    const getOptions = getOptionsFromProps ? getOptionsFromProps : defaultGetOptions;
    if (loadOptionCallbackRef.current) {
      getOptions(debouncedSearch).then((options2) => {
        setSelectedOptionsFromGetOptions(
          mergeUniqueByValue(selectedOptionsFromGetOptions, options2)
        );
        return options2;
      }).then(loadOptionCallbackRef.current).catch(
        () => loadOptionCallbackRef.current && loadOptionCallbackRef.current([])
      );
    }
  }, [debouncedSearch]);
  const Control = (0, import_react85.useCallback)(
    (_a3) => {
      var _b3 = _a3, { children } = _b3, props = __objRest(_b3, ["children"]);
      return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(import_react_select.components.Control, __spreadProps(__spreadValues({}, props), { children: [
        /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
          import_react84.Flex,
          {
            alignItems: "center",
            paddingLeft: leftIcon ? 3 : 0,
            color: props.isDisabled ? "content-disabled" : "content-secondary",
            children: leftIcon ? /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
              import_react84.Icon,
              {
                color: colorIcon,
                boxSize: "20px",
                stroke: colorIcon,
                as: leftIcon
              }
            ) : null
          }
        ),
        children
      ] }));
    },
    [colorIcon]
  );
  const ClearIndicator = (0, import_react85.useCallback)(
    (props) => {
      return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(import_react_select.components.ClearIndicator, __spreadProps(__spreadValues({}, props), { children: [
        props.children,
        /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Box, { padding: 0, children: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
          import_react84.Flex,
          {
            color: "content-tertiary",
            direction: "column",
            alignItems: "center",
            _hover: { cursor: "pointer" },
            children: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
              import_react84.Icon,
              {
                color: colorIcon,
                boxSize: "20px",
                stroke: colorIcon,
                as: import_fi13.FiX
              }
            )
          }
        ) })
      ] }));
    },
    [colorIcon]
  );
  const DropdownIndicator = (0, import_react85.useCallback)(
    (props) => {
      return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
        import_react84.Box,
        __spreadProps(__spreadValues({
          color: "content-tertiary",
          paddingRight: "12px",
          paddingLeft: "8px"
        }, props), {
          children: props.selectProps.menuIsOpen ? /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(ChevronUp, { size: "md", color: colorIcon }) : /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(ChevronDown, { size: "md", color: colorIcon })
        })
      );
    },
    [colorIcon]
  );
  const NoOptionsMessage = (0, import_react85.useCallback)(
    (props) => /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react_select.components.NoOptionsMessage, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
      import_react84.Flex,
      {
        direction: "column",
        alignItems: "start",
        justifyContent: "start",
        gap: 2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
            import_react84.Text,
            {
              size: "md",
              variant: "regular",
              color: "content-tertiary",
              textAlign: "left",
              fontSize: "14px",
              lineHeight: "1rem",
              children: noOptionMessage
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Box, { display: noOptionAction ? "block" : "none", width: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(Divider_default, {}) }),
          /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
            import_react84.Button,
            {
              display: noOptionAction ? "flex" : "none",
              variant: "linkPrimary",
              color: "link-primary-default",
              leftIcon: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_fi13.FiPlus, {}),
              onClick: noOptionAction,
              size: "sm",
              paddingY: 3,
              children: noOptionButtonLabel
            }
          )
        ]
      }
    ) })),
    [noOptionMessage, noOptionAction]
  );
  const mapReactSelectStateToLocalComponentState = (value, callback) => {
    setSearchValue(value);
    loadOptionCallbackRef.current = callback;
  };
  if (isReadOnly)
    return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(ReadOnlyField, { label, value: readOnlyValue });
  const selectedOptionsToRender = mergeUniqueByValue(
    options,
    selectedOptionsFromGetOptions
  ).filter((option) => {
    if (isMulti) {
      return (selectedOptions || []).includes(option.value);
    }
    return option.value === selectedOptions;
  });
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.FormControl, { isInvalid, isRequired, children: /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(import_react84.Flex, { direction: "column", children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      import_async.default,
      __spreadProps(__spreadValues({
        id: name,
        loadingMessage: () => /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Spinner, { variant: "primary" }),
        placeholder,
        options,
        isDisabled,
        isLoading,
        isMulti,
        styles,
        "aria-labelledby": name,
        loadOptions: mapReactSelectStateToLocalComponentState,
        cacheOptions,
        defaultOptions: getOptionsFromProps ? [] : options
      }, otherProps), {
        value: selectedOptionsToRender,
        onChange: setSelectedOptions,
        noOptionsMessage: searchValue ? () => noOptionMessage : () => null,
        onMenuClose: () => setSearchValue(""),
        components: {
          Control,
          Option,
          ClearIndicator,
          DropdownIndicator: (options == null ? void 0 : options.length) > 0 ? DropdownIndicator : null,
          LoadingIndicator: () => null,
          NoOptionsMessage,
          IndicatorSeparator: () => null
        }
      })
    ),
    showHelperText ? /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(import_react84.Flex, { mt: 1.5, gap: 1, color: "content-secondary", children: [
      showHelperTextIcon ? /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Flex, { alignItems: "top", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Icon, { as: import_fi13.FiAlertCircle }) }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.FormHelperText, { color: "content-secondary", mt: 0, children: helperText })
    ] }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(FormErrorMessage, { children: errorMessage })
  ] }) });
};
var Option = (props) => {
  var _a2, _b2;
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(import_react_select.components.Option, __spreadProps(__spreadValues({}, props), { children: [
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(import_react84.Text, { color: "content-secondary", children: props.data.label }),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      import_react84.Text,
      {
        display: ((_a2 = props.data) == null ? void 0 : _a2.supportingText) ? "block" : "none",
        color: "content-tertiary",
        children: (_b2 = props.data) == null ? void 0 : _b2.supportingText
      }
    )
  ] }));
};

// src/components/DropzoneField/DropzoneReadonly.tsx
var import_react86 = require("@chakra-ui/react");
var import_fi14 = require("react-icons/fi");
var import_jsx_runtime77 = require("react/jsx-runtime");
var DropzoneReadonly = (props) => {
  const {
    label,
    onDelete,
    hasError = false,
    leftIcon,
    fileName,
    rejectionMessage,
    onClick,
    isLoading = false
  } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(import_react86.Box, { children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(import_react86.FormLabel, { children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(
      import_react86.Flex,
      {
        border: "1px",
        borderStyle: hasError ? "solid" : "dashed",
        borderColor: hasError ? "content-destructive" : "border-color-primary",
        borderRadius: "base",
        alignItems: "center",
        padding: 4,
        justify: "space-between",
        _hover: { cursor: "pointer" },
        maxW: "Calc(100vw - 32px)",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
            import_react86.Button,
            {
              variant: "link",
              fontSize: "sm",
              color: hasError ? "content-destructive" : "link-secondary-default",
              isTruncated: true,
              padding: 1,
              leftIcon: leftIcon ? /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
                FeaturedIcons,
                {
                  size: "md",
                  variant: hasError ? "destructive" : "primary",
                  shape: "circle",
                  icon: leftIcon
                }
              ) : void 0,
              onClick,
              isLoading,
              whiteSpace: "normal",
              height: "auto",
              blockSize: "auto",
              children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(import_react86.Text, { isTruncated: true, children: fileName })
            }
          ),
          Boolean(onDelete) && /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(import_fi14.FiTrash2, { onClick: onDelete })
        ]
      }
    ),
    hasError ? /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(import_react86.Flex, { gap: "1", align: "center", color: "content-destructive", mt: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(AlertIcon, {}),
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(import_react86.Text, { color: "content-destructive", mt: "0", children: rejectionMessage })
    ] }) : null
  ] });
};
var DropzoneReadonly_default = DropzoneReadonly;

// src/components/DatePicker/DatePickerField.tsx
var import_react_hook_form7 = require("react-hook-form");
var import_react_datepicker3 = __toESM(require("react-datepicker"));
var import_react_datepicker4 = require("react-datepicker/dist/react-datepicker.css");
var import_react87 = require("@chakra-ui/react");
var import_fi15 = require("react-icons/fi");
var import_jsx_runtime78 = require("react/jsx-runtime");
var mapDateToTimestamp = (date) => Math.floor(Number(date) / 1e3);
var backToTheFuture = (date) => new Date(Number(date) * 1e3);
var DatePickerField = ({
  name,
  label,
  dateFormat = "dd/MM/yyyy",
  placeholder,
  helperText,
  rhfOptions,
  errorMessageFormatter = (message) => message
}) => {
  const { control, formState } = (0, import_react_hook_form7.useFormContext)();
  const { errors } = formState;
  const fieldError = (0, import_react_hook_form7.get)(errors, name, null);
  const errorMessage = errorMessageFormatter(
    (0, import_react_hook_form7.get)(fieldError, "message", "")
  );
  const isInvalid = Boolean(fieldError);
  const isValid = !isInvalid;
  const { disabled, required } = rhfOptions != null ? rhfOptions : {};
  const showHelperText = isValid && helperText;
  const isRequired = Boolean(required);
  const isMobile = window.innerWidth < BREAKPOINTS.sm;
  const CustomInput = (0, import_react87.forwardRef)((props, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_react87.InputGroup, { position: "relative", zIndex: "0", children: [
      /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.InputLeftElement, { children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_fi15.FiCalendar, { size: 20, color: "var(--chakra-colors-gray-500)" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
        import_react87.Input,
        __spreadProps(__spreadValues({
          size: isMobile ? SIZES.lg : SIZES.md,
          borderRadius: "md",
          name
        }, props), {
          ref
        })
      )
    ] });
  });
  const { field } = (0, import_react_hook_form7.useController)({
    name,
    control,
    rules: rhfOptions
  });
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.FormControl, { isInvalid, isRequired, children: /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_react87.Flex, { width: "100%", sx: datepicker_styles_default, direction: "column", children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      import_react_datepicker3.default,
      {
        selected: field.value ? backToTheFuture(field.value) : null,
        onChange: (date) => {
          field.onChange(date ? mapDateToTimestamp(date) : null);
        },
        dateFormat,
        customInput: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(CustomInput, {}),
        placeholderText: placeholder,
        strictParsing: true,
        disabled
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_react87.Flex, { columnGap: 1, mt: "1.5", alignItems: "top", children: [
      showHelperText && !errorMessage && /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_react87.Flex, { columnGap: "1", color: "gray.600", children: [
        /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.Flex, { alignItems: "top", minWidth: 4, children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(AlertIcon, { color: "#475467" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.FormHelperText, { color: "gray.600", mt: 0, children: helperText })
      ] }),
      errorMessage ? /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_react87.Flex, { gap: 1, children: [
        /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(AlertIcon, { color: "#F25037" }),
        /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(import_react87.FormErrorMessage, { mt: "0", children: errorMessage })
      ] }) : null
    ] })
  ] }) });
};

// src/components/ErrorPage.tsx
var import_react88 = require("@chakra-ui/react");
var import_fi16 = require("react-icons/fi");

// src/components/svg/FileSearch.tsx
var import_jsx_runtime79 = require("react/jsx-runtime");
var FileSearch = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
    "svg",
    {
      width: "500",
      height: "500",
      viewBox: "0 0 500 500",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("circle", { cx: "250.152", cy: "250", r: "133.69", fill: "#E4E7EC" }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter0_i_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M177.969 348.35H321.448C328.486 348.35 334.192 342.644 334.192 335.606V185.126L281.758 132.874H177.969C170.93 132.874 165.225 138.579 165.225 145.617V335.606C165.225 342.644 170.93 348.35 177.969 348.35Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M177.969 348.35H321.448C328.486 348.35 334.192 342.644 334.192 335.606V185.126L281.758 132.874H177.969C170.93 132.874 165.225 138.579 165.225 145.617V335.606C165.225 342.644 170.93 348.35 177.969 348.35Z",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M189.028 187.636H254.018",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M189.028 222.604H284.986",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M189.028 205.12H300.126",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M189.028 240.087H268.305",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M189.028 324.75H268.305",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter1_i_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M281.903 132.874L334.192 185.188H293.23C286.974 185.188 281.903 180.116 281.903 173.86V132.874Z",
            fill: "#101828"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M281.903 132.874L334.192 185.188H293.23C286.974 185.188 281.903 180.116 281.903 173.86V132.874Z",
            stroke: "black",
            strokeWidth: "1.41599",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter2_ii_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M303.394 307.659L343.063 347.329C346.554 350.82 346.554 356.479 343.063 359.969V359.969C339.573 363.46 333.914 363.46 330.423 359.969L290.754 320.299L303.394 307.659Z",
            fill: "var(--chakra-colors-brand-100)"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M303.394 308.661L342.563 347.83C345.777 351.044 345.777 356.255 342.563 359.469C339.349 362.683 334.138 362.683 330.924 359.469L291.755 320.299L303.394 308.661Z",
            stroke: "#101828",
            strokeWidth: "1.41599"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter3_i_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M305.506 305.547L320.368 320.409C321.474 321.515 321.474 323.308 320.368 324.414L307.508 337.273C306.402 338.379 304.609 338.379 303.503 337.273L288.642 322.411L305.506 305.547Z",
            fill: "#0C121F"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M305.506 306.548L319.867 320.91C320.696 321.739 320.696 323.084 319.867 323.913L307.008 336.773C306.178 337.602 304.834 337.602 304.004 336.773L289.643 322.411L305.506 306.548Z",
            stroke: "#101828",
            strokeWidth: "1.41599"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter4_ii_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "circle",
          {
            cx: "268.395",
            cy: "285.301",
            r: "53.9749",
            fill: "var(--chakra-colors-brand-100)"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "circle",
          {
            cx: "268.395",
            cy: "285.301",
            r: "53.2669",
            stroke: "#101828",
            strokeWidth: "1.41599"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("g", { filter: "url(#filter5_i_15256_308710)", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "ellipse",
          {
            cx: "268.395",
            cy: "285.3",
            rx: "41.9522",
            ry: "41.9522",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M309.639 285.3C309.639 308.078 291.174 326.544 268.395 326.544C245.616 326.544 227.151 308.078 227.151 285.3C227.151 262.521 245.616 244.056 268.395 244.056C291.174 244.056 309.639 262.521 309.639 285.3Z",
            stroke: "black",
            strokeWidth: "1.41599"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
          "path",
          {
            d: "M297.778 285.302C297.778 269.074 284.623 255.919 268.395 255.919",
            stroke: "#101827",
            strokeWidth: "1.41599",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)("defs", { children: [
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter0_i_15256_308710",
              x: "164.517",
              y: "132.166",
              width: "170.383",
              height: "216.892",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "3.53999" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0470588 0 0 0 0 0.0705882 0 0 0 0 0.117647 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter1_i_15256_308710",
              x: "281.195",
              y: "132.166",
              width: "53.7057",
              height: "53.7306",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "3.53999", dy: "-0.707997" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter2_ii_15256_308710",
              x: "290.754",
              y: "307.659",
              width: "54.9276",
              height: "54.9276",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "-3.53999", dy: "1.41599" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "1.41599", dy: "-2.12399" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "effect1_innerShadow_15256_308710",
                    result: "effect2_innerShadow_15256_308710"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter3_i_15256_308710",
              x: "288.642",
              y: "305.547",
              width: "32.5554",
              height: "32.5554",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "-1.41599", dy: "2.83199" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter4_ii_15256_308710",
              x: "214.42",
              y: "231.326",
              width: "107.95",
              height: "107.95",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "-2.83199", dy: "2.12399" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "2.12399", dy: "-2.12399" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "effect1_innerShadow_15256_308710",
                    result: "effect2_innerShadow_15256_308710"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)(
            "filter",
            {
              id: "filter5_i_15256_308710",
              x: "226.443",
              y: "243.348",
              width: "83.9044",
              height: "83.9044",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feOffset", { dx: "-2.83199", dy: "1.41599" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 1 0"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_15256_308710"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
};

// src/components/ErrorPage.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");
var ErrorPage = (props) => {
  const {
    error,
    mainErrorMessage,
    errorDescription,
    secondaryButtonLabel,
    secondaryButtonVariant = "secondary",
    primaryButtonLabel,
    primaryButtonVariant = "primary",
    onClickSecondaryButton,
    onClickPrimaryButton,
    leftImage = /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(FileSearch, {}),
    showLeftIconInSecondaryButton = true
  } = props;
  const isMobile = (0, import_react88.useBreakpointValue)(
    {
      base: true,
      sm: true,
      md: false,
      lg: false,
      xl: false
    },
    "md"
  );
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(
    import_react88.Flex,
    {
      marginX: "auto",
      gap: { base: 0, sm: 20 },
      justifyContent: { base: "", sm: "space-around" },
      paddingY: { base: 0, sm: 1 },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_react88.Box, { display: { base: "none", sm: "initial" }, children: leftImage }),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(
          import_react88.Flex,
          {
            direction: { base: "column", sm: "column" },
            alignItems: { base: "", sm: "start" },
            justifyContent: { base: "", sm: "center" },
            maxW: "max-content",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_react88.Flex, { gap: 3, direction: { base: "column", sm: "column" }, children: [
                /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_react88.Text, { color: "content-destructive", variant: "medium", size: "md", children: [
                  "Error ",
                  error
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_react88.Box, { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
                    import_react88.Heading,
                    {
                      size: isMobile ? "sm" : "md",
                      variant: "medium",
                      color: "content-primary",
                      lineHeight: "2.875rem",
                      children: mainErrorMessage
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
                    import_react88.Text,
                    {
                      size: isMobile ? "lg" : "xl",
                      variant: "regular",
                      color: "content-secondary",
                      marginBottom: { base: "2rem", sm: "3rem" },
                      marginTop: { base: "1rem", sm: 3 },
                      children: errorDescription
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_react88.Flex, { gap: 3, direction: { base: "column-reverse", sm: "row" }, children: [
                /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
                  import_react88.Button,
                  {
                    leftIcon: showLeftIconInSecondaryButton ? /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_fi16.FiArrowLeft, {}) : void 0,
                    variant: secondaryButtonVariant,
                    display: secondaryButtonLabel ? "inherit" : "none",
                    onClick: onClickSecondaryButton,
                    size: "lg",
                    children: secondaryButtonLabel
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
                  import_react88.Button,
                  {
                    variant: primaryButtonVariant,
                    display: primaryButtonLabel ? "inherit" : "none",
                    onClick: onClickPrimaryButton,
                    size: "lg",
                    children: primaryButtonLabel
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
};
var ErrorPage_default = ErrorPage;

// src/components/ReadOnlyTextarea.tsx
var import_react89 = require("@chakra-ui/react");
var import_jsx_runtime81 = require("react/jsx-runtime");
var ReadOnlyTextarea = ({ value, label, rows }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)(import_react89.FormControl, { children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(import_react89.FormLabel, { children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
      import_react89.Textarea,
      {
        readOnly: true,
        value,
        isDisabled: true,
        rows,
        _disabled: {
          cursor: "text !important",
          color: "content-tertiary",
          backgroundColor: "background-disabled"
        }
      }
    )
  ] });
};

// src/index.tsx
var import_react91 = require("@chakra-ui/react");

// src/components/NumericFormatField.tsx
var import_react90 = require("@chakra-ui/react");
var import_lodash6 = __toESM(require("lodash.get"));
var import_react_hook_form8 = require("react-hook-form");
var import_react_number_format2 = require("react-number-format");

// src/components/NumericReadOnlyField.tsx
var import_react_number_format = require("react-number-format");
var import_jsx_runtime82 = require("react/jsx-runtime");
var NumericReadOnlyField = ({
  value,
  label,
  helperText,
  thousandSeparator = ".",
  decimalSeparator = ",",
  decimalScale,
  fixedDecimalScale
}) => {
  const numericValue = (0, import_react_number_format.numericFormatter)(value, {
    thousandSeparator,
    decimalSeparator,
    decimalScale,
    fixedDecimalScale
  });
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(ReadOnlyField, { value: numericValue, label, helperText });
};

// src/components/NumericFormatField.tsx
var import_jsx_runtime83 = require("react/jsx-runtime");
var NumericFormatField = ({
  name,
  label,
  placeholder,
  helperText,
  rhfOptions = {},
  leftElement,
  rightElement,
  size = "md",
  errorMessageFormatter = (message) => message,
  thousandSeparator = ".",
  decimalSeparator = ",",
  decimalScale,
  isFixedDecimalScale = false,
  isReadOnly = false,
  readOnlyValue = ""
}) => {
  const formMethods = (0, import_react_hook_form8.useFormContext)();
  if (!formMethods) {
    throw new Error(
      `NumericFormatField component Must be used within react-hook-form "FormProvider"`
    );
  }
  const { control } = formMethods;
  const { errors } = (0, import_react_hook_form8.useFormState)();
  const fieldError = (0, import_lodash6.default)(errors, name, null);
  const errorMessage = errorMessageFormatter(
    (0, import_lodash6.default)(fieldError, "message", "")
  );
  const isInvalid = Boolean(fieldError);
  const isValid = !isInvalid;
  const showHelperText = isValid && helperText;
  const isRequired = Boolean(rhfOptions.required);
  if (isReadOnly)
    return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(NumericReadOnlyField, { label, value: readOnlyValue });
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)(import_react90.FormControl, { isInvalid, isRequired, children: [
    label ? /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(import_react90.FormLabel, { htmlFor: name, children: label }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)(import_react90.InputGroup, { size, children: [
      leftElement ? /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(import_react90.InputLeftElement, { pointerEvents: "none", children: leftElement }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        import_react_hook_form8.Controller,
        {
          render: ({ field }) => /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
            import_react_number_format2.NumericFormat,
            {
              id: name,
              customInput: import_react90.Input,
              thousandSeparator,
              decimalSeparator,
              decimalScale,
              fixedDecimalScale: isFixedDecimalScale,
              onValueChange: (v) => {
                field.onChange(v.value);
              },
              value: field.value,
              placeholder,
              size
            }
          ),
          name,
          control
        }
      ),
      rightElement ? /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(import_react90.InputRightElement, { pointerEvents: "none", children: rightElement }) : null
    ] }),
    showHelperText && /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(FormHelperText, { children: helperText }),
    /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(FormErrorMessage, { children: errorMessage })
  ] });
};

// src/index.tsx
var import_icons = require("@chakra-ui/icons");
var import_react92 = require("@chakra-ui/react");
var import_react_table = require("react-table");
var import_fi17 = require("react-icons/fi");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion,
  AccordionItem,
  Alert,
  AlertDialog,
  AlertIcon,
  AlertOctagonIcon,
  Avatar,
  BUTTON_VARIANTS,
  Badge,
  BankIcon,
  Box,
  Breadcrumb,
  BuildingIcon,
  Button,
  ButtonGroup,
  Card,
  CellProps,
  Center,
  ChakraModal,
  Checkbox,
  CheckboxGroup,
  ChevronDownIcon,
  CircularProgress,
  ClockUsedIcon,
  CloseButton,
  Code,
  CoinsIcon,
  CoinsStackIcon,
  ContainedText,
  Container,
  ContextPhoneInput,
  Controller,
  ControllerRenderProps,
  CornIcon,
  CornToken,
  CrossOutlineIcon,
  DateCalendar,
  DatePickerField,
  Divider,
  DollarSignIcon,
  Drawer,
  Dropdown,
  DropdownField,
  DropzoneField,
  DropzoneReadonly,
  Editable,
  EmailIcon,
  EmptyState,
  ErrorPage,
  FeaturedIcons,
  FiAlertCircle,
  FiAlertTriangle,
  FiCalendar,
  FiCheckCircle,
  FiDownload,
  FiEdit,
  FiExternalLink,
  FiEye,
  FiEyeOff,
  FiFigma,
  FiFile,
  FiFileMinus,
  FiFileText,
  FiLogIn,
  FiLogOut,
  FiMail,
  FiMinusCircle,
  FiPlus,
  FiPlusCircle,
  FiRefreshCcw,
  FiRefreshCw,
  FiRepeat,
  FiSave,
  FiSearch,
  FiSend,
  FiSlash,
  FiTool,
  FiTrash2,
  FiUserCheck,
  FiUserX,
  FiUsers,
  FiXOctagon,
  FieldArrayWithId,
  FieldError,
  FieldValues,
  FileAttachmentErrorIcon,
  FileAttachmentIcon,
  FileCheckIcon,
  FileUpload,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  FormProvider,
  FormState,
  Grid,
  GridItem,
  Heading,
  Highlight,
  HintIcon,
  Icon,
  IconButton,
  Image,
  Kbd,
  Link,
  LinkOverlay,
  List,
  ListIcon,
  ListItem,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  MenuOptionGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Navigation,
  NumberInput,
  NumericFormatField,
  NumericReadOnlyField,
  OrderedList,
  PendingClockIcon,
  PinInput,
  Popover,
  Portal,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  RangeSlider,
  ReadOnlyField,
  ReadOnlyTextarea,
  RightAlignCell,
  SIZES,
  SeedIcon,
  Select,
  SelectField,
  SimpleGrid,
  Skeleton,
  Slider,
  SoyIcon,
  SoyToken,
  SpeedometerIcon,
  Spinner,
  Stack,
  Stat,
  Stepper,
  Switch,
  SwitchIcon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableInstance,
  TableWrapper,
  Tabs,
  Tag,
  Text,
  TextField,
  TextareaField,
  ThemeProvider,
  Toast,
  Tooltip,
  TwoLinesCell,
  UnorderedList,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReturn,
  UseFormSetValue,
  VerificationCode,
  VisuallyHidden,
  WheatIcon,
  WheatToken,
  Wrap,
  getBase64FromFile,
  theme,
  useBreakpointValue,
  useDebounce,
  useDisclosure,
  useFieldArray,
  useForm,
  useFormContext,
  usePagination,
  useTable,
  useTheme,
  useToast
});
